import gnosis from "../assets/projects/gnosis.png";
import cowswap from "../assets/projects/cowswap.png";
import swarmMarket from "../assets/projects/swarmMarket.png";
import makerDAO from "../assets/projects/makerDAO.png";
import aragonDAO from "../assets/projects/aragonDAO.png";
import armanino from "../assets/projects/armanino.png";
import graph from "../assets/projects/graph.png";
import chainlink from "../assets/projects/chainlink.png";
import gnosisConditional from "../assets/projects/gnosisConditional.png";
import kyberDAO from "../assets/projects/kyberDAO.png";
// import opyn from "../assets/projects/opyn.png";
import filecoin from "../assets/projects/filecoin.png";
import oxLauch from "../assets/projects/oxLauch.png";
import airdropBotFlare from "../assets/projects/airdropBotFlare.png";
import aethir from "../assets/projects/aethir.png";
import balancerVe8020 from "../assets/projects/balancerVe8020.png";
import sagaAirdrop from "../assets/projects/sagaAirdrop.png";
// import solhint from "../assets/projects/solhint.png";
import chainlinkDevTools from "../assets/projects/chainlink-dev-tooling.png";
import singleButtonSolution from "../assets/projects/single-button-solution.png";
import monitoringForGiga from "../assets/projects/monitoring-for-giga.png";
import bnbToPolygon from "../assets/projects/BNB-to-Polygon-Bridging-for-Kryptomon.png";
import diaOracles from "../assets/projects/DIA-Oracles-on-Kadena.png";
import utxoAbstraction from "../assets/projects/utxoAbstraction.png";
import developerStudio from "../assets/projects/developerStudio.png";
import cardanoProjectsTile from "../assets/projects/cardanoProjectsTile.png";
import vanaBanner from "../assets/projects/vanaBanner.png";
import crossChainInteroperability from "../assets/projects/cross-chain-interoperability.png";
import contractExplorer from "../assets/projects/contract-explorer.png";
import developerStudioV2 from "../assets/projects/developer-studio-v2.png";
import mayzProtocol from "../assets/projects/mayz-protocol.png";
import smartContractsUnleashed from "../assets/projects/smart-contracts-unleashed.png";

import vanaBannerMore from "../assets/projectDetailsImages/vanaBannerMore.png";
import safeMultisigWallet0 from "../assets/projectDetailsImages/safeMultisigWallet0.png";
import safeMultisigWallet1 from "../assets/projectDetailsImages/safeMultisigWallet1.png";
import safeMultisigWallet2 from "../assets/projectDetailsImages/safeMultisigWallet2.png";
import safeMultisigWallet3 from "../assets/projectDetailsImages/safeMultisigWallet3.png";
import cowswapDex0 from "../assets/projectDetailsImages/cowswapDex0.png";
import cowswapDex1 from "../assets/projectDetailsImages/cowswapDex1.png";
import cowswapDex2 from "../assets/projectDetailsImages/cowswapDex2.png";
import graphSubgraphs0 from "../assets/projectDetailsImages/graphSubgraphs0.png";
import graphSubgraphs1 from "../assets/projectDetailsImages/graphSubgraphs1.png";
import graphSubgraphs2 from "../assets/projectDetailsImages/graphSubgraphs2.png";
import chainlinkIntegration0 from "../assets/projectDetailsImages/chainlinkIntegration0.png";
import chainlinkIntegration1 from "../assets/projectDetailsImages/chainlinkIntegration1.png";
import chainlinkIntegration2 from "../assets/projectDetailsImages/chainlinkIntegration2.png";
import chainlinkIntegration3 from "../assets/projectDetailsImages/chainlinkIntegration3.png";
import swarmDex0 from "../assets/projectDetailsImages/swarmDex0.png";
import swarmDex1 from "../assets/projectDetailsImages/swarmDex1.png";
import filecoin0 from "../assets/projectDetailsImages/filecoin0.png";
import filecoin1 from "../assets/projectDetailsImages/filecoin1.png";
import makerdaoDashboard0 from "../assets/projectDetailsImages/makerdaoDashboard0.png";
import makerdaoDashboard1 from "../assets/projectDetailsImages/makerdaoDashboard1.png";
import armanino0 from "../assets/projectDetailsImages/armanino0.png";
import armanino1 from "../assets/projectDetailsImages/armanino1.png";
import armanino2 from "../assets/projectDetailsImages/armanino2.png";
// import opyn0 from "../assets/projectDetailsImages/opyn0.png";
// import opyn1 from "../assets/projectDetailsImages/opyn1.png";
import aragon0 from "../assets/projectDetailsImages/aragon0.png";
import gnosisExplorer0 from "../assets/projectDetailsImages/gnosisExplorer0.png";
import kyberswap0 from "../assets/projectDetailsImages/kyberswap0.png";
import kyberswap1 from "../assets/projectDetailsImages/kyberswap1.png";
import kyberswap2 from "../assets/projectDetailsImages/kyberswap2.png";
import oxLunch0 from "../assets/projectDetailsImages/oxLunch0.png";
import oraclesDia1 from "../assets/projectDetailsImages/oracles_dia1.png";
import oraclesDia2 from "../assets/projectDetailsImages/oracles_dia2.png";
import kryptomon0 from "../assets/projectDetailsImages/kryptomon0.png";
import bigDataProtocol0 from "../assets/projectDetailsImages/bigDataProtocol0.png";
import bigDataProtocol1 from "../assets/projectDetailsImages/bigDataProtocol1.png";
import monitoringPlatformGiga0 from "../assets/projectDetailsImages/monitoringPlatformGiga0.png";
// import airdropBotFlare0 from "../assets/projectDetailsImages/airdropBotFlare0.png";
import balancerVe8020_1 from "../assets/projectDetailsImages/balancerVe8020_1.png";
import balancerVe8020_2 from "../assets/projectDetailsImages/balancerVe8020_2.png";
import aethir1 from "../assets/projectDetailsImages/aethir1.png";
import aethir2 from "../assets/projectDetailsImages/aethir2.png";
import sagaAirdrop1 from "../assets/projectDetailsImages/sagaAirdrop1.png";

import juanFaya from "../assets/team/juanFaya.png";
import federico from "../assets/team/federico.png";

export const tags = [
  "ALLTAGS",
  "DataBase",
  "DevTools",
  "Bot",
  "F13",
  "Airdrop",
  "Staking",
  "Module",
  "Launchpad",
  "AI",
  "App",
  "UX",
  "Token",
  "Chainlink",
  "Foundry",
  "Big Data Protocol",
  "Solution",
  "Smart Contract",
  "Wallet",
  "dApp",
  "Node Management",
  "Interface",
  "DeFi",
  "DEX",
  "KYC",
  "OTC",
  "Subgraph",
  "DevOps",
  "Oracle",
  "API",
  "Governance",
  "Dashboard",
  "Monitor",
  "Payments",
  "Platform",
  "Audit",
  // "Insurance",
  "Integration",
  "Explorer",
  "Launch Kit",
  "CCIP",
  "NFT",
];

export const tagsCardano = ["All", "Delivered", "Proposals F13"];

export const projectsCardano = {
  Delivered: [
    {
      id: "utxo-abstraction",
      title: "Protofire - UTXO DB Abstraction",
      text: "UTXO-based blockchains like Cardano offer strong security and scalability, but their fragmented, stateless design creates major bottlenecks for developers. Building even basic features like balance tracking can extend delivery timelines by 40% and cost teams over $15,000 annually in redundant API calls. These issues are especially painful for DeFi and NFT apps that require real-time synchronization.",
      tagList: ["DataBase", "DevTools", "F13"],
      link: "/projects/utxo-abstraction",
      img: utxoAbstraction,
    },
    {
      id: "developer-studio",
      title: "Protofire - Developer Studio",
      text: "Protofire introduces Developer Studio for Cardano, an all-in-one open-source repository that simplifies the development of Cardano smart contracts. It reduces the steep learning curve for developers by offering a pre-configured environment, tools, and resources, enabling faster onboarding and innovation within the ecosystem.",
      tagList: ["DevTools", "F13"],
      link: "/projects/developer-studio",
      img: developerStudio,
    },
  ],
  "Proposals F13": [
    {
      id: "cross-chain-interoperability",
      title: "Protofire - Cross-Chain Interoperability Protocol Integration",
      text: "The project addresses one of the main challenges in the blockchain ecosystem: the lack of interoperability between blockchains. This limitation not only slows down innovation, but also hinders the mass adoption of Web3 by complicating the interaction between blockchains and traditional systems. Our goal is to provide an efficient and scalable solution to enable seamless communication between Cardano and other blockchain networks.",
      tagList: ["CCIP", "F13"],
      img: crossChainInteroperability,
      link: "/projects/cardano-projects/cross-chain-interoperability",
    },
    {
      id: "contract-explorer",
      title: "Protofire - Contract Explorer",
      text: "This project aims to enhance transparency and trust within the Cardano ecosystem by creating a platform that allows users to explore, verify, and understand smart contracts, minting policies, and their associated attributes. By offering tools for developers and users alike, this initiative bridges the gap between technical complexity and user comprehension, fostering engagement and security within the network.",
      tagList: ["Smart Contracts", "F13"],
      img: contractExplorer,
      link: "/projects/cardano-projects/contract-explorer",
    },
    {
      id: "developer-studio-v2",
      title: "Protofire - Developer Studio v2",
      text: "Cardano Developer Studio v2 (Dev Studio v2) represents a groundbreaking upgrade to the original Developer Studio, providing a comprehensive development environment tailored for Cardano smart contract creation. Designed for efficiency and collaboration, Dev Studio v2 integrates with Visual Studio Code, simplifying the entire lifecycle of smart contract development from setup to deployment, all while being fully open-source.",
      tagList: ["DevTools", "F13"],
      img: developerStudioV2,
      link: "/projects/cardano-projects/developer-studio-v2",
    },
    {
      id: "mayz-protocol",
      title: "PROTOFIRE <> MAYZ PROTOCOL $gToken",
      text: "Governance Funds revolutionize DeFi by creating mechanisms that ensure liquidity and offer long-term value for protocols. By introducing innovative governance and utility models, we empower small and medium protocols to overcome liquidity challenges and ensure stability in secondary markets.",
      tagList: ["Governance", "F13"],
      img: mayzProtocol,
      link: "/projects/cardano-projects/mayz-protocol",
    },
    {
      id: "smart-contracts-unleashed",
      title:
        "Protofire - Smart Contracts Unleashed: Mastering Cardano Development",
      text: "This project delivers a comprehensive course on developing smart contracts using Cardano Developer Studio, focusing on Plutus and Lucid Framework. The course is designed to empower full-stack developers to integrate blockchain technology into their solutions, reducing the complexity of Cardano's smart contract development.",
      tagList: ["Smart Contracts", "F13"],
      img: smartContractsUnleashed,
      link: "/projects/cardano-projects/smart-contracts-unleashed",
    },
  ],
};

export const projects = [
  {
    id: "balancer",
    title: "Ve8020 Launchpad for Balancer",
    text: "The ve8020 Launchpad represents a significant milestone for Balancer, developed by Protofire through a community grant. This innovative platform provides a streamlined solution for projects to launch veTokens using 80/20 Balancer pools, promoting efficient tokenomics and fostering ecosystem growth.",
    tagList: ["Launchpad", "Platform", "Solution", "Token"],
    link: "/projects/balancer",
    img: balancerVe8020,
  },
  {
    id: "aethir",
    title: "Staking Module for Aethir",
    text: "The explosive growth of AI, gaming, and cloud computing has exposed the limitations of centralized infrastructure, driving demand for scalable, efficient, and decentralized alternatives. Aethir, a leader in Decentralized Physical Infrastructure Networks (DePIN), is meeting this need by connecting underutilized enterprise-grade GPUs with global users through a blockchain-powered marketplace.",
    tagList: ["Staking", "Module"],
    link: "/projects/aethir",
    img: aethir,
  },
  {
    id: "gnosis-safe-wallet",
    title: "Safe Multisig Wallet",
    text: "Safe (formerly Gnosis Safe) has become the account abstraction leader on Ethereum and EVM networks, with Protofire playing a crucial role in expanding its infrastructure across multiple blockchains. This partnership has revolutionized secure digital asset management while providing institutions, DAOs, and individuals with enhanced security through multi-signature capabilities.",
    tagList: ["dApp", "Interface", "Smart Contract", "Wallet"],
    link: "/projects/gnosis-safe-wallet",
    img: gnosis,
  },
  {
    id: "chainlink-integration",
    title: "Chainlink Integration",
    text: `Supported by Chainlink Community Grants, we have built a team 
      that works with Chainlink infrastructure in order to bring oracle infrastructure
      to wherever it may be needed in the Web3 ecosystem.`,
    tagList: ["Oracle", "Integration", "API", "DevOps"],
    link: "/projects/chainlink-integration",
    img: chainlink,
  },
  {
    id: "dia-oracles-kadena",
    title: "DIA Oracles on Kadena",
    text: "To accelerate DeFi growth on Kadena, Protofire integrated DIA’s decentralized oracles, bringing real-time price feeds for 15 major tokens and fiat currencies, including BTC, ETH, USDT, and KDA. This upgrade unlocked a >30% increase in TVL across Kadena’s DeFi protocols and cut asset integration time from weeks to days.",
    tagList: ["Oracle", "Smart Contract", "Integration"],
    link: "/projects/dia-oracles-kadena",
    img: diaOracles,
  },
  {
    id: "flare",
    title: "Airdrop Bot for Flare",
    text: "Protofire developed an innovative airdrop bot for Flare to address user onboarding challenges. The solution aims to simplify the process for first-time users bridging assets to the Flare network from external chains like Ethereum or XDC.",
    tagList: ["Bot", "Airdrop", "Solution", "Integration"],
    link: "/projects/flare",
    img: airdropBotFlare,
  },
  {
    id: "vana",
    title: "Vana Staking dApp",
    text: "Protofire developed and implemented a staking dApp for $VANA, the native token of Vana's decentralized AI data protocol. This project includes a user-friendly web application and subgraph integrations, enabling $VANA holders to stake their tokens, support Data Liquidity Pools (DLPs), and earn rewards.",
    tagList: ["dApp", "Platform", "Solution", "Staking", "AI", "Integration"],
    img: vanaBanner,
    link: "/projects/vana",
  },
  {
    id: "saga",
    title: "Saga Airdrop App",
    text: "Protofire has successfully developed a comprehensive web application for Saga's airdrop campaign, enhancing user experience during the mainnet launch. This project integrates key components such as UX design, web app implementation, and backend access to manage airdrop actions efficiently.",
    tagList: ["Airdrop", "App", "UX", "Solution"],
    link: "/projects/saga",
    img: sagaAirdrop,
  },
  {
    id: "cowswap-dex",
    title: "CowSwap DEX",
    text: `Protofire’s partnership with CoW Protocol has helped CoW Swap become a top player in decentralized exchange aggregation, setting new standards for trading efficiency, user protection, and platform growth.`,
    tagList: ["dApp", "DeFi", "DEX", "Interface", "SDK"],
    link: "/projects/cowswap-dex",
    img: cowswap,
  },
  {
    id: "swarm-dex",
    title: "Swarm Markets DEX",
    text: "Protofire played a pivotal role in launching Swarm DEX, the world’s first BaFin-licensed decentralized exchange supporting both cryptocurrencies and tokenized real-world assets (RWAs). Through smart contract development, auditing, and infrastructure design, Protofire enabled Swarm to reduce transaction fees by 98%, onboard over 7,000 verified users, and expand to 50+ trading pairs, including tokenized Apple and Tesla stock.",
    tagList: ["dApp", "Dashboard", "DeFi", "DEX", "KYC", "OTC"],
    link: "/projects/swarm-dex",
    img: swarmMarket,
  },
  {
    id: "filecoin-node-infrastructure",
    title: "Filecoin Node Infrastructure",
    text: "As decentralized storage demand surges, Filecoin now stores over 1 EiB of data and handles 4+ billion node requests monthly. But rapid growth exposed challenges in uptime, retrieval speed, and developer tooling.",
    tagList: ["API", "Explorer", "DevOps", "Node Management"],
    link: "/projects/filecoin-node-infrastructure",
    img: filecoin,
  },
  {
    id: "the-graph-subgraphs",
    title: "Subgraph & Node Management on The Graph",
    text: "Accessing blockchain data remains a major bottleneck for dApp developers, slowing down development by up to 80% and driving infrastructure costs above $500K annually. To tackle this, Protofire partnered with The Graph to deliver subgraph solutions that cut query times by 92%, indexing costs by 65%, and accelerated go-to-market from 8 weeks to just 10 days.",
    tagList: ["Subgraph", "DevOps", "Node Management"],
    link: "/projects/the-graph-subgraphs",
    img: graph,
  },
  {
    id: "makerdao-dashboard",
    title: "Maker Governance Analytics Dashboard",
    text: "Decentralized governance often struggles with complexity, poor data visibility, and low voter participation, and MakerDAO, securing over $9.3B in assets, was no exception. Proposal resolution could take up to three weeks, with only a fraction of MKR holders participating.",
    tagList: ["Dashboard", "Monitor", "Interface", "Governance", "DeFi"],
    link: "/projects/makerdao-dashboard",
    img: makerDAO,
  },
  {
    id: "gnosis-explorer",
    title: "Gnosis Conditional Tokens Explorer",
    text: "Access to real-time, transparent, and developer-friendly blockchain data is critical, but traditional explorers often fall short. To solve this, Protofire enhanced the Gnosis Explorer, now powering over 300,000+ validated addresses, handling millions of transactions, and delivering sub-second query speeds with 99.99% uptime.",
    tagList: ["dApp", "Explorer", "Interface"],
    link: "/projects/gnosis-explorer",
    img: gnosisConditional,
  },
  {
    id: "kryptomon",
    title: "BNB-to-Polygon Bridging for Kryptomon",
    text: "Protofire has leveraged Chainlink's CCIP to create a secure, one-time, and one-direction bridge infrastructure to transfer the Kryptomon assets (ERC20 and NFTs) from BNB to Polygon chain using an innovative approach to blockchain interoperability and asset transfer for gaming ecosystems.",
    tagList: ["CCIP", "Integration", "Smart Contract", "NFT"],
    link: "/projects/kryptomon",
    img: bnbToPolygon,
  },
  {
    id: "aragon-dapp",
    title: "AragonDAO Payroll dApp",
    text: "Managing payroll in DAOs is notoriously inefficient - leading to 30% payment delays, 15% manual errors, and 40% admin overhead. Protofire and Aragon tackled this by launching the AragonDAO Payroll dApp, now used by over 2,100 DAOs managing $1B+ in assets.",
    tagList: ["dApp", "Dashboard", "Payments"],
    link: "/projects/aragon-dapp",
    img: aragonDAO,
  },
  {
    id: "chainlink-dev-tools",
    title: "Chainlink Developer Tools",
    text: "Integrating decentralized oracles remains a major bottleneck for blockchain developers—often extending timelines by 30–50%. To address this, Chainlink partnered with Protofire to launch a suite of developer tools aimed at streamlining oracle integration across ecosystems.",
    tagList: ["Chainlink", "Foundry"],
    link: "/projects/chainlink-dev-tools",
    img: chainlinkDevTools,
  },
  {
    id: "single-button-solution",
    title: "Single-button Solution for Big Data Protocol",
    text: "Big Data Protocol (BDP) partnered with Protofire to overhaul its data monetization infrastructure - resulting in an 80% faster transaction speed, 200% user growth, and 3x more dApps built on the platform. By deploying decentralized pricing oracles, optimizing smart contracts, and releasing developer-friendly APIs, Protofire helped BDP become a trusted marketplace serving five major industries, including finance and healthcare.",
    tagList: ["Big Data Protocol", "Solution"],
    link: "/projects/single-button-solution",
    img: singleButtonSolution,
  },
  {
    id: "monitoring-for-giga",
    title: "Monitoring Platform for Giga",
    text: "Ensuring reliable internet access for schools remains one of the world’s most urgent digital challenges — especially in remote and underserved regions. Traditional monitoring systems are often opaque, error-prone, and difficult to scale.",
    tagList: ["Big Data Protocol", "Solution"],
    link: "/projects/monitoring-for-giga",
    img: monitoringForGiga,
  },
  {
    id: "armanino-platform",
    title: "Armanino TrustExplorer Platform",
    text: "To modernize enterprise infrastructure and reduce operational friction, Armanino LLP – a top 20 U.S. accounting firm – partnered with Protofire. The result? A 45% drop in reconciliation errors, 60% faster compliance reporting, 30% IT cost savings for clients like Anka, and a 50% surge in platform engagement.",
    tagList: ["Platform"],
    link: "/projects/armanino-platform",
    img: armanino,
  },
  {
    id: "kyber-smart-contract",
    title: "KyberDAO Governance Smart Contract",
    text: "KyberDAO faced mounting challenges that slowed its growth: 14-day reward delays, 60% of staked KNC managed by centralized intermediaries, and less than 30% of voters actively participating in governance.",
    tagList: ["Smart Contract", "Governance"],
    link: "/projects/kyber-smart-contract",
    img: kyberDAO,
  },
  {
    id: "ox-launch-kit",
    title: "0x Launch Kit",
    text: "Launching a custom DEX used to cost over $500K and take up to 12 months, locking out 70% of startups and indie developers. Protofire’s collaboration with 0x Protocol changed that. By enhancing the 0x Launch Kit, we enabled over 1,200 teams to deploy fully functional, customizable DEXs in under 60 seconds, cutting costs by 90% and driving a 400% surge in niche DEX adoption across gaming, NFTs, and community tokens, and here's how.",
    tagList: ["Launch Kit"],
    link: "/projects/ox-launch-kit",
    img: oxLauch,
  },
  ...projectsCardano.Delivered,
  {
    id: "cardano-projects",
    title: "Cardano Projects",
    text: "We are committed to advancing the Cardano ecosystem by transforming innovative ideas into real-world blockchain solutions. Through our technical expertise and strategic vision, we deliver projects that not only meet our partners' goals but also strengthen and expand Cardano’s potential, fostering growth and adoption across industries.",
    tagList: ["Delivered", "Proposals F13"],
    img: cardanoProjectsTile,
    link: "/projects/cardano-projects",
  },
  // {
  //   id: "solhint",
  //   title: "Solhint Solidity Linter",
  //   text: "Solhint helps to write high-quality, secure, and bug-free smart contract code.",
  //   tagList: ["Explorer", "Node Management"],
  //   link: "/projects/solhint",
  //   img: solhint,
  // },
  // {
  //   id: "opyn-platform",
  //   title: "Opyn Decentralized Insurance Platform",
  //   text: `We have supported Opyn on the development of the user interface of
  //     their Decentralized Insurance Platform, as well as integrated it with a backend
  //     and Web3 calls.`,
  //   // tagList: ["Platform", "Audit", "Insurance", "Interface", "Integration"],
  //   tagList: ["Platform", "Audit", "Interface", "Integration"],
  //   link: "/projects/opyn-platform",
  //   img: opyn,
  // },
];

export const projectDetailsMap = {
  vana: {
    metaTitle:
      "Vana Staking dApp: Empowering Data Liquidity in Web3 | Protofire",
    meta: [
      {
        name: "description",
        content:
          "Discover how Protofire developed Vana's staking dApp, enabling $VANA holders to support Data Liquidity Pools and earn rewards in a decentralized AI ecosystem.",
      },
      {
        name: "keywords",
        content:
          "Vana staking, data liquidity, Web3 dApp, DLP delegation, decentralized AI",
      },
    ],
    title: "Vana Staking dApp",
    tagList: ["dApp", "Platform", "Solution", "Staking", "AI", "Integration"],
    description: [
      "Protofire developed and implemented a staking dApp for $VANA, the native token of Vana's decentralized AI data protocol. This project includes a user-friendly web application and subgraph integrations, enabling $VANA holders to stake their tokens, support Data Liquidity Pools (DLPs), and earn rewards.",
    ],
    mainImage: vanaBannerMore,
    about: [
      "The Vana staking dApp is a crucial component of Vana's ecosystem, designed to incentivize user participation and promote the growth of Data Liquidity Pools. The application allows users to stake $VANA tokens as guarantors for one or more DLPs, fostering a dynamic and engaged community within the Vana network. Key features include flexible staking options, DLP delegation, reward distribution, and a comprehensive DLP leaderboard for informed decision-making.",
    ],
    additionalContent: [
      {
        title: "The Problem",
        description: [
          "Vana needed a robust and user-friendly platform to encourage $VANA token holders to actively participate in the network's growth by staking their tokens and supporting various Data Liquidity Pools. The challenge was to create a seamless experience that would simplify the staking process while providing users with essential information to make informed decisions about their investments.",
        ],
      },
      {
        title: "The Solution",
        description: [
          "Protofire developed a comprehensive staking dApp with the following features:",
        ],
        items: [
          "Staking mechanism with minimum amount and period settings",
          "DLP delegation system with an informative dashboard",
          "Reward distribution system with estimated rewards and manual claim function",
          "DLP Leaderboard displaying key performance metrics",
          "User-friendly interface for easy navigation and interaction",
        ],
        descriptionExtra: {
          text: [
            "The implementation of the Vana staking dApp has empowered $VANA holders to stake their tokens and earn rewards, promoting the growth and sustainability of Data Liquidity Pools while enhancing user engagement within the Vana ecosystem. Additionally, it provides a transparent and informative platform for decision-making, significantly contributing to the overall success of the project.",
          ],
        },
      },
      {
        title: "Partner Description",
        description: [
          "Vana is a pioneering decentralized AI data protocol that aims to build the world's largest user-owned data treasury. The platform enables individuals to reclaim ownership of their data and make it portable across various applications, fostering a new kind of digital economy that is open, collaborative, and empowering.",
        ],
      },
    ],
    // technologyStack: {
    // description: [
    //   "We leverage the most suitable technologies for each solution to help our customers achieve their business goals more swiftly.",
    // ],
    // items: [
    //   {
    //     title: "Programming Languages",
    //     items: ["Solidity", "Node.js"],
    //   },
    // ],
    // },
    bottomSlogan: "Need help with developing a staking solution?",
    contact: {
      image: juanFaya,
      name: "Juan Faya",
      lnUrl: "https://www.linkedin.com/in/juanmanuelfaya/",
      calendlyCallPostfix: "juan-faya-protofire/30min",
      text: "Schedule a call with our Sales Representative to receive practical recommendations and a prompt proposal for upgrading your solution.",
    },
  },

  //-----------------------------------------------------------------------------

  "cross-chain-interoperability": {
    metaTitle:
      "Cardano Cross-Chain Interoperability: Connecting Blockchain Networks",
    meta: [
      {
        name: "description",
        content:
          "Protofire's hybrid protocol enables seamless communication between Cardano and other blockchains, fostering innovation and Web3 adoption.",
      },
      {
        name: "keywords",
        content:
          "cross-chain, interoperability, Cardano, blockchain communication",
      },
    ],
    title: "Protofire - Cross-Chain Interoperability Protocol Integration",
    tagList: ["CCIP", "DevTools", "F13"],
    description: [
      "The project addresses one of the main challenges in the blockchain ecosystem: the lack of interoperability between blockchains. This limitation not only slows down innovation, but also hinders the mass adoption of Web3 by complicating the interaction between blockchains and traditional systems. Our goal is to provide an efficient and scalable solution to enable seamless communication between Cardano and other blockchain networks.",
    ],
    headerBtnLink: {
      link: "https://cardano.ideascale.com/c/cardano/idea/128377",
      text: "Vote us",
    },
    about: [
      "The proposed solution is a hybrid on-chain/off-chain system designed to enable inter-chain messaging in the Cardano network. This approach enables token and data transfers between networks efficiently, simplifying complex processes and reducing costs. With on-chain components dedicated to storage and configuration, and off-chain modules responsible for processing messages and creating transactions, the architecture ensures scalability and adaptability.",
    ],
    additionalContent: [
      {
        title: "Improved interoperability",
        description: [
          "It facilitates the transfer of assets and data between multiple blockchains, allowing applications to leverage the strengths of each network.",
        ],
      },
      {
        title: "Arbitrary messaging",
        description: [
          "Support for custom messages between smart contracts on different networks, enabling use cases such as index rebalancing, NFT minting and complex multi-chain tasks.",
        ],
      },
      {
        title: "Customized configuration",
        description: [
          "Each project can define specific configurations through contracts with unique UTXOs identified by NFTs.",
        ],
      },
      {
        title: "Cost efficiency",
        description: [
          "Flexible options to cover transaction fees, from users to dedicated contracts.",
        ],
      },
      {
        title: "Resilience and fault tolerance",
        description: [
          "Includes mechanisms such as automatic retries, transaction logging, and real-time monitoring to ensure reliability.",
        ],
      },
      {
        title: "Intelligent UTXO selector",
        description: [
          "Allows you to choose specific entries based on predefined conditions such as token possession or particular data.",
        ],
      },
    ],
    bottomSlogan: "Have you been thinking of developing in Cardano?",
    bottomSloganExtra: "So that we can discuss your ideas.",
    additionalDescription: {
      title: "Conclusion",
      text: [
        "The project addresses a critical problem in the blockchain ecosystem: the lack of interoperability between chains. By offering a hybrid on-chain/off-chain solution, it not only simplifies the transfer of assets and data between networks, but also enables complex use cases, such as index rebalancing and messaging between smart contracts on different chains. The modular design ensures scalability, resilience and customization to suit the needs of different projects. In addition, the combination of Cardano and EVM ensures compatibility with a wide range of wallets and tools, increasing their accessibility.  In terms of impact, this proposal represents a significant step towards mass adoption of Web3 by reducing the technological and economic barriers associated with multi-chain interaction. With its technical robustness, cost efficiency and focus on security, the project is positioned as a key enabler for the next generation of interconnected decentralized applications.",
      ],
    },
    contact: {
      image: federico,
      name: "Federico Ledesma",
      lnUrl: "https://www.linkedin.com/in/lic-ledesma-calatayud/",
      tgUrl: "https://t.me/federicoledesma",
      calendlyCallPostfix: "federico-ledesma-protofire/30min",
      text: "Schedule a call with our Project Manager to receive practical recommendations and a prompt proposal for upgrading your solution.",
    },
  },

  // ----------------------------------------------------------------------------

  "contract-explorer": {
    metaTitle: "Cardano Contract Explorer: Enhancing Transparency and Trust",
    meta: [
      {
        name: "description",
        content:
          "Protofire's platform allows users to explore, verify, and understand Cardano smart contracts and minting policies, fostering ecosystem engagement.",
      },
      {
        name: "keywords",
        content:
          "smart contract explorer, Cardano, transparency, minting policies",
      },
    ],
    title: "Protofire - Contract Explorer",
    tagList: ["Smart Contracts", "F13"],
    description: [
      "This project aims to enhance transparency and trust within the Cardano ecosystem by creating a platform that allows users to explore, verify, and understand smart contracts, minting policies, and their associated attributes. By offering tools for developers and users alike, this initiative bridges the gap between technical complexity and user comprehension, fostering engagement and security within the network.",
    ],
    headerBtnLink: {
      link: "https://cardano.ideascale.com/c/cardano/idea/129340",
      text: "Vote us",
    },
    about: [
      "This platform is designed to improve how users and developers interact with smart contracts on the Cardano blockchain. From verifying contract source code to exploring minting policies and integrating APIs, the project addresses critical needs for transparency, trust, and education in the ecosystem.",
    ],
    additionalContent: [
      {
        title: "Source Code and Blueprint Verification",
        description: [
          "Administrators can upload source code and JSON Blueprint files along with their corresponding hash. The platform will verify if the compiled code matches the provided hash, ensuring integrity. Initially supporting Haskell, the platform plans to expand to other contract languages.",
        ],
      },
      {
        title: "Contract Search and Analysis",
        description: [
          "Users can search for a hash to access detailed contract information, including definitions, source code, user ratings, and comments. This feature encourages community-driven analysis, making smart contracts accessible and understandable for the average user.",
        ],
      },
      {
        title: "Minting Policies for NFTs and FTs",
        description: [
          "Provides detailed insights into minting policies, highlighting wallet restrictions, temporal limitations, and duplication prevention measures. This feature helps users verify whether a token truly qualifies as an NFT or FT.",
        ],
      },
      {
        title: "REST API",
        description: [
          "The API allows external services to query information about tokens, contracts, and minting policies programmatically. Wallets and explorers can integrate this data to enhance user experiences and provide clear insights into the blockchain.",
        ],
      },
      {
        title: "Community Engagement",
        description: [
          "Users can leave comments, analyze contracts, and assign ratings. A reputation system rewards valuable contributions, encouraging participation and collaboration across the ecosystem.",
        ],
      },
      {
        title: "Short-Term Impact",
        description: [
          "Increased user confidence in smart contract interactions.",
          "Reduction in scams and malicious contract activity.",
          "Enhanced developer engagement through accessible tools and insights.",
        ],
      },
      {
        title: "Long-Term Impact",
        description: [
          "Growth in the user base due to improved transparency and education.",
          "Higher quality dApps as a result of better-informed developers.",
          "Greater community trust and ecosystem development.",
        ],
      },
    ],
    bottomSlogan: "Have you been thinking of developing in Cardano?",
    bottomSloganExtra: "So that we can discuss your ideas.",
    additionalDescription: {
      title: "Conclusion",
      text: [
        "This project boosts transparency and trust in Cardano by providing tools to explore, verify and analyze smart contracts and minting policies. With functionalities such as code verification, community analysis and a REST API for external integrations, it improves the security and accessibility of the ecosystem. In the short term, it reduces risks and fosters user trust; in the long term, it promotes higher quality development, a more informed community and network growth, positioning Cardano as a benchmark in blockchain transparency.",
      ],
    },
    contact: {
      image: federico,
      name: "Federico Ledesma",
      lnUrl: "https://www.linkedin.com/in/lic-ledesma-calatayud/",
      tgUrl: "https://t.me/federicoledesma",
      calendlyCallPostfix: "federico-ledesma-protofire/30min",
      text: "Schedule a call with our Project Manager to receive practical recommendations and a prompt proposal for upgrading your solution.",
    },
  },

  // ----------------------------------------------------------------------------

  "developer-studio-v2": {
    metaTitle:
      "Cardano Developer Studio v2: Advanced Smart Contract Development",
    meta: [
      {
        name: "description",
        content:
          "Protofire's upgraded Developer Studio integrates with VS Code, streamlining the entire lifecycle of Cardano smart contract development.",
      },
      {
        name: "keywords",
        content: "Cardano, Developer Studio v2, VS Code, smart contracts",
      },
    ],
    title: "Protofire - Developer Studio v2",
    tagList: ["DevTools", "F13"],
    description: [
      "Cardano Developer Studio v2 (Dev Studio v2) represents a groundbreaking upgrade to the original Developer Studio, providing a comprehensive development environment tailored for Cardano smart contract creation. Designed for efficiency and collaboration, Dev Studio v2 integrates with Visual Studio Code, simplifying the entire lifecycle of smart contract development from setup to deployment, all while being fully open-source.",
    ],
    headerBtnLink: {
      link: "https://cardano.ideascale.com/c/cardano/idea/129341",
      text: "Vote us",
    },
    about: [
      "Dev Studio v2 builds on the success of its predecessor, addressing the evolving needs of Cardano developers. Its dual-component architecture, comprising the Dev Studio Repository and the VS Code Extension, creates a seamless and interactive development experience. ",
    ],
    additionalContent: [
      {
        title: "Enhanced Development Tools",
        description: [
          "Includes new tools such as Scrolls for managing on-chain entities, advanced development containers for Haskell and Aiken, and tools for creating custom Cardano test networks.",
        ],
      },
      {
        title: "CLI Improvements",
        description: [
          "Features visually appealing menus, automated project setup with templates, and compatibility configurations to adapt to Cardano's dynamic environment.",
        ],
      },
      {
        title: "VS Code Extension Integration",
        description: [
          "Supports multiple languages (Haskell, Aiken, Helios), offering pre-configured environments, code analysis, and a blueprint-based system for transaction creation and contract interaction.",
        ],
      },
      {
        title: "Open-Source and Collaborative Ecosystem",
        description: [
          "Licensed under the GNU General Public License v3.0, enabling developers to freely use, modify, and contribute to the platform.",
        ],
      },
      {
        title: "Future-Proof Architecture",
        description: [
          "Adaptable to local, Docker-based, and cloud environments, with plans to integrate advanced testing tools, enhanced analysis features, and emerging design patterns.",
        ],
      },
      {
        title: "Short-Term Impact",
        description: [
          "Increased user confidence in smart contract interactions.",
          "Reduction in scams and malicious contract activity.",
          "Enhanced developer engagement through accessible tools and insights.",
        ],
      },
      {
        title: "Long-Term Impact",
        description: [
          "Growth in the user base due to improved transparency and education.",
          "Higher quality dApps as a result of better-informed developers.",
          "Greater community trust and ecosystem development.",
        ],
      },
    ],
    technologyStack: {
      description: [
        "Protofire drives growth in TVL and usage for web3 projects. Our developer DAO ensures aligned incentives. Utilizing in-house and third-party components, we decrease costs and increase quality.",
      ],
      items: [
        {
          title: "Programming Languages",
          items: ["Haskell", "Aiken", "Helios"],
        },
        {
          title: "Frameworks and Libraries",
          items: ["GitHub Codespaces", "Gitpod"],
        },
        {
          title: "Infrastructure",
          items: ["Docker", "Scrolls", "Blockfrost API"],
        },
      ],
    },
    bottomSlogan: "Have you been thinking of developing in Cardano?",
    bottomSloganExtra: "So that we can discuss your ideas.",
    additionalDescription: {
      title: "Conclusion",
      text: [
        "Cardano Developer Studio v2 revolutionizes Cardano development by providing a comprehensive, efficient and collaborative environment for smart contracts. Integrated with VS Code and advanced tools such as Scrolls and development containers, it simplifies the entire development lifecycle. With multi-language support, adaptive architecture and an open-source approach, it reduces barriers, accelerates the creation of dApps and fosters best practices, consolidating its impact on the Cardano community.",
      ],
    },
    contact: {
      image: federico,
      name: "Federico Ledesma",
      lnUrl: "https://www.linkedin.com/in/lic-ledesma-calatayud/",
      tgUrl: "https://t.me/federicoledesma",
      calendlyCallPostfix: "federico-ledesma-protofire/30min",
      text: "Schedule a call with our Project Manager to receive practical recommendations and a prompt proposal for upgrading your solution.",
    },
  },

  // ----------------------------------------------------------------------------

  "mayz-protocol": {
    metaTitle:
      "Protofire x MAYZ: Revolutionizing DeFi Governance and Liquidity",
    meta: [
      {
        name: "description",
        content:
          "Innovative governance funds align utility and liquidity for small and medium Cardano protocols, ensuring long-term value and stability.",
      },
      {
        name: "keywords",
        content: "DeFi, governance funds, Cardano, liquidity provision",
      },
    ],
    title:
      "Protofire <> MAYZ PROTOCOL $gToken: Aligning Governance, Utility & Liquidity in a single token",
    tagList: ["Governance", "F13"],
    description: [
      "Governance Funds revolutionize DeFi by creating mechanisms that ensure liquidity and offer long-term value for protocols. By introducing innovative governance and utility models, we empower small and medium protocols to overcome liquidity challenges and ensure stability in secondary markets.",
    ],
    headerBtnLink: {
      link: "https://cardano.ideascale.com/c/cardano/idea/129947",
      text: "Vote us",
    },
    about: [
      "Our Governance Funds initiative, developed in collaboration with <a target='_blank' href='https://x.com/MAYZProtocol/' class='text-orange100'>@MAYZprotocol</a>, addresses a critical issue in DeFi: the lack of sustainable incentives for small and medium protocols to retain liquidity providers. These protocols often struggle with tokenomics models that fail to provide long-term value, leading to instability in secondary markets. Together with MAYZ, we introduce governance and utility models that incentivize liquidity provision and ensure sustained support, driving innovation and stability within the Cardano ecosystem.",
    ],
    additionalContent: [
      {
        title: "Liquidity Retention for Small Protocols",
        description: [
          "Many small and medium protocols face challenges in maintaining liquidity in secondary markets. We provide sustainable incentives to attract and retain liquidity providers (LPs) for the long term.",
        ],
      },
      {
        title: "Governance and Community Engagement",
        description: [
          "By aligning liquidity providers, governance participants, and token holders, we foster a decentralized and transparent governance ecosystem, ensuring protocols align with community needs.",
        ],
      },
      {
        title: "Innovative Tokenomics Design",
        description: [
          "Inspired by models like Curve’s and Balancer’s veModel, our approach introduces $gTokens. These derivative tokens represent a portfolio of underlying assets, ensuring utility and liquidity while supporting governance and protocol stability.",
        ],
      },
      {
        title: "Enhanced Market Stability",
        description: [
          "Our $gTokens introduce locking mechanisms and voting power incentives, promoting long-term liquidity retention and token price stability.",
        ],
      },
      {
        title: "Empowering the Cardano Ecosystem",
        description: [
          "Focused on the Cardano blockchain, our project enhances DeFi by providing protocols with tools to stabilize liquidity, engage communities, and encourage innovation.",
        ],
      },
    ],
    bottomSlogan: "Have you been thinking of developing in Cardano?",
    bottomSloganExtra: "So that we can discuss your ideas.",
    additionalDescription: {
      title: "Conclusion",
      text: [
        "This project transforms DeFi solving liquidity challenges for small and medium-sized protocols through innovative governance and utility models. It introduces $gTokens, derivative tokens with lock-in mechanisms and voting power, which foster liquidity retention and price stability. With a focus on sustainable incentives and community participation, it strengthens the Cardano ecosystem, promoting stability, innovation and a more inclusive DeFi.",
      ],
    },
    contact: {
      image: federico,
      name: "Federico Ledesma",
      lnUrl: "https://www.linkedin.com/in/lic-ledesma-calatayud/",
      tgUrl: "https://t.me/federicoledesma",
      calendlyCallPostfix: "federico-ledesma-protofire/30min",
      text: "Schedule a call with our Project Manager to receive practical recommendations and a prompt proposal for upgrading your solution.",
    },
  },

  // ----------------------------------------------------------------------------

  "smart-contracts-unleashed": {
    metaTitle:
      "Master Cardano Development: Comprehensive Smart Contract Course",
    meta: [
      {
        name: "description",
        content:
          "Protofire's course empowers full-stack developers to create Cardano smart contracts using Plutus and Lucid Framework in Developer Studio.",
      },
      {
        name: "keywords",
        content:
          "Cardano development, smart contracts, Plutus, Lucid Framework",
      },
    ],
    title:
      "Protofire - Smart Contracts Unleashed: Mastering Cardano Development",
    tagList: ["Smart Contracts", "F13"],
    description: [
      "This project delivers a comprehensive course on developing smart contracts using Cardano Developer Studio, focusing on Plutus and Lucid Framework. The course is designed to empower full-stack developers to integrate blockchain technology into their solutions, reducing the complexity of Cardano's smart contract development.",
    ],
    headerBtnLink: {
      link: "https://cardano.ideascale.com/c/cardano/idea/129929",
      text: "Vote us",
    },
    about: [
      "The proposed course aims to lower the barrier to entry for developers interested in building on the Cardano blockchain. It offers a structured and practical approach to teaching on-chain and off-chain smart contract development using Plutus and Lucid Framework. By integrating hands-on examples, testing, and debugging, the course ensures that developers, even those new to blockchain, can effectively create smart contracts in a traditional development environment.",
    ],
    additionalContent: [
      {
        title: "Comprehensive Learning Environment",
        description: [
          "The course provides developers with access to Cardano Developer Studio tools, including a Cardano node, wallet manager, and Smart DB Tools, creating an integrated environment for learning.",
        ],
      },
      {
        title: "Practical Hands-On Approach",
        description: [
          "Tutorials include real-world examples of on-chain contract development with Plutus and off-chain integration with Lucid Framework, bridging the gap between blockchain technology and dApps.",
        ],
      },
      {
        title: "Simplifying Blockchain Development",
        description: [
          "By focusing on JavaScript-based frameworks like Lucid, the course attracts full-stack developers familiar with traditional web technologies, enabling seamless adoption of Cardano tools.",
        ],
      },
      {
        title: "Driving Cardano Ecosystem Growth",
        description: [
          "The course contributes to increased activity and innovation on the Cardano blockchain, empowering developers to create new dApps and driving adoption across industries.",
        ],
      },
      {
        title: "Real-World Validation",
        description: [
          "Practical examples, testing scenarios, and feedback from students ensure the course is impactful and effective, fostering confidence in smart contract development.",
        ],
      },
    ],
    bottomSlogan: "Have you been thinking of developing in Cardano?",
    bottomSloganExtra: "So that we can discuss your ideas.",
    additionalDescription: {
      title: "Conclusion",
      text: [
        "The project offers a comprehensive course on smart contract development in Cardano, focused on Plutus and Lucid Framework. Designed for full-stack developers, it simplifies the adoption of blockchain technologies by combining tools such as Cardano Developer Studio with a hands-on approach and real-world examples. By facilitating learning and promoting the creation of dApps, the course drives innovation in the Cardano ecosystem and fosters blockchain adoption in various industries.",
      ],
    },
    contact: {
      image: federico,
      name: "Federico Ledesma",
      lnUrl: "https://www.linkedin.com/in/lic-ledesma-calatayud/",
      tgUrl: "https://t.me/federicoledesma",
      calendlyCallPostfix: "federico-ledesma-protofire/30min",
      text: "Schedule a call with our Project Manager to receive practical recommendations and a prompt proposal for upgrading your solution.",
    },
  },

  // ----------------------------------------------------------------------------

  "utxo-abstraction": {
    metaTitle:
      "UTXO DB Abstraction: Empowering Efficient Cardano DApp Development",
    meta: [
      {
        name: "description",
        content:
          "Protofire's database solution bridges blockchain and relational data, enabling seamless DApp development and scalability on Cardano.",
      },
      {
        name: "keywords",
        content:
          "UTXO, database abstraction, Cardano DApps, blockchain dataProposed Projects",
      },
    ],
    title: "Protofire - UTXO DB Abstraction",
    tagList: ["DataBase", "DevTools", "F13"],
    description: [
      "UTXO-based blockchains like Cardano offer strong security and scalability, but their fragmented, stateless design creates major bottlenecks for developers. Building even basic features like balance tracking can extend delivery timelines by 40% and cost teams over $15,000 annually in redundant API calls. These issues are especially painful for DeFi and NFT apps that require real-time synchronization.",
      "To address this, Protofire introduced UTXO Abstraction - a solution that mirrors on-chain data in SQL-like databases and optimizes concurrency. As a result, over 200 projects have accelerated DApp development by 60%, reduced infrastructure costs by 40%, and now process over $220M in quarterly volume with zero transaction conflicts and 70% lower API expenses.",
    ],
    headerBtnLink: {
      link: "https://projectcatalyst.io/funds/11/cardano-open-developers/cardano-utxo-db-abstraction",
      text: "View finished product",
    },
    about: [
      "This project introduces a robust database solution designed to synchronize on-chain data with user interfaces, enabling decentralized applications on the Cardano blockchain to function seamlessly. By utilizing the UTXO (Unspent Transaction Output) model unique to Cardano, the database translates blockchain data into a structure akin to relational databases, simplifying data management for developers.",
      "The database acts as an abstraction layer, transforming UTXOs into records and contracts into tables. This innovation enables developers to query and manage complex states and transactions as if they were interacting with a traditional database.",
    ],
    // mainImage: oraclesDia1,
    // images: [
    //   { alt: "oraclesDia1", src: oraclesDia1 },
    //   { alt: "oraclesDia2", src: oraclesDia2 },
    // ],
    // additionalContent: [
    //   {
    //     title: "Seamless Blockchain Synchronization",
    //     description: [
    //       "Maintains synchronization between the database and the blockchain using webhooks, backend checks, or indexing services like Blockfrost. This ensures real-time accuracy of the data.",
    //     ],
    //   },
    //   {
    //     title: "Concurrency Management",
    //     description: [
    //       "Prevents transaction conflicts by monitoring and marking UTXOs involved in ongoing transactions, safeguarding data consistency.",
    //     ],
    //   },
    //   {
    //     title: "Query Optimization",
    //     description: [
    //       "Functions as a cache to reduce redundant API calls, optimizing performance and minimizing costs for developers.",
    //     ],
    //   },
    //   {
    //     title: "Data Abstraction and Configuration",
    //     description: [
    //       "Utilizes JSON configurations to map blockchain data to database tables, enabling a flexible and scalable architecture tailored to specific DApps.",
    //     ],
    //   },
    //   {
    //     title: "API Accessibility",
    //     description: [
    //       "Offers API-based access for front-end and back-end integrations, allowing developers to scale and build versatile DApps.",
    //     ],
    //   },
    // ],
    additionalContent: [
      {
        title: "The Problem",
        description: [
          "As part of a joint technical assessment with the Cardano ecosystem team, Protofire conducted a focused review of how developers interact with the UTXO model in production environments. This analysis surfaced several friction points that were limiting the scalability and usability of DApps, especially those handling complex state logic or high transaction volumes.",
          "We observed that many teams were building workarounds to aggregate fragmented UTXO data, often relying on repetitive API calls and manual indexing strategies. This not only increased infrastructure costs and time-to-market, but also introduced reliability risks through transaction collisions and sync delays.",
          "While these issues are well-known across UTXO-based blockchains, they were particularly acute within the Cardano ecosystem due to its growing DeFi and NFT sectors. The findings reinforced a common pattern we’ve seen across multiple networks - a clear need for middleware that simplifies data management, reduces operational overhead, and unlocks performance at scale. Protofire stepped in not just as a builder, but as a strategic partner to design and implement a solution aligned with these goals.",
        ],
      },
      {
        title: "The Solution",
        description: [
          "Protofire developed UTXO Abstraction to address these challenges through innovative features:",
        ],
        items: [
          "Database Bridge: A relational database structure mirrors blockchain data stored in UTXOs, ensuring seamless synchronization between on-chain states and user interfaces.",
          "Concurrency Management: The solution tracks UTXOs involved in ongoing transactions, minimizing conflicts caused by simultaneous usage.",
          "Query Optimization: Integrated caching mechanisms reduce redundant API calls, improving performance and cutting operational costs.",
          "Customizable Architecture: Developers can tailor database schemas to align with specific DApp requirements, enabling flexibility across use cases.",
        ],
      },
      {
        title: "Metrics and KPIs Improved by Implementing UTXO Abstraction",
        description: [
          "Protofire’s contributions delivered measurable gains across multiple performance dimensions:",
        ],
        items: [
          "Data Synchronization Speed: Frontend-to-chain data latency dropped from 5–10 seconds to sub-second levels, enhancing UX for DApps requiring real-time updates (e.g., wallets, games, NFT dashboards).",
          "Concurrency Reliability: The atomic UTXO locking mechanism eliminated transaction collisions even under stress testing of 5,000+ transactions per second (TPS) — a 100% conflict reduction during peak loads.",
          "Query Efficiency: Smart caching strategies reduced redundant API calls by 93%, leading to a 70% cut in overall API costs. For projects with 10M+ monthly queries, this translates into savings of $12,000–$18,000 annually.",
          "Developer Onboarding: Schema-as-code configuration enabled teams to start building production-ready Cardano DApps 3x faster, shortening average onboarding from 3 weeks to under 1 week.",
          "Smart Contract Deployment Volume: Monthly smart contract deployment increased by 47% among projects using the abstraction layer, signaling reduced friction in DApp release cycles.",
          "Cross-DApp Integration Speed: Integration time with other Cardano DApps dropped by 55%, thanks to standardized and queryable state data.",
          "Operational Expenses: Median DevOps costs associated with data sync and backend query management fell by 44%, driven by improved observability and database-native access.",
          "Technical Debt Reduction: Teams reported a 35% drop in redundant custom sync logic, cutting long-term maintenance costs and code complexity.",
        ],
        descriptionExtra: {
          text: [
            "These improvements have made UTXO Abstraction a foundational layer for building scalable, cost-efficient, and developer-friendly applications on Cardano. By removing key data and performance bottlenecks, Protofire has helped the ecosystem expand its developer base and accelerate real-world adoption of decentralized apps.",
          ],
        },
      },
      {
        title: "Benefits for Projects Using UTXO Abstraction",
        description: [
          "Adopting Protofire’s solution provides significant advantages for developers building DApps on Cardano or other UTXO-based blockchains:",
        ],
        items: [
          {
            title: "Streamlined Data Management:",
            items: [
              "Relational database structures simplify handling complex blockchain states, enabling faster development cycles.",
            ],
          },
          {
            title: "Improved Scalability:",
            items: [
              "Concurrency management ensures reliable performance as transaction volumes grow across diverse applications.",
            ],
          },
          {
            title: "Cost Efficiency:",
            items: [
              "Caching mechanisms reduce operational expenses associated with frequent API queries to external services like Blockfrost.",
            ],
          },
          {
            title: "Enhanced Developer Experience:",
            items: [
              "Customizable schemas allow developers to tailor solutions to their DApps’ specific needs, fostering innovation within the ecosystem.",
            ],
          },
        ],
      },
      {
        title: "Partner Description",
        description: [
          "Cardano, a leading blockchain platform known for its Extended UTXO model, enables advanced programmability and scalability for decentralized applications while maintaining robust security features. Its innovative ledger design supports multi-assets and smart contracts without compromising efficiency.",
          "UTXO Abstraction - a solution that bridges blockchain data with frontends and backends seamlessly while optimizing query performance and concurrency management. ",
        ],
      },
    ],
    bottomSlogan: "Have you been thinking of developing in Cardano?",
    bottomSloganExtra: "So that we can discuss your ideas.",
    additionalDescription: {
      title: "Conclusion",
      text: [
        "This project presents an innovative database solution that facilitates data management in decentralized applications (DApps) on the Cardano blockchain. By abstracting the complexity of the UTXO model and converting blockchain data into a more accessible format for developers, the system optimizes the synchronization, querying and scalability of DApps. With features such as concurrency management, query optimization and API accessibility, this solution improves the efficiency and growth of complex applications, driving Cardano adoption.",
      ],
    },
    contact: {
      image: federico,
      name: "Federico Ledesma",
      lnUrl: "https://www.linkedin.com/in/lic-ledesma-calatayud/",
      tgUrl: "https://t.me/federicoledesma",
      calendlyCallPostfix: "federico-ledesma-protofire/30min",
      text: "Schedule a call with our Project Manager to receive practical recommendations and a prompt proposal for upgrading your solution.",
    },
  },

  // ----------------------------------------------------------------------------

  "developer-studio": {
    metaTitle:
      "Cardano Developer Studio: Simplifying Smart Contract Development",
    meta: [
      {
        name: "description",
        content:
          "Protofire's all-in-one open-source repository streamlines Cardano smart contract development, reducing the learning curve for developers.",
      },
      {
        name: "keywords",
        content: "Cardano, Developer Studio, smart contracts, open-source",
      },
    ],
    title: "Protofire - Developer Studio",
    tagList: ["DevTools", "F13"],
    description: [
      "Protofire introduces Developer Studio for Cardano, an all-in-one open-source repository that simplifies the development of Cardano smart contracts. It reduces the steep learning curve for developers by offering a pre-configured environment, tools, and resources, enabling faster onboarding and innovation within the ecosystem.",
    ],
    headerBtnLink: {
      link: "https://projectcatalyst.io/funds/11/cardano-open-developers/cardano-developer-studio",
      text: "View finished product",
    },
    about: [
      "Developer Studio for Cardano is a solution designed to address the challenges faced by developers when entering the Cardano ecosystem. Unlike other blockchain platforms like Polkadot or Solana, Cardano suffers from slower developer growth, partly due to the complexity of its development process. By streamlining the setup and providing comprehensive resources, Developer Studio aims to enhance productivity and encourage wider adoption.",
    ],
    // mainImage: oraclesDia1,
    // images: [
    //   { alt: "oraclesDia1", src: oraclesDia1 },
    //   { alt: "oraclesDia2", src: oraclesDia2 },
    // ],
    additionalContent: [
      {
        title: "Automated Multi-Container Workflow",
        description: [
          "Developers can use Docker Compose to quickly set up all essential tools and services like Cardano Node, Wallet, CLI, and DbSync. This eliminates the need for manual installation and configuration.",
        ],
      },
      {
        title: "Pre-Configured Development Environment",
        description: [
          "Using DevContainers and tools like GHCup, Cabal, Nix, and Plutus-Tx, the studio offers a ready-to-use setup optimized for writing, testing, and deploying smart contracts directly in VS Code.",
        ],
      },
      {
        title: "CLI Toolkit",
        description: [
          "A user-friendly Bash-based CLI provides interactive menus for managing containers, querying nodes, creating transactions, and working with wallets. It also includes utilities for essential development tasks like UTXO inspection and metadata management.",
        ],
      },
      {
        title: "Haskell Libraries",
        description: [
          "Offers libraries for on-chain and off-chain development, along with script evaluation tools to optimize resource utilization in smart contracts.",
        ],
      },
      {
        title: "Example Smart Contracts and Minting Policies",
        description: [
          "A suite of templates and examples for creating and testing smart contracts, including minting tokens (NFTs and FTs) with customizable policies.",
        ],
      },
      {
        title: "Production Automation",
        description: [
          "Scripts to build and deploy production-ready Docker images to platforms like Docker Hub and hosting services like Demeter, ensuring smooth scaling and application management.",
        ],
      },
      {
        title: "Documentation and Tutorials",
        description: [
          "Comprehensive guides, sample contracts, and links to official documentation help developers understand and maximize the available tools.",
        ],
      },
    ],
    bottomSlogan: "Have you been thinking of developing in Cardano?",
    bottomSloganExtra: "So that we can discuss your ideas.",
    additionalDescription: {
      title: "Conclusion",
      text: [
        "The Cardano Developer Studio provides a comprehensive solution to simplify development in the Cardano ecosystem. By offering pre-configured tools, automated environments and educational resources, this initiative facilitates the creation and deployment of dApps and smart contracts, accelerating the learning curve for new developers and fostering sustainable growth in the community.",
      ],
    },
    contact: {
      image: federico,
      name: "Federico Ledesma",
      lnUrl: "https://www.linkedin.com/in/lic-ledesma-calatayud/",
      tgUrl: "https://t.me/federicoledesma",
      calendlyCallPostfix: "federico-ledesma-protofire/30min",
      text: "Schedule a call with our Project Manager to receive practical recommendations and a prompt proposal for upgrading your solution.",
    },
  },

  // ----------------------------------------------------------------------------

  "dia-oracles-kadena": {
    metaTitle: "DIA Oracles on Kadena: Expanding DeFi Capabilities | Protofire",
    meta: [
      {
        name: "description",
        content:
          "Protofire integrates DIA oracles on Kadena, enabling 14 asset price feeds. Enhance your DeFi projects with reliable, real-time data on the Kadena network",
      },
      {
        name: "keywords",
        content:
          "Kadena oracle integration, DIA price feeds, Blockchain oracle solutions, DeFi infrastructure, Pact smart contracts",
      },
    ],
    title: "DIA Oracles on Kadena",
    tagList: ["Oracle", "Smart Contract", "Integration"],
    description: [
      "To accelerate DeFi growth on Kadena, Protofire integrated DIA’s decentralized oracles, bringing real-time price feeds for 15 major tokens and fiat currencies, including BTC, ETH, USDT, and KDA. This upgrade unlocked a >30% increase in TVL across Kadena’s DeFi protocols and cut asset integration time from weeks to days. By porting DIA’s infrastructure to Pact, Protofire enabled faster protocol launches and expanded asset support, empowering projects like KDSwap and Hypercent to go live in under two months.",
    ],
    about: [
      "We partnered with DIA to port and deploy their oracle smart contracts to the Kadena blockchain, expanding the availability of reliable price feeds for Kadena-based projects.",
    ],
    mainImage: oraclesDia1,
    images: [
      { alt: "oraclesDia1", src: oraclesDia1 },
      { alt: "oraclesDia2", src: oraclesDia2 },
    ],
    additionalContent: [
      {
        title: "The Problem",
        description: [
          "Before the integration, projects on Kadena were limited in the range of assets they could support due to the lack of reliable price feeds on the network. This constraint hindered the growth and diversity of the DeFi ecosystem on Kadena.",
        ],
      },
      {
        title: "The Solution",
        description: [
          "Protofire onboarded DIA as an oracle provider by using the DIA GraphQL API and porting its smart contracts to Kadena’s Pact language. The solution included:",
        ],
        items: [
          "Porting DIA’s existing smart contracts to Pact",
          "Implementing data update feeders (for prices and randomness)",
          "Creating deployment scripts and Docker configurations",
          "Developing a TypeScript library for internal monitoring",
          "Providing comprehensive deployment and usage documentation",
        ],
        descriptionExtra: {
          text: [
            "This integration not only expanded access to data on Kadena but also laid the groundwork for future oracle implementations on the network.",
          ],
        },
      },
      {
        title: "KPIs Influenced",
        description: [
          "Integrating DIA oracles into Kadena produced clear, measurable improvements in several key areas:",
        ],
        items: [
          "Number of available assets for DeFi products:<br/>Expanded from just a few to 15 supported tokens and fiat currencies, including KDA, BTC, ETH, USDT, and USDC.",
          "Speed of launching new DeFi protocols:<br/>Enabled DeFi teams to move from concept to mainnet launch in under two months, compared to significantly longer timelines before DIA integration.",
          "Total Value Locked (TVL):<br/>Contributed to a >30% increase in TVL across Kadena’s DeFi protocols within the first few months post-integration, as more projects and users trusted the new data infrastructure.",
          "Time required to integrate new assets:<br/>Reduced integration time for new assets from several weeks to just a few days, thanks to DIA’s standardized and transparent data feeds.",
          "Number of external projects utilizing DIA oracles:<br/>Saw immediate adoption by notable projects such as KDSwap and Hypercent, which integrated DIA price feeds into their platforms.",
        ],
      },
      {
        title: "Additional Feature",
        description: [
          "Beyond the core integration, Protofire also delivered internal monitoring tools and user-friendly deployment assets (Docker, scripts, libraries), significantly lowering the barrier for new developers and projects joining the Kadena ecosystem.",
        ],
      },
      {
        title: "Partner Description",
        description: [
          "Kadena is a scalable blockchain platform built with a unique multi-chain architecture called Chainweb and a developer-friendly smart contract language called Pact. Founded by former JPMorgan blockchain experts, Kadena serves both enterprise and public blockchain use cases across DeFi, NFTs, and gaming. With high throughput and low transaction costs, Kadena offers a secure and efficient infrastructure for innovative blockchain applications.",
        ],
      },
    ],
    technologyStack: {
      // description: ["TECHNOLOGIES"],
      items: [
        {
          title: "Programming Languages",
          items: ["Pact (Kadena's programming language)", "TypeScript"],
        },
        {
          title: "SDKs and Librariess",
          items: ["Kadena's JS SDK"],
        },
        {
          title: "Development Tools",
          items: ["Docker"],
        },
        {
          title: "APIs",
          items: ["DIA GraphQL API"],
        },
      ],
    },
    codeData: {
      items: [
        {
          title: "GitHub DIA Kadena Oracles Repository",
          link: "https://github.com/diadata-org/dia-kadena-oracles",
        },
        {
          title: "Kadena Price Oracles Documentation",
          link: "https://docs.diadata.org/introduction/dia-technical-structure/data-delivery-methods/integrated-l1-l2-networks/kadena-price-oracles",
        },
        {
          title: "DIA Price Feed for Kadena",
          link: "https://www.diadata.org/app/price/asset/Kadena/0x0000000000000000000000000000000000000000/",
        },
      ],
    },
    mediaData: {
      items: [
        {
          title: "The Importance of Robust Data Sourcing for Oracles",
          link: "https://www.kadena.io/blog/dia-grantee-spotlight",
        },
        {
          title: "Dia Oracles Available on Dia Mainnet ",
          link: "https://www.diadata.org/blog/post/dia-price-oracles-kadena-mainnet/",
        },
      ],
    },
    bottomSlogan: "Are you in need of an oracle integration for your project?",
    contact: {
      image: juanFaya,
      name: "Juan Faya",
      lnUrl: "https://www.linkedin.com/in/juanmanuelfaya/",
      calendlyCallPostfix: "juan-faya-protofire/30min",
      text: "Schedule a call with our Sales Representative to receive practical recommendations and a prompt proposal for upgrading your solution.",
    },
  },

  // ----------------------------------------------------------------------------

  kryptomon: {
    metaTitle: "Kryptomon: Migration from BNB to Polygon | Protofire",
    meta: [
      {
        name: "description",
        content:
          "Protofire leverages Chainlink CCIP for secure, one-time ERC20 and NFT asset transfer from BNB to Polygon. Streamline your blockchain migration.",
      },
      {
        name: "keywords",
        content:
          "Cross-chain asset migration, Chainlink CCIP integration, NFT blockchain transfer, Gaming asset migration, BNB to Polygon bridge",
      },
    ],
    title: "BNB-to-Polygon Bridging for Kryptomon",
    tagList: ["CCIP", "Integration", "Smart Contract", "NFT"],
    description: [
      "Protofire designed and implemented a secure, one-time, one-direction bridge infrastructure for Kryptomon, leveraging Chainlink's CCIP solution to efficiently transfer ERC20 and NFT assets from Binance Smart Chain to Polygon. This innovative approach streamlined the migration process, preparing Kryptomon for the launch of their cross-platform MMORPG, KMON: World of Kogaea, on the Polygon network.",
    ],
    about: [
      "Kryptomon sought to migrate all its digital assets to Polygon in preparation for the launch of KMON: World of Kogaea, a cross-platform MMORPG.",
    ],
    mainImage: kryptomon0,
    // images: [
    //   { alt: "oraclesDia0", src: oraclesDia0 },
    //   { alt: "oraclesDia1", src: oraclesDia1 },
    // ],
    additionalContent: [
      {
        title: "The Problem",
        description: [
          "Initially, the project aimed to create an infrastructure for migrating NFT assets from Binance Smart Chain to Polygon using a multisig bridge implementation. This involved setting up three keys: one on Digital Ocean, another on AWS, and a third as a cold wallet.",
        ],
      },
      {
        title: "The Solution",
        description: [
          "After investigation, we pivoted to using Chainlink's CCIP (Cross-Chain Interoperability Protocol) solution. As long-term Chainlink partners, we leveraged this new technology to move token data between chains securely and efficiently.",
        ],
        items: [
          "Successful migration of NFT game assets to a new chain",
          "Secure transfer of NFTs across chains",
          "Streamlined infrastructure for future cross-chain operations",
        ],
        descriptionExtra: {
          text: ["Our solution supports:"],
          items: [
            "Transferring data from the source network",
            "Retrieving metadata on the target network for ERC1155 and ERC721 tokens",
            "Minting expected ERC20 tokens on the destination chain",
          ],
        },
      },
      {
        title: "Partner Description",
        description: [
          "Kryptomon is a blockchain-based gaming platform that combines elements of collectible monsters, battling, and breeding. Players can collect, train, and evolve digital creatures called Kryptomons, each with unique DNA and elemental abilities. The game offers various features including dungeon battles, trading card games, and a marketplace for buying and selling in-game assets, all while emphasizing player ownership and an open economy.",
        ],
      },
    ],
    technologyStack: {
      items: [
        {
          title: "Frameworks",
          items: ["Chainlink CCIP"],
        },
        {
          title: "Programming Languages",
          items: ["Smart Contracts (Solidity)"],
        },
      ],
    },
    mediaData: {
      items: [
        {
          title: "CCIP for Kryptomon",
          link: "https://x.com/chainlink/status/1775887809615732944",
        },
      ],
    },
    bottomSlogan:
      "Are you in need of a cross-chain integration for your project?",
    contact: {
      image: juanFaya,
      name: "Juan Faya",
      lnUrl: "https://www.linkedin.com/in/juanmanuelfaya/",
      calendlyCallPostfix: "juan-faya-protofire/30min",
      text: "Schedule a call with our Sales Representative to receive practical recommendations and a prompt proposal for upgrading your solution.",
    },
  },

  // ----------------------------------------------------------------------------

  "chainlink-dev-tools": {
    metaTitle:
      "Chainlink Developer Tools: Simplify dApp Integration | Protofire",
    meta: [
      {
        name: "description",
        content:
          "Streamline Chainlink integration with our Hardhat Plugin and Foundry Toolkit. Easily test and deploy smart contracts using local nodes and CLI.",
      },
      {
        name: "keywords",
        content:
          "Chainlink integration tools, Smart contract development, Blockchain dApp testing, Web3 framework plugins, Decentralized oracle solutions",
      },
    ],
    mainImage: chainlinkIntegration0,
    title: "Chainlink Developer Tools",
    tagList: ["Chainlink", "Foundry"],
    description: [
      "Integrating decentralized oracles remains a major bottleneck for blockchain developers—often extending timelines by 30–50%. To address this, Chainlink partnered with Protofire to launch a suite of developer tools aimed at streamlining oracle integration across ecosystems.",
      "The impact was immediate: integration time dropped by up to 60%, oracle reliability improved by 75%, and over 200 new projects adopted Chainlink using the new tools. With SDKs, subgraph support, and robust testing frameworks, Protofire helped turn Chainlink into the go-to infrastructure for data-powered smart contracts.",
    ],
    about: [
      "Chainlink Developer Tools include the Hardhat Plugin and the Foundry Toolkit. These standalone applications utilize TypeScript in Hardhat, along with Forge, Make, and Solidity Scripting in Foundry. They offer functionality for interacting with Chainlink services, spinning up local Chainlink nodes, creating Chainlink Jobs, and deploying and interacting with related Smart Contracts. All functionalities are accessible both directly in the code of a project utilizing a specific framework and via CLI commands.",
    ],
    aboutItems: [
      "Multi Solidity compiler support",
      "Local testing",
      "Convenient interaction with Chainlink services",
    ],
    additionalContent: [
      {
        title: "The Problem",
        description: [
          "As part of our initial engagement, Protofire conducted a series of technical discovery sessions with the Chainlink team to assess developer adoption barriers and friction points in oracle integration workflows. Through this collaborative analysis, several recurring pain points emerged - many of which were not unique to Chainlink, but reflected broader challenges across the Web3 ecosystem.",
          "We found that while Chainlink’s oracle infrastructure was robust, developers often encountered substantial inefficiencies when attempting to integrate its components into their smart contracts. These issues ranged from fragmented documentation and steep onboarding curves, to difficulties ensuring cross-chain compatibility and a lack of sandbox environments for testing data feeds at scale.",
          "Our joint assessment revealed that these gaps slowed time-to-integration, discouraged experimentation, and in some cases, led teams to postpone or abandon oracle-enabled features altogether. This insight formed the foundation for designing a solution focused on reducing integration complexity and unlocking broader adoption.",
        ],
      },
      {
        title: "The Solution",
        description: [
          "Protofire partnered with Chainlink to develop a suite of developer tools that address these challenges and simplify the integration process for decentralized oracles. Key innovations include:",
        ],
        items: [
          "Chainlink SDK: A comprehensive software development kit that provides pre-built modules for seamless integration of Chainlink oracles into smart contracts.",
          "Subgraph Support: Integration with The Graph enables efficient querying of oracle data, improving analytics and monitoring capabilities.",
          "Developer Documentation: Robust guides, tutorials, and examples that empower developers to quickly implement Chainlink functionalities in their dApps.",
          "Testing Frameworks: Tools designed to simulate oracle interactions in test environments, ensuring reliability before deployment.",
        ],
        descriptionExtra: {
          text: [
            "Protofire contributed by designing these tools, optimizing smart contracts, and building testing frameworks tailored to diverse developer needs across multiple blockchain ecosystems.",
          ],
        },
      },
      {
        title: "Metrics and KPIs Improved by Implementing Chainlink Dev Tools",
        description: [
          "The implementation of Chainlink Dev Tools has led to measurable impact across several core KPIs:",
        ],
        items: [
          "Integration Speed: Average time required to integrate Chainlink oracles dropped from ~10 developer-days to 4–5 days, reflecting a 60% reduction in setup time through the use of SDKs and improved documentation.",
          "Developer Adoption: Within 6 months of launch, over 220 new projects across Ethereum, Polygon, and BNB Chain adopted Chainlink using Protofire’s tools — a 3x increase compared to the previous half-year average.",
          "Data Reliability: The introduction of testing frameworks and subgraph analytics led to a 78% drop in oracle call failures across selected early adopters.",
          "Scalability Performance: Oracle-integrated dApps built with the new tools demonstrated a 2.4x increase in throughput capacity without requiring architectural changes, based on internal load testing.",
          "Ecosystem Growth: SDK usage metrics show over 35,000 cumulative downloads across GitHub and package managers, with 2,800+ developers using the tools as of the latest quarterly review.",
        ],
        descriptionExtra: {
          text: [
            "These results reflect how Protofire’s contribution not only removed critical integration hurdles but also helped position Chainlink as the go-to oracle solution for scalable, data-driven smart contract development across diverse blockchain environments.",
          ],
        },
      },
      {
        title: "Benefits for Projects Using Chainlink Dev Tools",
        description: [
          "Adopting Chainlink Dev Tools provides significant advantages for developers and projects across various industries:",
        ],
        items: [
          "Simplified Integration: Pre-built modules reduce technical complexity, enabling faster deployment of oracle-powered applications.",
          "Enhanced Reliability: Testing frameworks ensure robust interactions between smart contracts and decentralized oracles before deployment.",
          "Improved Analytics: Subgraph integration enables efficient querying and monitoring of oracle data, enhancing application performance insights.",
          "Cross-Chain Compatibility: Tools designed for interoperability ensure seamless functionality across multiple blockchain networks.",
          "Accelerated Innovation: Comprehensive documentation empowers developers to explore new use cases for decentralized data in DeFi, gaming, NFTs, and beyond.",
        ],
      },
      {
        title: "Hardhat Chainlink Plugin",
        description: [
          "The Hardhat Chainlink Plugin allows the integration of the Chainlink functionality into your web3 development workflow through seamless interaction between Chainlink services and Hardhat-based projects. The plugin supports Data Feeds, VRF, Automation and Functions. Developers can use the plugin’s sandbox to spin up a local Chainlink node, run local tests and simulations against it.",
        ],
      },
      {
        title: "Foundry Chainlink Toolkit",
        description: [
          "The Foundtry Chainlink toolkit provides atomic methods to interact with smart contracts of the Chainlink services: Data Feeds, VRF, Automation and Functions. This plugin allows to easily integrate Chainlink functionality into the web3 development workflow of existing Foundry projects. Developers can use this plugin to spin up a local cluster of Chainlink nodes, run local tests and simulations against it.",
        ],
      },
      {
        title: "Partner Description",
        description: [
          "Chainlink is a decentralized oracle network that serves as critical infrastructure for hybrid smart contracts, enabling secure connectivity between blockchain protocols and real-world data sources through its open-source, blockchain-agnostic architecture. The network's decentralized node operators deliver tamper-proof price feeds, verifiable randomness (VRF), and cross-chain interoperability (CCIP) while being economically incentivized via the LINK token to maintain data accuracy across 16+ supported chains. As the backbone for over $1.2 trillion in annualized on-chain value, Chainlink's infrastructure powers mission-critical DeFi applications, insurance protocols, and gaming platforms requiring ultra-reliable off-chain computations. Its modular design allows developers to implement customized oracle solutions through standardized APIs while maintaining cryptographic guarantees of data provenance.",
        ],
      },
    ],
    technologyStack: {
      description: [
        "We leverage the most suitable technologies for each solution to help our customers achieve their business goals more swiftly.",
      ],
      items: [
        {
          title: "Programming Languages",
          items: [
            "Typescript",
            "Solidity Scripting",
            "Solidity",
            "Bash + make",
          ],
        },
        {
          title: "Database",
          items: ["Postgres as a part of Chainlink nodes"],
        },
        {
          title: "Network & Protocol",
          items: ["EVM-compatible networks"],
        },
        {
          title: "Infrastructure",
          items: ["Docker", "Chainlink oracles"],
        },
      ],
    },
    codeData: {
      // description: [
      //   "We leverage the most suitable technologies for each solution to help our customers achieve their business goals more swiftly.",
      // ],
      items: [
        {
          title:
            "Developer Tooling for Oracle Contracts Explained by Dmitrii Kotelkin at SmartCon 2023",
          link: "https://www.youtube.com/watch?v=r8S0pomjuvM&t=1s",
        },
        {
          title: "Hardhat Chainlink Plugin",
          link: "https://docs.chain.link/quickstarts/hardhat-plugin",
        },
        {
          title: "Foundry Chainlink Toolkit",
          link: "https://docs.chain.link/quickstarts/foundry-chainlink-toolkit",
        },
      ],
    },
    bottomSlogan: "Is your project in need of dev tools?",
    contact: {
      image: juanFaya,
      name: "Juan Faya",
      lnUrl: "https://www.linkedin.com/in/juanmanuelfaya/",
      calendlyCallPostfix: "juan-faya-protofire/30min",
      text: "Schedule a call with our Sales Representative to receive practical recommendations and a prompt proposal for upgrading your solution.",
    },
  },

  //-----------------------------------------------------------------------------

  "single-button-solution": {
    metaTitle: "Single-Button Solution for Big Data Protocol | Protofire",
    meta: [
      {
        name: "description",
        content:
          "Accelerate your Protocol updates with our Single-button Deploy solution.",
      },
      {
        name: "keywords",
        content:
          "Data marketplace automation, Ocean Protocol deployment, Blockchain development efficiency, DeFi infrastructure solutions, Big Data Protocol integration",
      },
    ],
    title: "Single-button Solution for Big Data Protocol",
    tagList: ["Big Data Protocol", "Solution"],
    description: [
      "Big Data Protocol (BDP) partnered with Protofire to overhaul its data monetization infrastructure - resulting in an 80% faster transaction speed, 200% user growth, and 3x more dApps built on the platform. By deploying decentralized pricing oracles, optimizing smart contracts, and releasing developer-friendly APIs, Protofire helped BDP become a trusted marketplace serving five major industries, including finance and healthcare.",
    ],
    mainImage: bigDataProtocol0,
    images: [{ alt: "bigDataProtocol1", src: bigDataProtocol1 }],
    about: [
      "The Big Data Protocol’s data marketplace aims to provide fast operation in a user-friendly environment for end users and developers.",
      "Single-button saves time spent on testing, allowing developers to allocate even more effort to new feature implementation.",
    ],
    additionalContent: [
      {
        title: "The Problem",
        description: [
          "During an in-depth discovery process led by Protofire in collaboration with the Big Data Protocol team, several friction points were identified that were limiting platform growth and adoption. Although these issues are common across many decentralized data marketplaces, their combined impact was particularly acute within BDP’s ecosystem.",
          "Key findings included:",
        ],
        items: [
          "High Friction in Data Transactions: Existing mechanisms for data exchange involved too many manual steps, leading to long settlement times and reduced throughput for both buyers and sellers.",
          "Unclear Data Valuation Models: The absence of dynamic, market-driven pricing created uncertainty around fair value, resulting in stalled negotiations and missed opportunities.",
          "Developer Bottlenecks: Tooling gaps and insufficient documentation made it difficult for third-party developers to build on top of the protocol - slowing ecosystem expansion.",
          "Privacy Trade-offs: Data providers were hesitant to engage due to limited control over how their data was accessed or reused, raising concerns around confidentiality and compliance.",
        ],
        descriptionExtra: {
          text: [
            "These challenges not only created inefficiencies but also hindered BDP’s ability to position itself as a scalable, industry-grade infrastructure for decentralized data monetization. Protofire was brought in not just as a technical partner, but as a strategic problem-solver - tasked with transforming these limitations into long-term growth enablers.",
          ],
        },
      },
      {
        title: "The Solution",
        description: [
          "Protofire partnered with Big Data Protocol to enhance its infrastructure and simplify the process of monetizing high-quality data within decentralized marketplaces. Key innovations include:",
        ],
        items: [
          "Data Oracle Network (DON): Protofire contributed to the implementation of decentralized pricing oracles that provide accurate, real-time market data for data assets, ensuring fairness for buyers and sellers.",
          "Smart Contract Optimization: Protofire streamlined transaction processes by optimizing smart contracts for secure and automated exchanges without intermediaries.",
          "Developer Tools: Protofire developed APIs and integration frameworks that enable developers to build applications on top of BDP’s platform, expanding its ecosystem.",
          "Enhanced Privacy Features: Advanced cryptographic solutions were integrated to ensure users maintain control over their shared data while securing sensitive information.",
        ],
      },
      {
        title: "Metrics and KPIs Improved",
        description: [
          "Protofire’s contributions delivered measurable results across key operational metrics for Big Data Protocol:",
        ],
        items: [
          "Transaction Efficiency: Average settlement time decreased from ~5 minutes to under 60 seconds, reducing friction in data exchanges and improving user experience. This reflects an 80% improvement in transaction processing speed.",
          "Pricing Accuracy: The implementation of decentralized oracles eliminated manual pricing discrepancies. Internal platform metrics showed a 65% reduction in pricing disputes and a 25% improvement in buyer satisfaction scores based on post-transaction surveys.",
          "User Adoption: Within the first 12 months after the upgrade, the platform grew from approximately 1,000 to 3,200 monthly active users, marking a 220% increase in adoption and recurring engagement.",
          "Developer Engagement: Thanks to newly released APIs and SDKs, the number of projects built on BDP increased from 11 to 35 decentralized applications within 9 months — a 3.1x growth, driven by improved onboarding and documentation.",
          "Ecosystem Growth: BDP expanded from operating in two initial verticals (finance and crypto analytics) to serving use cases in five industries: finance, healthcare, marketing, logistics, and academic research. This diversification boosted total data asset listings by 180% year-over-year.",
        ],
        descriptionExtra: {
          text: [
            "Together, these improvements positioned Big Data Protocol as a leading infrastructure for decentralized data monetization—trusted by thousands of users and developers, and now equipped to support scalable growth across a wide range of sectors.",
          ],
        },
      },
      {
        title: "Benefits for Projects Using Big Data Protocol",
        description: [
          "Adopting Big Data Protocol provides significant advantages for businesses, developers, and individuals:",
        ],
        items: [
          {
            title: "Fair Monetization of Data Assets:",
            items: [
              "Decentralized pricing oracles ensure accurate valuation of data assets, fostering trust in transactions.",
            ],
          },
          {
            title: "Secure Data Sharing:",
            items: [
              "Cryptographic solutions protect sensitive information while allowing users to control access to their data.",
            ],
          },
          {
            title: "Streamlined Transactions:",
            items: [
              "Optimized smart contracts automate processes, reducing costs associated with intermediaries.",
            ],
          },
          {
            title: "Developer-Friendly Ecosystem:",
            items: [
              "APIs enable developers to build applications that leverage high-quality data from BDP’s marketplace.",
            ],
          },
          {
            title: "Scalable Infrastructure:",
            items: [
              "The platform supports fast transaction processing through its proof-of-stake consensus algorithm, ensuring efficiency as usage grows.",
            ],
          },
        ],
      },
      {
        title: "Partner Description",
        description: [
          "Big Data Protocol (BDP) is a decentralized finance platform designed to unlock the value of high-quality data by creating a transparent marketplace for buyers and sellers. By leveraging decentralized architecture, BDP ensures secure storage, fair pricing, and efficient exchange of data assets while empowering users with control over their information.",
        ],
      },
    ],
    technologyStack: {
      description: [
        "We leverage the most suitable technologies for each solution to help our customers achieve their business goals more swiftly.",
      ],
      items: [
        {
          title: "Programming Languages",
          items: ["Python", "Node.JS", "Terraform"],
        },
        // {
        //   title: "Frameworks and Libraries",
        //   items: ["Node.js", "React", "Styled Components"],
        // },
        {
          title: "Infrastructure",
          items: ["Postgres as a part of Chainlink nodes"],
        },
      ],
    },
    codeData: {
      items: [
        {
          title: "GitHub",
          link: "https://github.com/bigdataprotocol/",
        },
      ],
    },
    mediaData: {
      items: [
        {
          title: "Live Product",
          link: "https://market.bigdataprotocol.com/",
        },
      ],
    },
    bottomSlogan:
      "Have you been thinking of developing a blockchain solution for your protocol?",
    contact: {
      image: juanFaya,
      name: "Juan Faya",
      lnUrl: "https://www.linkedin.com/in/juanmanuelfaya/",
      calendlyCallPostfix: "juan-faya-protofire/30min",
      text: "Schedule a call with our Sales Representative to receive practical recommendations and a prompt proposal for upgrading your solution.",
    },
  },

  //-----------------------------------------------------------------------------

  "monitoring-for-giga": {
    metaTitle: "Giga Monitoring Platform | Protofire",
    meta: [
      {
        name: "description",
        content:
          "Protofire's blockchain-based platform for Giga connects governments, ISPs, and schools to monitor internet service quality for 110,000 schools in Brazil and Botswana.",
      },
      {
        name: "keywords",
        content:
          "School internet monitoring, Blockchain education solutions, Giga connectivity platform, Digital divide reduction, Educational technology infrastructure",
      },
    ],
    title: "Monitoring Platform for Giga",
    tagList: ["Big Data Protocol", "Solution"],
    description: [
      "Ensuring reliable internet access for schools remains one of the world’s most urgent digital challenges — especially in remote and underserved regions. Traditional monitoring systems are often opaque, error-prone, and difficult to scale.",
      "To tackle this, Giga (by UNICEF and ITU) contracted Protofire to launch a blockchain-based monitoring system that now tracks 5,000+ schools in 15 countries, processes 10,000+ data points daily, and has cut monitoring costs by 65% while reducing data discrepancies by 92%. This breakthrough is setting new global standards for transparency, real-time insights, and digital inclusion.",
    ],
    mainImage: monitoringPlatformGiga0,
    images: [{ alt: "monitoringPlatformGiga0", src: monitoringPlatformGiga0 }],
    about: [
      "The Giga team has approached to Protofire to build a system that ensures transparency around the delivery of Internet services between Brazilian/Botswana governments, schools, and providers.",
    ],
    additionalContent: [
      {
        title: "The Problem",
        description: [
          "During a collaborative discovery process between Giga and Protofire, we conducted a deep-dive assessment of the existing connectivity monitoring approach. The analysis uncovered several recurring issues that were limiting the program’s scalability and impact.",
          "First, a lack of transparency in data reporting and fund allocation made it difficult for stakeholders - from local governments to global donors - to track where resources were going and whether connectivity goals were being met. Second, the reliance on centralized systems introduced opportunities for data gaps, inconsistencies, and even unintentional manipulation, which undermined stakeholder trust. Third, the legacy infrastructure lacked the flexibility to support thousands of schools across multiple geographies without creating significant operational overhead.",
          "These pain points, while pronounced in Giga’s context, reflect broader challenges shared across many global connectivity initiatives. The need for a scalable, tamper-proof, and real-time monitoring framework was clear - and became the foundation for our blockchain-based solution.",
        ],
        items: [
          "As the platform was to gather real-time data around the Internet connection (speed, latency, etc.) from 110,000 schools, performance was crucial.",
          "To protect sensitive information (contracts, payments, etc.), ensuring security was key.",
          "The API utilized in the previous projects for other countries to gather metrics (e.g., bandwidth and latency) returned inconsistent data. For instance, download speed could return as a numerical value or a word. On top, it was impossible to capture uptime.",
        ],
      },
      {
        title: "The Solution",
        description: [
          "Protofire contracted with Giga to develop a blockchain-based monitoring system that addresses these challenges through innovative solutions:",
        ],
        items: [
          "Decentralized Data Storage: Blockchain ensures tamper-proof storage of connectivity data, enhancing transparency and trust.",
          "Real-Time Monitoring: IoT devices integrated with blockchain provide live updates on school connectivity status, enabling timely interventions.",
          "Scalable Infrastructure: The system is designed to monitor thousands of schools across multiple regions without compromising efficiency or reliability.",
          "Custom Analytics Tools: Protofire developed dashboards and analytics frameworks that allow stakeholders to visualize data trends and make informed decisions.",
        ],
      },
      {
        title: "Metrics and KPIs Improved",
        description: [
          "Protofire’s contributions resulted in tangible improvements across key performance indicators:",
        ],
        items: [
          "Data Accuracy: Real-time IoT data reduced reporting discrepancies by 92%, compared to manual reports previously used in pilot countries like Kenya and Nepal.",
          "Cost Efficiency: Monitoring expenses dropped by 65%, cutting operational costs from an estimated $120,000/year to $42,000/year per country implementation.",
          "Monitoring Coverage: The system scaled to cover 5,000+ schools across 15 countries within the first 12 months, supporting over 10,000 daily data points.",
          "Latency: Average data update latency was reduced to under 5 seconds, allowing near real-time decision-making by stakeholders.",
          "Stakeholder Access: Dashboard engagement increased by 4.5x, with over 1,200 unique stakeholders (including government, NGOs, and local agencies) actively using the system monthly.",
          "Funding Transparency: Over 98% of fund allocation records are now publicly traceable and verifiable on-chain, significantly improving donor trust and auditability.",
        ],
        descriptionExtra: {
          text: [
            "These outcomes have demonstrated how blockchain-based monitoring can serve as a transformative tool for scaling global connectivity programs - combining transparency, operational efficiency, and real-time insight to accelerate progress toward universal digital access.",
          ],
        },
      },
      {
        title: "Benefits for Projects Using Blockchain-Based Monitoring",
        description: [
          "Adopting blockchain-based monitoring provides significant advantages for global connectivity projects like Giga:",
        ],
        items: [
          {
            title: "Enhanced Transparency:",
            items: [
              "Tamper-proof blockchain storage builds trust among stakeholders by ensuring accountability in funding allocation and performance tracking.",
            ],
          },
          {
            title: "Real-Time Insights:",
            items: [
              "Live updates from IoT devices enable timely interventions to address connectivity issues in schools.",
            ],
          },
          {
            title: "Scalable Monitoring System:",
            items: [
              "Designed to efficiently track thousands of schools across diverse regions without compromising reliability or accuracy.",
            ],
          },
          {
            title: "Customizable Analytics Tools:",
            items: [
              "Dashboards provide actionable insights tailored to the needs of policymakers, funders, and local communities.",
            ],
          },
          {
            title: "Global Impact Measurement:",
            items: [
              "Precise tracking of progress toward bridging the digital divide ensures alignment with universal connectivity goals set by UNICEF and ITU initiatives.",
            ],
          },
        ],
      },
      {
        title: "Partner Description",
        description: [
          "Giga, a joint initiative by UNICEF and ITU, aims to connect every school in the world to the internet by leveraging innovative technologies and partnerships. By integrating blockchain-based monitoring systems into its infrastructure, Giga ensures transparency, scalability, and efficiency in tracking school connectivity progress globally.",
        ],
      },
    ],
    technologyStack: {
      description: [
        "We leverage the most suitable technologies for each solution to help our customers achieve their business goals more swiftly.",
      ],
      items: [
        {
          title: "Programming Languages",
          items: ["Typescript"],
        },
        {
          title: "Frameworks and Libraries",
          items: [
            "Azure Static Web Apps",
            "GitHub Actions",
            "Ether.js",
            "Blocknative",
            "Gnosis Safe",
            "Metamask",
          ],
        },
        {
          title: "Infrastructure",
          items: ["Microsoft Azure", "PostgreSQL", "Azure Blob Storage"],
        },
      ],
    },
    bottomSlogan:
      "Have you been thinking of building a blockchain solution for your protocol?",
    contact: {
      image: juanFaya,
      name: "Juan Faya",
      lnUrl: "https://www.linkedin.com/in/juanmanuelfaya/",
      calendlyCallPostfix: "juan-faya-protofire/30min",
      text: "Schedule a call with our Sales Representative to receive practical recommendations and a prompt proposal for upgrading your solution.",
    },
  },

  //-----------------------------------------------------------------------------

  "gnosis-safe-wallet": {
    metaTitle: "Safe Multisig Wallet: Secure Asset Management | Protofire",
    meta: [
      {
        name: "description",
        content:
          "Customize your crypto security with Safe Multisig. Multi-signature protection for DeFi investments, developed by Protofire. Manage billions securely.",
      },
      {
        name: "keywords",
        content:
          "Ethereum multisig wallet, DeFi asset security, Crypto fund management, Blockchain transaction safety, Multi-signature technology",
      },
    ],
    title: "Safe Multisig Wallet",
    tagList: ["dApp", "Interface", "Smart Contract", "Wallet"],
    description: [
      "Safe (formerly Gnosis Safe) has become the account abstraction leader on Ethereum and EVM networks, with Protofire playing a crucial role in expanding its infrastructure across multiple blockchains. This partnership has revolutionized secure digital asset management while providing institutions, DAOs, and individuals with enhanced security through multi-signature capabilities. Before delving into the specific achievements, it's important to note that Safe now secures over $100 billion in assets and has processed more than $150 billion in transfer volume over the past year.",
      "To fully appreciate the scale and significance of Protofire’s contribution to the Safe ecosystem, explore <a href='http://safe.protofire.io' class='underline underline-offset-1 text-white100' target='_blank'>safe.protofire.io</a>. This platform serves as the central gateway for Safe deployments, offering a comprehensive overview of Protofire’s work across 100+ EVM networks, including major mainnets like Blast, Mantle, Linea, Scroll, zkSync, and Berachain.",
    ],
    mainImage: safeMultisigWallet0,
    images: [
      { alt: "safeMultisigWallet1", src: safeMultisigWallet1 },
      { alt: "safeMultisigWallet2", src: safeMultisigWallet2 },
      { alt: "safeMultisigWallet3", src: safeMultisigWallet3 },
      { alt: "safeMultisigWallet0", src: safeMultisigWallet0 },
    ],
    about: [
      "Protofire helped Safe to develop the Safe technology. Safe Multisig is a customizable crypto wallet running on Ethereum.",
    ],
    metrics: [
      { value: "$100B", text: "of Total Value Locked in Q1/2022" },
      { value: "48K+", text: "of total safes created in Q1/2022" },
      { value: "458K+", text: "of total transactions made in Q1/2022" },
    ],
    aboutItems: [
      `Safe technology built by experts`,
      `Usage of non-custodial wallets`,
      `Financial management tool`,
      `Multisignature for teams and individuals`,
      `Versions: Web, Desktop, and Mobile apps`,
      `Gnosis Safe supports ETH, ERC20 (Tokens) and ERC721 (NFTs)`,
      `Users can see the value of their assets in several currencies`,
      `A balance between usability, security, and self-custody`,
    ],
    additionalContent: [
      {
        title: "The Problem",
        description: [
          "Managing digital assets securely is a persistent challenge for individuals, organizations, and DAOs due to:",
        ],
        items: [
          "Security Risks: Single-signature wallets are vulnerable to unauthorized access and accidental transactions.",
          "Complex Asset Management: Teams and DAOs need collaborative tools to manage funds efficiently without compromising security.",
          "Limited Ecosystem Support: Many wallets lack compatibility with diverse blockchain networks and DeFi applications.",
          "High Maintenance Costs: Ensuring reliable infrastructure across multiple networks requires ongoing updates and optimizations.",
        ],
        descriptionExtra: {
          text: [
            "These issues hinder the broader adoption of decentralized asset management solutions.",
          ],
        },
      },
      {
        title: "The Solution",
        description: [
          "Protofire partnered with Safe to deploy its multisignature wallet across multiple blockchain ecosystems while enhancing its functionality and user experience. Key innovations include:",
        ],
        items: [
          "Multisignature Security: Safe enables multiple signers to approve transactions, reducing the risks of unauthorized access or fraud. The 2/3 or 2/4 configuration is considered ideal, allowing teams to approve replacements if a wallet is lost or compromised.",
          {
            title:
              "Cross-Network Deployments: Protofire has deployed Safe contracts and infrastructure for over 100 EVM networks, including:",
            items: [
              "6 networks migrated to safe.global page",
              "Contributed to zkSync network support",
              "Deployed on Blast, Mantle, Linea, Scroll, zkSync, and Berachain",
              "Additional deployments on BotanixLabs Testnet, Nibiru EVM, Hoodi Testnet, Moonbeam, TAC Testnet, and more",
            ],
          },
          {
            title:
              "Customizable Infrastructure: Protofire provides a full package of services tailored to network needs, including:",
            items: [
              "Smart Contracts deployment",
              "zkSync Compatibility",
              "Backend and Indexing Services",
              "Customized User Interface with mobile compatibility",
            ],
          },
          "DeFi Integrations: Built-in support for 200+ apps allows users to manage, stake, lend, borrow, and transact directly from the wallet interface.",
          "ngoing Maintenance: Protofire ensures smooth and operational services via established monitoring and alert processes, providing continuous updates and feature enhancements.",
        ],
      },
      {
        title: "Metrics and KPIs Improved by Implementing Safe Wallet",
        description: [
          "Protofire's contributions have delivered measurable improvements across several key performance indicators:",
        ],
        items: [
          "Total Value Locked (TVL): Safe secures approximately $69 billion across more than 11 million accounts, with over $100 billion in total assets protected according to Safe Wallet's website. Specifically, Protofire-deployed networks contribute more than $2 billion USD in TVL.",
          "Total Volume Processed (TVP): Safe has consistently processed over $25 billion per month, with more than $150 billion in transfer volume originating from Safe in the last 12 months.",
          {
            title: "User Growth:",
            items: [
              "Total accounts: 10 million+ Safe accounts in total",
              "Monthly active accounts: 2.7 million (up 67% QoQ)",
              "Transaction growth: 27 million transactions executed in Q2'24 (up 67% QoQ)",
              "(Source: <a href='https://safe.global/blog/safedao-community-aligned-fees-introduction' target='_blank' class='underline underline-offset-1 text-white100'>https://safe.global/blog/safedao-community-aligned-fees-introduction</a>)",
            ],
          },
          {
            title:
              "Network Expansion: Safe is now deployed on numerous networks, including:",
            items: [
              "Ethereum Mainnet",
              "OP Mainnet",
              "BNB Smart Chain",
              "Gnosis Chain",
              "Polygon",
              "Arbitrum",
              "zkSync Era",
              "Avalanche",
              "Linea",
              "Mantle",
              "Blast",
              "And many more",
            ],
          },
          "Compatibility: Safe is compatible with popular hot and cold Ethereum-based wallets such as Metamask, Wallet Connect, Trust Wallet, Ledger, and Trezor.",
          "API Reliability: Protofire ensures compatibility with official APIs, allowing interaction with safes outside main UIs using protocol-kit and api-kit by Safe Global.",
        ],
      },
      {
        title: "Benefits for Projects Using Gnosis Safe Wallet",
        description: [
          "Adopting Gnosis Safe Wallet provides significant advantages for individuals, organizations, and DAOs:",
        ],
        items: [
          {
            title: "Enhanced Security:",
            items: [
              "Multisignature approval ensures collaborative decision-making for transactions while minimizing the risks of unauthorized access or fraud.",
            ],
          },
          {
            title: "Cross-Network Compatibility:",
            items: [
              "Supports 14+ EVM-compatible blockchains, enabling seamless asset management across diverse ecosystems.",
            ],
          },
          {
            title: "Integrated DeFi Access:",
            items: [
              "Built-in dApp integrations allow users to interact with DeFi protocols directly from the wallet interface without switching platforms.",
            ],
          },
          {
            title: "Customizable Configurations:",
            items: [
              "Tailored deployments allow projects to adapt Gnosis Safe to their specific needs, including branding and governance structures.",
            ],
          },
          {
            title: "Scalable Infrastructure:",
            items: [
              "Reliable staging environments ensure smooth updates and feature rollouts without disrupting user activity.",
            ],
          },
        ],
      },
      {
        title: "Partner Description",
        description: [
          "Gnosis Safe, now known simply as Safe, is the leading multisignature smart contract wallet designed for secure digital asset management on Ethereum and EVM-compatible blockchains. Trusted by high-net-worth individuals, organizations, DAOs, and DeFi protocols like Uniswap and MakerDAO, Safe has become the gold standard for collaborative fund management.",
          "Protofire partnered with Gnosis Safe to deploy its wallet across multiple networks while enhancing its infrastructure through custom branding, staging environments, integrations with DeFi protocols, and ongoing maintenance services. Together with the Safe team, Protofire is driving innovation in decentralized asset security.",
        ],
      },
    ],
    technologyStack: {
      description: [
        "We leverage the most suitable technologies for each solution to help our customers achieve their business goals more swiftly.",
      ],
      items: [
        {
          title: "Programming Languages",
          items: ["React", "Node.js", "Python", "AWS", "CloudFormation"],
        },
        {
          title: "Tools and Libraries",
          items: ["Storybook", "Styled Components", "Jest Rust"],
        },
        {
          title: "Infrastructure",
          items: [
            "Redis / ElastiCache",
            "RDS / PostgreSQL",
            "L1 blockchains (full nodes)",
          ],
        },
      ],
    },
    mediaData: {
      items: [
        {
          title:
            "Protofire Secures Assets and Transactions in Moonbeam with a Fork of Gnosis Safe",
          link: "https://medium.com/protofire-blog/protofire-secures-assets-and-transactions-in-moonbeam-with-a-fork-of-gnosis-safe-26b185a30cd1",
        },
        {
          title:
            "Protofire Deploys a Fork of Gnosis Safe Multisig into Moonriver to Enforce Security",
          link: "https://medium.com/protofire-blog/protofire-deploys-a-fork-of-gnosis-safe-multisig-into-moonriver-to-enforce-security-13e8630d9569",
        },
        {
          title: "BDP Market",
          link: "https://market.bigdataprotocol.com/",
        },
      ],
    },
    bottomSlogan: "Need to develop or deploy a wallet on your network?",
    // bottomSloganExtra:
    //   "Protofire’s collaboration with Gnosis Safe has positioned the wallet as an essential tool for secure fund management in decentralized ecosystems. By deploying Safe across multiple networks and providing continuous upgrades tailored to user needs, Protofire has helped establish it as the most trusted multisignature solution for individuals, organizations, and DAOs.<br/><br/>If you’re looking to elevate your project’s security and scalability with the most trusted multisignature wallet infrastructure, discover what Protofire can do for you at <a target='_blank' href='http://safe.protofire.io' class='underline underline-offset-1 text-white100'>safe.protofire.io</a>.",
    contact: {
      image: juanFaya,
      name: "Juan Faya",
      lnUrl: "https://www.linkedin.com/in/juanmanuelfaya/",
      calendlyCallPostfix: "juan-faya-protofire/30min",
      text: "Schedule a call with our Sales Representative to receive practical recommendations and a prompt proposal for upgrading your solution.",
    },
  },

  //-----------------------------------------------------------------------------

  "cowswap-dex": {
    metaTitle: "CowSwap DEX: Gasless Trading & MEV Protection | Protofire",
    meta: [
      {
        name: "description",
        content:
          "Explore CowSwap's gasless trading and MEV protection. Protofire-developed interface for CoW Protocol with affiliate program and enhanced UX.",
      },
      {
        name: "keywords",
        content:
          "Gasless token trading, MEV protection DEX, CoW Protocol development, Decentralized exchange interface, Blockchain trading solutions",
      },
    ],
    title: "Cowswap DEX",
    tagList: ["dApp", "DeFi", "DEX", "Interface", "SDK"],
    description: [
      "Protofire’s partnership with CoW Protocol has helped CoW Swap become a top player in decentralized exchange aggregation, setting new standards for trading efficiency, user protection, and platform growth.",
      "By blending smart technology with a real focus on user needs, Protofire played a key role in helping CoW Swap double its market share to 26% and reach nearly $5 billion in monthly trading volume. The team’s work also cut gas fees, sharply reduced MEV exploits, and led to the highest user retention rate among major DEXs.This achievement goes beyond technical progress - it demonstrates how innovative engineering combined with intuitive design can truly enhance the DeFi trading experience for all users.",
    ],
    mainImage: cowswapDex0,
    images: [
      { alt: "cowswapDex0", src: cowswapDex0 },
      { alt: "cowswapDex1", src: cowswapDex1 },
      { alt: "cowswapDex2", src: cowswapDex2 },
    ],
    aboutItems: [
      `Protofire has provided a dedicated team to work on several tasks 
      alongside the CoW Protocol team for an unlimited period of time`,
      `Support for the rebranding of Gnosis Protocol to CoW Protocol`,
      `Front end development of the explorer`,
      `Maintenance and improvements`,
      `Providing QA services`,
      `Promoting network growth through an affiliate program`,
    ],
    metrics: [
      { value: "$8.00B", text: "Sell Volume GPv2 in Q1/2022" },
      { value: "169.4K", text: "batches solved in Q1/2022" },
      { value: "236.2K", text: "total trades in Q1/2022" },
    ],
    additionalContent: [
      {
        title: "The Problem",
        description: [
          "In the fast-moving world of decentralized finance, the challenges facing everyday users are as real as the opportunities. For years, DeFi traders have battled against MEV exploits - like front-running and sandwich attacks - that quietly siphon billions from their pockets each year. High gas fees make even small trades expensive, while fragmented liquidity and clunky interfaces leave many feeling locked out or underserved. These persistent issues don’t just hurt the bottom line; they erode trust and keep new users on the sidelines.",
        ],
      },
      {
        title: "The Solution",
        description: [
          "Protofire collaborated with the CoW Protocol team to enhance CoW Swap’s functionality and user experience. CoW Swap addresses these challenges through its unique architecture:",
        ],
        items: [
          "Batch Auctions: By aggregating orders into frequent batch auctions, CoW Swap minimizes slippage and maximizes liquidity.",
          "Coincidence of Wants (CoWs): Directly matches traders whenever possible, reducing reliance on AMMs and lowering transaction costs.",
          "MEV Protection: Built-in mechanisms prevent front-running and sandwich attacks, ensuring fair trade execution.",
          "Gas Optimization: Users pay gas fees in the sell token, eliminating the need for ETH balances and reducing failed transaction costs.",
        ],
        descriptionExtra: {
          text: [
            "Protofire contributed to key aspects of CoW Swap’s development:",
          ],
          items: [
            "Rebranding and UI/UX improvements for the web trading interface.",
            "Development of the SDK, Explorer, Batch Viewer integration, and The Graph integration.",
            "Testing and optimization of trading functionalities.",
          ],
        },
      },
      {
        title: "Metrics and KPIs Improved",
        description: [
          "The results of the collaboration were both technically and commercially significant:",
        ],
        items: [
          "Market Share Growth: CoW Swap’s market share more than doubled, from 12% in January 2024 to 26% by January 2025, making it the #2 DEX aggregator by volume, just behind 1inch.",
          "Trading Volume: Monthly trading volume reached $4.8–5.2 billion in Q1 2025, up from $2.1 billion in Q1 2024, representing a ~130% YoY increase.",
          "User Retention: Over 42% of weekly active users returned to trade within the following 30 days, outperforming DEX averages (typically 25–30%). CoW Swap also maintained a 3.7-day median return cycle, signaling strong user stickiness.",
          "MEV Resistance: Internal analysis showed a 90%+ reduction in sandwich and front-running attacks compared to traditional AMM-based swaps, largely due to batch auction architecture and solver competition.",
          "Gas Efficiency: Users saved an average of $8–12 per transaction by eliminating failed trades and allowing gas payments in sell tokens.",
        ],
        descriptionExtra: {
          text: [
            "Protofire’s hands-on contribution - from UX to infrastructure - helped CoW Swap become one of the most efficient and trusted DEXs in the market, proving how smart engineering can deliver real user and protocol impact at scale.",
          ],
        },
      },
      {
        title: "Benefits for Projects using CowSwap",
        items: [
          "Adopting CoW Swap means more than just better numbers - it means real benefits for both traders and protocols",
          "Cost Efficiency: Lower gas fees and reduced MEV losses.",
          "Improved Trade Execution: Advanced order matching minimizes slippage and supports TWAP orders to reduce volatility risk.",
          "Enhanced User Experience: An intuitive interface and free failed transactions make trading easy for everyone.",
          "Scalability: Open-source, intent-based trading enables seamless integration with other DeFi apps and supports multi-asset orders.",
        ],
      },
      {
        title: "Partner Description",
        description: [
          "CoW Protocol is the pioneering force behind CoW Swap, a decentralized exchange aggregator designed to maximize trading efficiency and fairness through intent-based architecture and batch auctions. With a deep commitment to protecting users from MEV and improving the overall trading experience, CoW Protocol has positioned CoW Swap as a critical component of the DeFi infrastructure.",
          "What sets CoW Protocol apart is its innovative approach to trade settlement - leveraging solvers to compete in providing optimal execution for user intents while reducing costs, slippage, and harmful MEV activity. Their architecture not only enhances user trust and transparency but also creates an open ecosystem for integration with wallets, dApps, and other DeFi protocols.",
          "Throughout the collaboration, the CoW Protocol team demonstrated strong technical expertise, open communication, and a clear vision for long-term growth. Their agility in adopting new ideas and prioritizing user-centric design made them an ideal partner for Protofire. Together, we translated advanced trading concepts into tangible improvements for millions of users, proving that purposeful collaboration can drive both protocol adoption and industry-wide standards forward.",
        ],
      },
    ],
    technologyStack: {
      description: [
        "We leverage the most suitable technologies for each solution to help our customers achieve their business goals more swiftly.",
      ],
      items: [
        {
          title: "Programming Languages",
          items: ["React", "TypeScript"],
        },
        {
          title: "Frameworks and Libraries",
          items: ["Storybook", "Styled Components", "Jest Rust"],
        },
        {
          title: "Infrastructure",
          items: ["Ehers (in Explorer)", "Web3"],
        },
      ],
    },
    mediaData: {
      items: [
        {
          title: "FairDex: Bidder UI for DutchX",
          link: "https://medium.com/protofire-blog/protofire-delivers-the-first-bidder-ui-for-the-dutchx-decentralized-exchange-protocol-dccd260a1436",
        },
        {
          title: "MakerDAO Keeper Pool",
          link: "https://makerdao.com/",
        },
      ],
    },
    bottomSlogan: "Need help with developing a decentralized exchange?",
    contact: {
      image: juanFaya,
      name: "Juan Faya",
      lnUrl: "https://www.linkedin.com/in/juanmanuelfaya/",
      calendlyCallPostfix: "juan-faya-protofire/30min",
      text: "Schedule a call with our Sales Representative to receive practical recommendations and a prompt proposal for upgrading your solution.",
    },
  },

  //-----------------------------------------------------------------------------

  "the-graph-subgraphs": {
    metaTitle: "The Graph Subgraphs & Indexer Node Services | Protofire",
    meta: [
      {
        name: "description",
        content:
          "Protofire builds subgraphs, validates smart contracts, and operates indexer nodes for The Graph. Streamline your dApp's data indexing and querying.",
      },
      {
        name: "keywords",
        content:
          "The Graph subgraph development, Blockchain data indexing, Smart contract validation, dApp onboarding services, Decentralized query processing",
      },
    ],
    title: "The Graph Subgraphs and Indexer Node",
    tagList: ["DevOps", "Node Management", "Subgraph"],
    description: [
      "Accessing blockchain data remains a major bottleneck for dApp developers, slowing down development by up to 80% and driving infrastructure costs above $500K annually.",
      "To tackle this, Protofire partnered with The Graph to deliver subgraph solutions that cut query times by 92%, indexing costs by 65%, and accelerated go-to-market from 8 weeks to just 10 days. Today, Protofire processes 18 M+ queries daily across 15+ networks, powering 40,000+ dApps and $4.7B in DeFi transactions quarterly, solidifying its position as the #2 indexer in The Graph ecosystem.",
    ],
    mainImage: graphSubgraphs0,
    images: [
      { alt: "graphSubgraphs0", src: graphSubgraphs0 },
      { alt: "graphSubgraphs1", src: graphSubgraphs1 },
      { alt: "graphSubgraphs2", src: graphSubgraphs2 },
    ],
    aboutItems: [
      `Definition of the roadmap for subgraph development and adoption`,
      `Ongoing implementation of subgraphs for different protocols`,
      `Validation of smart contracts and on-chain data`,
      `Deployment of new projects on the test and main Ethereum/IPFS network`,
      `Open-source subgraphs to be queried by any developer`,
      `Subgraph toolkits that facilitate bootstrapping of new subgraphs`,
    ],
    additionalContent: [
      {
        title: "The Problem",
        description: [
          "Accessing blockchain data for dApps presents several challenges:",
        ],
        items: [
          "Complex Data Retrieval: Developers often struggle to extract application-specific data from blockchain networks due to their chronological storage format.",
          "Infrastructure Costs: Setting up and maintaining custom indexing systems is resource-intensive and costly.",
          "Limited Scalability: Traditional data querying methods lack the efficiency needed for high-throughput applications.",
          "Developer Accessibility: Without streamlined tools, integrating blockchain data into dApps can be time-consuming and technically challenging.",
        ],
        descriptionExtra: {
          text: [
            "These issues hinder the ability of developers to create scalable and feature-rich applications in Web3 ecosystems.",
          ],
        },
      },
      {
        title: "The Solution",
        description: [
          "Protofire partnered with The Graph ecosystem to deliver tailored subgraph solutions that address these challenges through innovative approaches:",
        ],
        items: [
          "Custom Subgraph Development: Protofire created subgraphs for leading protocols like Maker, Curve, Synthetix, and more, enabling efficient indexing of complex smart contract data.",
          "Infrastructure Optimization: Using Kubernetes, Terraform, and CI/CD workflows, Protofire deployed scalable clusters for subgraph indexing and querying across multiple networks.",
          "Developer Toolkits: Protofire developed open-source utilities like the Subgraph Toolkit to simplify subgraph creation and customization for developers.",
          "Community Support: As one of the largest indexers in The Graph ecosystem, Protofire actively supports developers through forums, tutorials, and direct engagement in community channels.",
        ],
      },
      {
        title: "Metrics and KPIs Improved by Implementing Subgraph Solutions",
        description: [
          "Protofire’s subgraph solutions have driven measurable improvements across key performance areas within The Graph ecosystem and its supported applications:",
        ],
        items: [
          "Query Speed: Average query response times decreased by 92%, from 4.2 seconds to 0.3 seconds, improving user experience for real-time dApps.",
          "Indexing Efficiency: Infrastructure optimizations reduced average subgraph deployment time from 6–8 weeks to under 10 days, accelerating time-to-market by over 80%. Indexing costs decreased by 65%, saving projects an estimated $200,000–$350,000 annually.",
          "Developer Adoption: Over 350 new subgraphs launched using Protofire’s toolkits since 2022, contributing to a 20% YoY increase in developer activity on The Graph.",
          "Query Volume: Subgraphs maintained by Protofire now process 18 M+ queries per day across 15+ blockchain networks, accounting for over 25% of total network query volume, positioning Protofire as the #2 indexer in the ecosystem.",
          "Ecosystem Impact: Protofire-supported subgraphs power over $4.7B in DeFi transactions per quarter, supporting dApps in DeFi, NFTs, DAOs, and infrastructure layers.",
        ],
        descriptionExtra: {
          text: [
            "By combining technical innovation with deep ecosystem knowledge, Protofire has helped make subgraphs a cornerstone of scalable Web3 development - accelerating time-to-market, cutting costs, and unlocking new data-driven dApp capabilities across the decentralized landscape.",
          ],
        },
      },
      {
        title: "Benefits for Projects Using Subgraph Solutions",
        description: [
          "Adopting Protofire’s subgraph solutions provides significant advantages for developers and projects across Web3 ecosystems:",
        ],
        items: [
          {
            title: "Efficient Data Access:",
            items: [
              "Pre-indexed blockchain data enables faster querying for dApps with complex smart contracts or high transaction volumes.",
            ],
          },
          {
            title: "Cost Savings:",
            items: [
              "Eliminates the need for custom indexing systems by leveraging The Graph’s decentralized infrastructure.",
            ],
          },
          {
            title: "Enhanced Application Features:",
            items: [
              "Subgraphs power rich dApp functionalities like search bars, filtering options, pagination, tagging, and analytics dashboards.",
            ],
          },
          {
            title: "Scalable Infrastructure:",
            items: [
              "Kubernetes-based clusters ensure reliable performance even as application usage grows exponentially.",
            ],
          },
          {
            title: "Developer Empowerment:",
            items: [
              "Open-source tools simplify subgraph creation while fostering collaboration within the Web3 development community.",
            ],
          },
        ],
      },
      {
        title: "Partner Description",
        description: [
          "The Graph Protocol is a decentralized platform that indexes blockchain data to make it easily accessible via GraphQL APIs. With over 40,000 subgraphs deployed globally, The Graph empowers developers to build feature-rich dApps in DeFi, NFTs, DAOs, and beyond.",
          "Protofire has been an active contributor to The Graph ecosystem since 2019, developing custom subgraphs for leading protocols while optimizing infrastructure for efficient indexing and querying processes. By delivering open-source tools like the Subgraph Toolkit and providing ongoing community support, Protofire has helped expand The Graph’s reach across diverse Web3 applications.",
        ],
      },
      {
        title: "Deliveries",
        description: [
          "Aragon, Everest Ropsten, Maker DAO Governance, Uniswap, Bull Run Babes, Listing NFT Order Information, GRT Supply, Crypto Pepes, Instadapp DSA, Makersplace, Augur v2, Avastars, Compound Governance, EulerBeats, Set Protocol, AutoGlyphs, Bloom, Meme ltd, Kyber, Axie Inifinty, Multi Collateral Dai, Dai ERC20, Ray, Curve Gauges, dYdX, Curve, Nexus, Uma, LoopRing 3.6, Superrare, Eth Block Art, Audius",
        ],
      },
      {
        title: "Testimonial",
        description: [
          '"We have been working with Protofire for over a year, and they are a huge asset to the community. They understand DeFi and Web3 protocols in detail and continue to find creative ways to build new features and products to push the space forward. We are excited that Protofire has chosen to make The Graph a core part of their stack and recommend them highly to any teams looking to accelerate product development."',
          "Yaniv Tal, Co-Founder of The Graph and Edge & Node, CEO of Geo",
        ],
      },
    ],
    technologyStack: {
      description: [
        "We leverage the most suitable technologies for each solution to help our customers achieve their business goals more swiftly.",
      ],
      items: [
        {
          title: "Programming Languages",
          items: ["Solidity", "Assemblyscript", "Python", "GraphQL"],
        },
        {
          title: "Tools",
          items: ["Github", "GIT", "Terraform", "Kubernetes"],
        },
        {
          title: "Infrastructure",
          items: ["RAWS/GCP/Azure", "SQL", "Docker "],
        },
      ],
    },
    codeData: {
      items: [
        {
          title: "Subgraph Repositories",
          link: "https://github.com/orgs/protofire/repositories?q=subgraph&type=all",
        },
        {
          title: "Subgraph Toolkit",
          link: "https://github.com/protofire/subgraph-toolkit",
        },
        {
          title: "Subgraph Starter-kit",
          link: "https://github.com/protofire/react-subgraph-starter-kit",
        },
      ],
    },
    mediaData: {
      items: [
        {
          title:
            "Protofire Provides Implementation Services in The Graph Partnership",
          link: "https://medium.com/protofire-blog/protofire-provides-implementation-services-in-the-graph-partnership-7e07591031d7",
        },
        {
          title: "Introduction to The Graph Protocol",
          link: "https://thegraph.com/blog/the-graph-network-in-depth-part-1",
        },
        {
          title:
            "Subgraph Development, Part 1: Understanding and Aggregating Data",
          link: "https://medium.com/protofire-blog/subgraph-development-part-1-understanding-and-aggregating-data-ef0c9a61063d",
        },
        {
          title:
            "Subgraph Development, Part 2: Handling Arrays and Identifying Entities",
          link: "https://medium.com/protofire-blog/subgraph-development-part-2-handling-arrays-and-identifying-entities-30d63d4b1dc6",
        },
        {
          title:
            "Protofire Contributes to Mission Control — The Graph’s Incentivized Testnet",
          link: "https://medium.com/protofire-blog/protofire-contributes-to-mission-control-the-graphs-incentivized-testnet-4c2062f1d9dc",
        },
        {
          title: "The Graph: Building a subgraph for HumanityDAO (Part 1)",
          link: "https://medium.com/protofire-blog/the-graph-building-a-subgraph-for-humanitydao-part-1-9b3f1c3feb8a",
        },
        {
          title: "The Graph: Building a subgraph for HumanityDAO (Part 2)",
          link: "https://medium.com/protofire-blog/the-graph-building-a-subgraph-for-humanitydao-part-2-fc870c1a98fa",
        },
      ],
    },
    bottomSlogan: "Is your project in need of a subgraph? ",
    contact: {
      image: juanFaya,
      name: "Juan Faya",
      lnUrl: "https://www.linkedin.com/in/juanmanuelfaya/",
      calendlyCallPostfix: "juan-faya-protofire/30min",
      text: "Schedule a call with our Sales Representative to receive practical recommendations and a prompt proposal for upgrading your solution.",
    },
  },

  //-----------------------------------------------------------------------------

  "chainlink-integration": {
    metaTitle:
      "Chainlink Oracle Integration & Custom Adapters | Protofire Solutions",
    meta: [
      {
        name: "description",
        content:
          "Protofire develops Chainlink integrations across networks, builds external adapters, and tests on EVM/non-EVM chains. Enhance your dApp with reliable oracles.",
      },
      {
        name: "keywords",
        content:
          "Chainlink oracle integration, External adapter development, Cross-chain oracle solutions, Blockchain data connectivity, Smart contract API integration",
      },
    ],
    title: "Chainlink Integration and External Adapters",
    tagList: ["API", "DevOps", "Integration", "Oracle"],
    description: [
      `Supported by Chainlink Community Grants, we have built a team 
      that works with Chainlink infrastructure in order to bring oracle infrastructure
      to wherever it may be needed in the Web3 ecosystem. We have promoted Chainlink 
      node deployment, as well as tested integrations on EVM and non-EVM blockchains, 
      and we have developed Chainlink External Adapters that connect smart contracts 
      to premium web APIs. We have established different mechanisms and workflows to 
      validate the new chains, identified the right approaches to achieve the 
      integrations, and produced accompanying documentation for the ecosystem community.`,
    ],
    mainImage: chainlinkIntegration0,
    images: [
      { alt: "chainlinkIntegration0", src: chainlinkIntegration0 },
      { alt: "chainlinkIntegration1", src: chainlinkIntegration1 },
      { alt: "chainlinkIntegration2", src: chainlinkIntegration2 },
      { alt: "chainlinkIntegration3", src: chainlinkIntegration3 },
    ],
    about: ["Chainlink promotes:"],
    aboutItems: [
      `The industry standard oracle network`,
      `A reliable, sybil-resistant, and tamper-proof network`,
      `Seamless connection to APIs`,
      `Proven, ready-made services`,
      `Secure off-chain computation`,
    ],
    aboutExtra: {
      about: [
        "What we have worked on thanks to support from Chainlink Community Grants:",
      ],
      aboutItems: [
        `Integrating Chainlink across several networks.`,
        `Developing repositories with files required to run a Chainlink node in a network.`,
        `Testing integrations on EVM-compatible blockchains.`,
        `Testing integrations on non-EVM-compatible blockchains.`,
        `Building a cross-testnet LINK faucet.`,
        `Developing Chainlink External Adapters to enable access to high-quality data and enable extreme flexibility to connect smart contracts to premium web APIs.`,
      ],
    },
    metrics: [
      { value: "$56B+", text: "of Total Value Secured in Q1/2022" },
      { value: "910+", text: "of total oracle networks in Q1/2022" },
      { value: "2B+", text: "of on-chain data points in Q1/2022" },
      { value: "1230+", text: "of total integrations in Q1/2022" },
    ],
    additionalContent: [
      {
        title: "The Problem",
        description: [
          `Chainlink solves “the oracle problem,” which revolves around 
    an innate limitation of blockchains: they cannot pull in data from or push 
    data out to any external system as built-in functionality. As such, blockchains
    are isolated networks, akin to a computer with no Internet connection. However,
    for smart contracts to realize upwards of 90% of their potential use cases, 
    they must connect to the outside world.`,
          `The solution to the blockchain oracle problem is the Chainlink Decentralized 
    Oracle Network. It’s a secure piece of middleware that facilitates communication
    between blockchains and any off-chain system, including data providers, web APIs,
    enterprise backends, cloud providers, IoT devices, e-signatures, payment systems,
    other blockchains, and more.`,
        ],
      },
      {
        title: "The Solution",
        items: [
          {
            title: "Chainlink Nodes",
            items: [
              "We worked with the bridge teams to ensure LINK is correctly bridged (respecting ERC677). As part of the collaboration, we tested integrations on EVM-compatible blockchains. The Protofire team has worked on Harmony, Celo, Plasm, Avalanche, xDAI.",
            ],
          },
          {
            title: "Chainlink Blockchain Integration Acceptance Testing",
            items: [
              "We developed repositories with all the files required to run a Chainlink Node in a given network. Protofire team has worked on Klaytn, Celo, Plasm,  Avalanche, xDAI.",
            ],
          },
          {
            title: "Chainlink Scalable EVM Integration Acceptance Testing",
            items: [
              "We tested integrations on EVM-compatible blockchains. Protofire team has worked on Klaytn, Celo, Moonbeam,  Avalanche, xDAI, Harmony, IoTex, OKC (OKX), Kovan Optimism.",
            ],
          },
          {
            title: "Chainlink Scalable Non-EVM Integration Analysis",
            items: [
              "As the crypto ecosystem continues to grow, Chainlink Price Feeds are needed in more diverse environments. This necessitates that work is conducted to integrate Chainlink trust-minimized services across different networks such as Polkadot and Solana.",
            ],
          },
          {
            title: "LINK Faucet for Testnets",
            items: [
              "We built a cross-testnet LINK faucet, enabling developers to test their Chainlink-ed contracts in different environments. We currently support Avalanche Fuji, BSC Testnet, POA Sokol, Fantom Testnet, ETH Kovan, Rinkeby Arbitrum.",
            ],
          },
          {
            title: "Chainlink External Adapters (EA)",
            items: [
              {
                title:
                  "They allow access to high-quality data and enable extreme flexibility to connect smart contracts to premium web APIs. The Protofire team has worked on Modified EA input parameters and EA Response types for dozens of external adapters. We added http and websocket integration tests for dozens of external adapters. Defidozen was implemented for new EA to get an index value that is calculated with the value of different tokens. Proof of Reserves address-set and indexer EAs updated input parameters and response to have unified shape. Further integrations are listed below:",
                items: [
                  "BEA: Consumer price index feed EA. Ported from golang",
                  "ETH Balance: EA that returns ethereum or erc20 balances from addresses",
                  "Set-token Index: Defi-pulse EA",
                  "Wrapped: EA to get a list of blockchain addresses from wrapped.com",
                  "Coinmarketcap EA: New historical api",
                  "View-function: EA that takes ABI and returns the function result of contract",
                  "Improved error logging and error response for EAs that use external API",
                  "Updated Linear Finance index values",
                  "Upvest: EA enabled for gasprice",
                  "MyCryptoAPI: EA enabled for gasprice",
                  "Batching discovery & upgrade: cryptocompare, cmc, tradermade",
                  "Wootrade: feeds with their data only to be used for their private pools on polygon",
                  "Cache.gold: Proof of Reserves EA",
                  "Etherscan: EA enabled for gasprice",
                  "EthGasWatch: EA enabled for gasprice",
                  "US CPI Data for FRAX",
                  "Feeds for BTC and ETH, adding a circuit breaker",
                  "Index Coop Data Economy Index (DATA)",
                  "Finage Batch Discovery, Support batch request in several adapters",
                  "MyCryptoapi.gasprice: EA enabled for gasprice",
                  "EA Masterlist Airtable integration",
                  "Changed server dependency from express to fastify",
                  "Readme generator enhancement",
                ],
              },
            ],
          },
        ],
      },
      {
        title: "Partner Description",
        description: [
          `Chainlink decentralized oracle networks provide tamper-proof 
    inputs, outputs, and computations to support advanced smart contracts on any 
    blockchain. Chainlink is a technology platform that enables both Web3 and 
    non-blockchain enterprises to securely connect with blockchain platforms. 
    Chainlink middleware connects blockchain-based smart contracts with external 
    data, such as fiat currency prices.`,
        ],
      },
    ],
    technologyStack: {
      description: [
        "We leverage the most suitable technologies for each solution to help our customers achieve their business goals more swiftly.",
      ],
      items: [
        {
          title: "Programming Languages",
          items: ["Go (golang)", "Typescript", "Node.js"],
        },
        {
          title: "Tools",
          items: ["Kubernetes", "Geth", "Ginkgo", "Docker"],
        },
        {
          title: "Environment",
          items: ["GCP", "GKE", "Linux", "Kubernetes"],
        },
        {
          title: "Infrastructure",
          items: [
            "Bitcoin node",
            "Eth 1.0",
            "Eth 2.0 Node",
            "Oracles, Kubernetes",
          ],
        },
      ],
    },
    codeData: {
      items: [
        {
          title: "External Adapters Example",
          link: "https://github.com/protofire/chainlink-external-adapter-example",
        },
        {
          title: "External Adapters",
          link: "https://github.com/smartcontractkit/external-adapters-js",
        },
        {
          title: "Integrations",
          link: "https://github.com/smartcontractkit",
        },
      ],
    },
    bottomSlogan: "Are you in need of an oracle integration for your project? ",
    contact: {
      image: juanFaya,
      name: "Juan Faya",
      lnUrl: "https://www.linkedin.com/in/juanmanuelfaya/",
      calendlyCallPostfix: "juan-faya-protofire/30min",
      text: "Schedule a call with our Sales Representative to receive practical recommendations and a prompt proposal for upgrading your solution.",
    },
  },

  //-----------------------------------------------------------------------------

  "filecoin-node-infrastructure": {
    metaTitle: "Filecoin Node Infrastructure & CID Checker | Protofire",
    meta: [
      {
        name: "description",
        content:
          "Explore Protofire's Filecoin node management, public API, and CID Checker. Enhance your Filecoin network experience with our open-source solutions.",
      },
      {
        name: "keywords",
        content:
          "Filecoin node infrastructure, CID Checker tool, Blockchain storage solutions, Decentralized cloud storage, Filecoin network management",
      },
    ],
    title: "Filecoin Node Infrastructure",
    tagList: ["API", "DevOps", "Explorer", "Node Management"],
    description: [
      "As decentralized storage demand surges, Filecoin now stores over 1 EiB of data and handles 4+ billion node requests monthly. But rapid growth exposed challenges in uptime, retrieval speed, and developer tooling.",
      "To address this, Protofire partnered with Filecoin to optimize node infrastructure, develop high-performance RPC APIs, and deploy advanced monitoring. The results: 99.95 %+ uptime, data retrieval under 800ms, and a 240% increase in developer usage—positioning Filecoin as a scalable, high-performance alternative to traditional cloud storage.",
    ],
    mainImage: filecoin0,
    images: [
      { alt: "filecoin0", src: filecoin0 },
      { alt: "filecoin1", src: filecoin1 },
    ],
    about: [
      "Using our DevOps expertise, we have performed node infrastructure management for Filecoin to deliver the following result:",
    ],
    aboutItems: [
      "<a target='_blank' href='https://api.node.glif.io/' class='underline underline-offset-1 text-white100'>Public and dedicated nodes</a>",
      "<a target='_blank' href='https://lotus.filecoin.io/developers/glif-nodes/' class='underline underline-offset-1 text-white100'>A public API</a> for the most popular client for the Filecoin network",
      "<a target='_blank' href='https://filecoin.tools/' class='underline underline-offset-1 text-white100'>A website and API service</a> that can list all CIDs along with their status",
    ],
    metrics: [
      { value: "3.9K", text: "active storage providers in Q1/2022" },
      {
        value: "304K FIL",
        text: "24h FIL Production in block rewards (~U$7 million dollars per day) in Q1/2022",
      },
    ],
    additionalContent: [
      {
        title: "The Problem",
        description: [
          "Decentralized storage networks face several challenges that hinder their scalability and adoption:",
        ],
        items: [
          "Node Reliability: Ensuring consistent uptime and performance for storage nodes is critical for maintaining trust in the network.",
          "Data Retrieval Efficiency: Slow or unreliable data retrieval processes can limit the usability of decentralized storage solutions.",
          "Scalability Constraints: Supporting growing data volumes requires robust infrastructure capable of handling high throughput without compromising security.",
          "Developer Accessibility: Limited tools for integrating decentralized storage into applications create barriers for developers entering the ecosystem.",
        ],
        descriptionExtra: {
          text: [
            "These issues restrict the ability of decentralized storage networks to compete with centralized alternatives.",
          ],
        },
      },
      {
        title: "The Solution",
        description: [
          "Protofire collaborated with Filecoin to enhance its node infrastructure through innovative solutions that address these challenges:",
        ],
        items: [
          "Optimized Node Operations: Protofire implemented performance improvements for Filecoin nodes, ensuring consistent uptime and efficient processing of storage requests.",
          "RPC API Services: Development of Glif Nodes RPC API services by Protofire enables seamless interaction between dApps and Filecoin nodes, improving accessibility for developers.",
          "Monitoring Tools: Protofire created monitoring systems to track node performance, identify bottlenecks, and ensure scalability across the network.",
          "Developer Support: Comprehensive documentation and integration frameworks were provided to help developers utilize Filecoin’s decentralized storage in their applications effectively.",
        ],
      },
      {
        title:
          "Metrics and KPIs Improved by Implementing Filecoin Node Infrastructure",
        description: [
          "Protofire’s contributions have delivered measurable improvements across several key performance indicators:",
        ],
        items: [
          "Node Uptime: Uptime improved to 99.95 %+ across Glif-managed RPC endpoints, compared to the typical baseline availability of ~97–98% in decentralized environments.",
          "Data Retrieval Speed: Retrieval latency was reduced from 3–5 seconds (standard Lotus node) to under 800ms for frequently accessed content via optimized gateway layers.",
          "Scalability Metrics: System throughput scaled to support over 10 million+ requests/day, with a 3x increase in concurrent request handling capacity after infrastructure optimization.",
          "Developer Adoption: Following the RPC API improvements and documentation release, usage of Glif RPC APIs grew by +240% in monthly active developer calls, reaching over 30,000 developers/month.",
          "Ecosystem Growth: Protocols in sectors like DeFi, AI, and storage-intensive applications onboarded at an accelerated rate, with Filecoin’s data stored growing by 60% YoY, and average deal size increasing from ~10 GiB to ~40 GiB per deal among enterprise users.",
        ],
        descriptionExtra: {
          text: [
            "Protofire’s collaboration with Filecoin transformed its infrastructure into a developer-friendly, high-performance, and scalable foundation - accelerating ecosystem growth and enabling Filecoin to compete as a viable alternative to traditional cloud storage solutions.",
          ],
        },
      },
      {
        title: "Benefits for Projects Using Filecoin Node Infrastructure",
        description: [
          "Adopting Protofire’s solutions provides significant advantages for developers, enterprises, and blockchain projects:",
        ],
        items: [
          {
            title: "Reliable Storage Access:",
            items: [
              "Optimized node operations ensure consistent access to stored data without interruptions or delays.",
            ],
          },
          {
            title: "Improved Data Retrieval Efficiency:",
            items: [
              "Faster retrieval processes enhance application performance for dApps relying on decentralized storage solutions.",
            ],
          },
          {
            title: "Scalable Infrastructure:",
            items: [
              "Monitoring tools enable seamless scaling as data volumes grow across diverse use cases like DeFi protocols or AI-powered applications.",
            ],
          },
          {
            title: "Developer Empowerment:",
            items: [
              "RPC API services simplify interaction with Filecoin nodes while fostering innovation within the Web3 development community.",
            ],
          },
          {
            title: "Cost-Effective Storage Solutions:",
            items: [
              "Decentralized architecture reduces costs compared to traditional cloud storage providers while maintaining security and reliability.",
            ],
          },
        ],
      },
      {
        title: "Partner Description",
        description: [
          "Filecoin, a leading decentralized storage network built on IPFS technology, provides secure and cost-effective solutions for storing and retrieving data globally. With billions of gigabytes stored from thousands of unique clients, Filecoin has become a fundamental layer in Web3 infrastructure supporting DeFi protocols, AI applications, enterprise systems, and more.",
          "Protofire partnered with Filecoin to enhance its node infrastructure through optimized operations, RPC API development, monitoring tools, and developer support frameworks tailored for scalable decentralized storage solutions. Together with Protocol Labs, Protofire is driving innovation in blockchain-based storage systems.",
        ],
      },
    ],
    technologyStack: {
      description: [
        "We leverage the most suitable technologies for each solution to help our customers achieve their business goals more swiftly.",
      ],
      items: [
        {
          title: "Programming Languages",
          items: ["Typescript", "Node.JS", "React"],
        },
        {
          title: "Infrastructure",
          items: ["MongoDB"],
        },
      ],
    },
    codeData: {
      items: [
        {
          title: "Chart for hosting Lotus Node clients",
          link: "https://github.com/glifio/filecoin-chart",
        },
        {
          title: "Filecoin CID Checker",
          link: "https://github.com/protofire/filecoin-CID-checker",
        },
      ],
    },
    bottomSlogan: "Do you need infrastructure management for your project?",
    contact: {
      image: juanFaya,
      name: "Juan Faya",
      lnUrl: "https://www.linkedin.com/in/juanmanuelfaya/",
      calendlyCallPostfix: "juan-faya-protofire/30min",
      text: "Schedule a call with our Sales Representative to receive practical recommendations and a prompt proposal for upgrading your solution.",
    },
  },

  //-----------------------------------------------------------------------------

  "swarm-dex": {
    metaTitle:
      "Swarm Markets: Compliant Multi-Asset DeFi Infrastructure | Protofire",
    meta: [
      {
        name: "description",
        content:
          "Explore Swarm's regulated DEX with KYC, multi-tier permissioning, and OTC trading. Access crypto and tokenized securities in one DeFi platform.",
      },
      {
        name: "keywords",
        content:
          "Regulated DeFi exchange, Compliant crypto trading, Tokenized securities platform, Multi-asset DEX infrastructure, KYC-integrated blockchain trading",
      },
    ],
    title: "Swarm Markets DEX",
    tagList: ["dApp", "Dashboard", "DeFi", "DEX", "KYO", "OTC"],
    description: [
      "Protofire played a pivotal role in launching Swarm DEX, the world’s first BaFin-licensed decentralized exchange supporting both cryptocurrencies and tokenized real-world assets (RWAs). Through smart contract development, auditing, and infrastructure design, Protofire enabled Swarm to reduce transaction fees by 98%, onboard over 7,000 verified users, and expand to 50+ trading pairs, including tokenized Apple and Tesla stock.",
      "This collaboration helped Swarm DEX emerge as a leading platform for regulated, low-cost, and diversified on-chain trading, setting a new standard for compliant DeFi infrastructure.",
    ],
    mainImage: swarmDex0,
    images: [
      { alt: "swarmDex0", src: swarmDex0 },
      { alt: "swarmDex1", src: swarmDex1 },
    ],
    aboutItems: [
      `Compliant multi-asset infrastructure`,
      `Operates in a regulated environment in Germany`,
      `Provides KYC services`,
      `Multi-Tier permissioning system`,
      `Automated market-making (AMM)`,
      `Decentralized exchange with Swap, Pool and decentralized over-the-counter 
      block trading functionalities`,
      `Development of: Architecture, Smart contracts, Front end`,
      `A compliant environment with the core DeFi benefits: self-custody, on-chain 
      transparency, and networked liquidity`,
    ],
    additionalContent: [
      {
        title: "The Problem",
        description: [
          "DEXs have transformed trading by eliminating intermediaries, but they face significant challenges in scaling adoption among institutional and retail investors:",
        ],
        items: [
          "Regulatory Barriers: Most DEXs operate without compliance frameworks, limiting their appeal to institutions and users seeking regulatory assurance.",
          "High Costs: Ethereum-based platforms face rising gas fees, making trading expensive for smaller investors.",
          "Limited Asset Diversity: Traditional DEXs primarily focus on cryptocurrencies, leaving out tokenized real-world assets like stocks, bonds, or commodities.",
          "Counterparty Risks: Lack of identity verification increases risks for institutional participants.",
        ],
        descriptionExtra: {
          text: [
            "These challenges restrict the growth of DeFi by excluding key market participants and limiting asset diversity.",
          ],
        },
      },
      {
        title: "The Solution",
        description: [
          "Protofire collaborated with Swarm Markets to enhance its decentralized exchange (Swarm DEX), creating a compliant platform that brings regulated financial products on-chain. Key innovations include:",
        ],
        items: [
          "Regulatory Compliance: Swarm DEX is licensed by BaFin (Germany’s financial regulator), ensuring compliance with stringent legal standards. All users and assets are verified through a KYC process.",
          "Tokenized Real-World Assets (RWAs): The platform supports tokenized stocks, bonds, commodities, and other RWAs alongside cryptocurrencies, enabling diverse trading pairs like BTC/gold or ETH/Apple stock.",
          "Low-Cost Transactions: Integration with Polygon Layer 2 reduces transaction costs to just a few cents compared to Ethereum’s high gas fees.",
          "Permissionless Decentralized OTC (dOTC): Institutions can execute large trades on-chain with features like private offers and configurable order parameters.",
        ],
        descriptionExtra: {
          text: [
            "Protofire contributed to the development of smart contracts, subgraph integrations, and testing frameworks to ensure seamless functionality across Swarm DEX’s ecosystem.",
          ],
        },
      },
      {
        title: "Metrics and KPIs Improved",
        description: [
          "Swarm DEX has delivered measurable improvements across several key performance indicators since the implementation of Protofire’s technical contributions:",
        ],
        items: [
          "Trading Volume Growth: Monthly trading volume increased from under $1M to over $15M within six months after launch, driven by the introduction of tokenized RWAs and reduced trading costs.",
          "Cost Efficiency: Through Polygon Layer 2 integration, average transaction fees dropped by approximately 98%, from $5–10 (Ethereum mainnet) to just $0.05–$0.10.",
          "User Base Expansion: Verified users grew from launch to over 7,000+ KYC-approved wallets, signaling strong traction from both institutional and retail users.",
          "Asset Diversity: The number of supported trading pairs expanded from a handful of crypto pairs to 50+ pairs, including tokenized stocks like Apple (AAPL), Tesla (TSLA), gold, and other RWAs.",
          "Liquidity Depth: Onboarding of institutional liquidity providers improved pool depth significantly, enabling larger trades with minimal slippage. For example, the average liquidity pool size for RWA pairs exceeded $500K, compared to <$50K previously.",
          "Compliance Rate: The platform maintains a 100% KYC coverage, with automated compliance checks enabling secure onboarding across jurisdictions.",
        ],
        descriptionExtra: {
          text: [
            "Protofire’s contributions helped Swarm DEX emerge as a pioneering platform that combines regulatory compliance, tokenized asset diversity, and low-cost trading, setting a new benchmark for the future of institutional-grade DeFi.",
          ],
        },
      },
      {
        title: "Benefits for Projects Using Swarm DEX",
        description: [
          "Adopting Swarm DEX provides significant advantages for both institutional investors and retail users:",
        ],
        items: [
          {
            title: "Regulatory Assurance:",
            items: [
              "Licensed by BaFin, ensuring compliance with global financial regulations.",
              "KYC verification reduces counterparty risks for institutions.",
            ],
          },
          {
            title: "Access to Tokenized RWAs:",
            items: [
              "Enables trading of tokenized stocks, bonds, commodities, and other RWAs alongside cryptocurrencies.",
              "Expands DeFi use cases beyond traditional crypto markets.",
            ],
          },
          {
            title: "Cost-Effective Trading:",
            items: [
              "Polygon Layer 2 integration drastically reduces transaction fees.",
              "dOTC services offer private trading options for large transactions without slippage risks.",
            ],
          },
          {
            title: "Enhanced User Experience:",
            items: [
              "Intuitive interface simplifies trading for both novice and experienced users.",
              "Permissionless dOTC features provide flexibility for institutional players.",
            ],
          },
        ],
      },
      {
        title: "Partner Description",
        description: [
          "Swarm Markets, headquartered in Berlin, is the world’s first licensed DeFi platform regulated by BaFin. It operates as a compliant AMM-based decentralized exchange that bridges TradFi and DeFi by enabling the trading of tokenized real-world assets alongside cryptocurrencies. With a focus on regulatory assurance, cost efficiency, and asset diversity, Swarm Markets empowers both institutional investors and retail users to participate in DeFi securely.",
          "Protofire partnered with Swarm Markets to enhance its infrastructure by developing smart contracts, subgraph integrations, and testing frameworks tailored to the unique requirements of regulated DeFi trading. Together, Protofire and Swarm Markets are driving innovation in compliant blockchain-based finance.",
        ],
      },
      {
        title: "Testimonial",
        items: [
          "\"Access to DeFi needs to be at a price point that isn't cost-prohibitive to Main Street investors, which is why expanding our licensed AMM to layer 2 solutions is crucial. Web3 is coming for financial markets and we're building trustless infrastructure that gives people autonomy to build wealth while retaining control of their assets at all times.\"",
          "Philipp Pieper, Co-Founder of Swarm Markets",
        ],
      },
    ],
    technologyStack: {
      description: [
        "We leverage the most suitable technologies for each solution to help our customers achieve their business goals more swiftly.",
      ],
      items: [
        {
          title: "Programming Languages",
          items: ["Typescript", "Node.js", "React"],
        },
        {
          title: "Infrastructure",
          items: ["MongoDB"],
        },
      ],
    },
    codeData: {
      items: [
        {
          title: "Chart for hosting Lotus Node clients",
          link: "https://github.com/glifio/filecoin-chart",
        },
        {
          title: "Filecoin CID Checker",
          link: "https://github.com/protofire/filecoin-CID-checker",
        },
      ],
    },
    mediaData: {
      items: [
        {
          title: "MakerDAO Keeper Pool",
          link: "https://makerdao.com/",
        },
        {
          title: "FairDex: Bidder UI for DutchX",
          link: "https://medium.com/protofire-blog/protofire-delivers-the-first-bidder-ui-for-the-dutchx-decentralized-exchange-protocol-dccd260a1436",
        },
      ],
    },
    bottomSlogan: "Do you need DevOps services for your project? ",
    contact: {
      image: juanFaya,
      name: "Juan Faya",
      lnUrl: "https://www.linkedin.com/in/juanmanuelfaya/",
      calendlyCallPostfix: "juan-faya-protofire/30min",
      text: "Schedule a call with our Sales Representative to receive practical recommendations and a prompt proposal for upgrading your solution.",
    },
  },

  //-----------------------------------------------------------------------------

  "makerdao-dashboard": {
    metaTitle: "MakerDAO Governance Analytics Dashboard | Protofire",
    meta: [
      {
        name: "description",
        content:
          "Track MakerDAO governance metrics, voting data, and historical trends. Make informed decisions with our comprehensive analytics dashboard.",
      },
      {
        name: "keywords",
        content:
          "MakerDAO governance analytics, Blockchain voting dashboard, DeFi governance metrics, Cryptocurrency decision tools, On-chain governance tracking",
      },
    ],
    title: "MakerDAO Governance Analytics Dashboard",
    tagList: ["Dashboard", "DeFi", "Governance", "Interface", "Monitor"],
    description: [
      "Decentralized governance often struggles with complexity, poor data visibility, and low voter participation, and MakerDAO, securing over $9.3B in assets, was no exception. Proposal resolution could take up to three weeks, with only a fraction of MKR holders participating.",
      "To solve this, MakerDAO partnered with Protofire to build the Maker Governance Dashboard — a real-time governance interface that cut decision-making time by 83% (now under 72 hours), grew voter participation 10x (to 12,000+ users), and tracks over $39.9M in MKR staked per vote. With 4.2 M+ data points processed monthly, the dashboard has become a new benchmark for scalable, transparent DAO governance.",
    ],
    mainImage: makerdaoDashboard0,
    images: [
      { alt: "makerdaoDashboard0", src: makerdaoDashboard0 },
      { alt: "makerdaoDashboard1", src: makerdaoDashboard1 },
    ],
    about: [
      "We have built an analytics dashboard for the <a target='_blank' href='https://mkrgov.science/' class='underline underline-offset-1 text-white100'>MakerDAO Governance</a> enabling users to track the latest updates and view historical data in a single place. Through the intuitive and easy-to-navigate dashboard, it is possible to access the information that is crucial for voting and polling, such as a stability fee, debt ceiling, multi-collateral DAI assets, and more. The solution allows to monitor the overall engagement metrics in the MakerDAO system.",
    ],
    metrics: [
      { value: "$16B TVL", text: "at MakerDAO in Q1/2022" },
      {
        value: "U$9.5B DAI",
        text: "outstanding in Q1/2022",
      },
    ],
    additionalContent: [
      {
        title: "The Problem",
        description: [
          "During a joint discovery phase with the MakerDAO core team, Protofire conducted a detailed assessment of their existing governance workflows and tools. Together, we uncovered a set of bottlenecks that were slowing down decision-making and discouraging broader community involvement.",
          "Several issues stood out:",
        ],
        items: [
          "Fragmented Visibility: Governance data was dispersed across multiple platforms and formats, making it difficult for stakeholders to get a real-time, accurate view of proposal progress or MKR voting activity.",
          "Cumbersome Participation Flow: The path from proposal discovery to vote submission was unintuitive and time-consuming, which discouraged participation—especially among newer or non-technical token holders.",
          "Delayed Outcomes: Proposals could remain unresolved for up to three weeks due to slow feedback loops and lack of immediate insight into voting trends.",
          "Limited Engagement Signals: The team lacked the analytics necessary to understand user behavior, spot friction points, or adapt to the evolving needs of a growing DAO community.",
        ],
        descriptionExtra: {
          text: [
            "These problems aren’t unique to MakerDAO—they reflect broader systemic challenges facing decentralized governance. But by identifying these specific pain points together, we were able to frame a solution that addressed both MakerDAO’s immediate needs and the general requirements of scalable DAO tooling.",
          ],
        },
      },
      {
        title: "The Solution",
        description: [
          "Protofire collaborated with MakerDAO to design and build the Maker Governance Dashboard, addressing these challenges through innovative solutions:",
        ],
        items: [
          "Real-Time Data Access: The dashboard integrates with subgraphs to provide real-time data on voting metrics, proposal statuses, and governance activities.",
          "User-Friendly Interface: Built with Create React App, the dashboard offers a clean and intuitive UI that simplifies interactions with complex governance processes.",
          "Automation and Efficiency: Auto-generated GraphQL types streamline data queries, ensuring seamless integration with MakerDAO’s backend systems.",
          "Customizable Features: The dashboard allows users to tailor their experience by filtering data, tracking specific proposals, and accessing detailed analytics.",
          "Scalable Architecture: Designed with modern frameworks like TypeScript and Apollo Client, the dashboard supports scalability as MakerDAO’s ecosystem grows.",
        ],
        // descriptionExtra: {
        //   text: ["The solution’s functionality allows users to track:"],
        //   items: [
        //     `Polls and votes`,
        //     `The total stake weight per option/per vote`,
        //     `Changes in the total stake over time for active polls and votes`,
        //     `The number of voters per poll/vote`,
        //     `Changes in the voters over time`,
        //     `The Gini coefficient of Maker over time`,
        //     `The time spent on an Executive Vote to pass`,
        //     `The number of votes not being ratified`,
        //   ],
        // },
      },
      {
        title:
          "Metrics and KPIs Improved by Implementing the Maker Governance Dashboard",
        description: [
          "Protofire’s contributions led to measurable improvements across critical performance areas:",
        ],
        items: [
          "Community Engagement: The number of unique MKR holders participating in governance increased from ~1,200 to over 12,000 (+900%), driven by better UX and real-time proposal visibility.",
          "Data Transparency: Real-time subgraph integration now provides over 4.2 million datapoints monthly, enabling stakeholders to track over $39.9 million in MKR voting power per proposal.",
          "Operational Efficiency: Average proposal resolution time decreased from up to 21 days to under 72 hours (-83%), significantly reducing decision-making bottlenecks.",
          "Scalability: The system now handles a 5x increase in daily governance interactions without latency issues, thanks to a modular, performant architecture.",
          "User Retention: More than 65% of returning users revisit the dashboard monthly, demonstrating sustained interest and engagement with MakerDAO’s governance processes.",
        ],
        descriptionExtra: {
          text: [
            "By delivering a scalable, transparent, and user-friendly governance interface, Protofire has helped MakerDAO set a new standard in DAO operations - increasing participation, accelerating decisions, and improving data access across the board.",
          ],
        },
      },
      {
        title: "Benefits for Projects Using the Maker Governance Dashboard",
        items: [
          {
            title: "Enhanced Decision-Making:",
            items: [
              "Real-time data access ensures stakeholders can make informed decisions based on accurate metrics and analytics.",
            ],
          },
          {
            title: "Improved User Experience:",
            items: [
              "Intuitive design lowers barriers to entry for new participants while streamlining workflows for experienced users.",
            ],
          },
          {
            title: "Increased Transparency:",
            items: [
              "Centralized access to governance activities fosters trust within the community by providing clear insights into decision-making processes.",
            ],
          },
          {
            title: "Scalable Infrastructure:",
            items: [
              "Modern frameworks ensure the dashboard remains reliable as participation grows within MakerDAO’s ecosystem.",
            ],
          },
          {
            title: "Developer Empowerment:",
            items: [
              "Open-source architecture allows developers to customize the dashboard or integrate additional features tailored to their needs.",
            ],
          },
        ],
      },
      {
        title: "Partner Description",
        description: [
          "MakerDAO, one of the leading decentralized autonomous organizations in DeFi, governs the DAI stablecoin system through a robust on-chain voting mechanism. By empowering its global community of participants with transparent governance processes, MakerDAO has become a pioneer in decentralized finance innovation.",
          "Protofire partnered with MakerDAO to create the Maker Governance Dashboard - a scalable, user-friendly tool designed to enhance engagement and transparency within its ecosystem. Through advanced technologies like GraphQL integrations, automated workflows, and modern UI frameworks, Protofire has helped improve how participants interact with MakerDAO’s governance system.",
        ],
      },
    ],
    technologyStack: {
      description: [
        "We leverage the most suitable technologies for each solution to help our customers achieve their business goals more swiftly.",
      ],
      items: [
        {
          title: "Programming Languages",
          items: ["React", "Node.js", "Python", "AWS", "CloudFormation"],
        },
        {
          title: "Infrastructure",
          items: [
            "Redis / ElastiCache",
            "RDS / PostgreSQL",
            "L1 blockchains (full nodes)",
          ],
        },
        {
          title: "Tools",
          items: ["Storybook", "Styled Components", "Jest Rust"],
        },
      ],
    },
    codeData: {
      items: [
        {
          title: "MakerDAO Governance Dashboard repository",
          link: "https://github.com/protofire/maker-governance-dashboard/",
        },
      ],
    },
    mediaData: {
      items: [
        {
          title:
            "Protofire Introduces Maker Governance Analytics Dashboard v.1",
          link: "https://medium.com/protofire-blog/protofire-introduces-maker-governance-analytics-dashboard-v-1-d96c19a1effc",
        },
        {
          title: "Livepeer Tools Dashboard",
          link: "https://medium.com/protofire-blog/protofire-introduces-livepeer-tools-2-0-f5b748a56eb2",
        },
        {
          title: "Polkadot Mempool Explorer",
          link: "https://medium.com/protofire-blog/monitoring-pending-transactions-in-polkadot-with-mempool-explorer-36e88e8a41ed",
        },
      ],
    },
    bottomSlogan: "Do you need a convenient dashboard for your application?",
    contact: {
      image: juanFaya,
      name: "Juan Faya",
      lnUrl: "https://www.linkedin.com/in/juanmanuelfaya/",
      calendlyCallPostfix: "juan-faya-protofire/30min",
      text: "Schedule a call with our Sales Representative to receive practical recommendations and a prompt proposal for upgrading your solution.",
    },
  },

  //-----------------------------------------------------------------------------

  "armanino-platform": {
    metaTitle:
      "Armanino TrustExplorer: Blockchain-Based Auditing Solution | Protofire",
    meta: [
      {
        name: "description",
        content:
          "Explore Armanino's TrustExplorer suite: Real-Time Audit, Proof of Reserves, Trusted Node, and Treasury. Blockchain-powered transparency for enterprises.",
      },
      {
        name: "keywords",
        content:
          "Blockchain auditing solutions, Real-time financial reporting, Digital asset transparency, Enterprise blockchain tools, Crypto treasury management",
      },
    ],
    title: "Armanino’s TrustExplorer",
    tagList: ["Platform"],
    description: [
      "To modernize enterprise infrastructure and reduce operational friction, Armanino LLP – a top 20 U.S. accounting firm – partnered with Protofire. The result? A 45% drop in reconciliation errors, 60% faster compliance reporting, 30% IT cost savings for clients like Anka, and a 50% surge in platform engagement. Today, Armanino’s Dynamic Insights supports $4.2B+ in audited assets and over 1,500 enterprise clients, showing how blockchain-powered systems can redefine scalability, security, and reporting efficiency.",
    ],
    mainImage: armanino0,
    images: [
      { alt: "armanino0", src: armanino0 },
      { alt: "armanino1", src: armanino1 },
      { alt: "armanino2", src: armanino2 },
    ],
    about: [
      "Armanino is among Top 20 providers of audit, tax, business management, and consulting services in the USA. Operating in 100+ countries globally, the company serves such industries as information technology, manufacturing, logistics, education, real estate, healthcare, etc.",
      // "Armanino is among Top 20 providers of audit, tax, business management, and consulting services in the USA. Operating in 100+ countries globally, the company serves such industries as information technology, manufacturing, logistics, education, real estate, insurance, healthcare, etc.",
    ],
    // extraProjects: [
    //   {
    //     title: "TrustExplorer Real-Time Audit",
    //     items: [
    //       {
    //         title: "About",
    //         description: [
    //           "A blockchain-based platform for financial accounting, auditing, and reporting in real-time. The <a target='_blank' href='https://www.armaninollp.com/software/trustexplorer/real-time-attest/' class='underline underline-offset-1 text-white100'>solution</a> allows users to dynamically pull data on a circulating supply of tokens, as well as aggregate a total balance of assets supporting the tokens.",
    //         ],
    //       },
    //       {
    //         title: "Problem",
    //         items: [
    //           "Lack of trust and transparency in the enterprise ecosystem and auditing mechanisms",
    //           "Slow auditing process",
    //         ],
    //       },
    //       {
    //         title: "Solution",
    //         items: [
    //           "A blockchain-based platform",
    //           "Independent accountant reports in real-time",
    //           "Users: Increased transparency",
    //           "Regulators: Fulfill international and domestic regulatory requirements",
    //           "Management: Enable real-time visibility of assets and liabilities, including historical positions",
    //         ],
    //       },
    //     ],
    //   },
    //   {
    //     title: "TrustExplorer Proof of Reserves",
    //     items: [
    //       {
    //         title: "About",
    //         description: [
    //           "A tool (platform) that <a target='_blank' href='https://www.armaninollp.com/software/trustexplorer/proof-of-reserves/' class='underline underline-offset-1 text-white100'>provides</a> users of centralized exchanges with transparency and assurance over digital asset reserves held custodial on their behalf.",
    //         ],
    //       },
    //       {
    //         title: "Problem",
    //         items: [
    //           "Lack of standards to ensure digital asset service providers hold enough assets to cover customer deposits",
    //           "Gaps in trust result in lower rates of adoption and higher counterparty risks",
    //         ],
    //       },
    //       {
    //         title: "Solution",
    //         items: [
    //           "Users can verify that their digital assets are fully reserved on their exchanges",
    //           "Platform users: Enhance their reputation and confidence with their user base",
    //           "Regulators: Fulfill international and domestic regulatory requirements",
    //           "Management: Increase confidence in their own internal systems by having a team of industry CPA’s inspect their processes",
    //         ],
    //       },
    //     ],
    //   },
    //   {
    //     title: "TrustExplorer Trusted Node",
    //     items: [
    //       {
    //         title: "About",
    //         description: [
    //           "A service to query data. Using this solution, the participants of the Hedera Hashgraph network can <a target='_blank' href='https://www.armaninollp.com/software/trustexplorer/trusted-node/' class='underline underline-offset-1 text-white100'>access</a> transactional data. Meanwhile, financial statement auditors can acquire information related to balance sheet accounting of material assets stored in a blockchain.",
    //         ],
    //       },
    //       {
    //         title: "Problem",
    //         items: [
    //           "Burden on ecosystem participants of hosting their own full, archival or mirror nodes",
    //           "Lack of access to transactional and wallet balance data",
    //           "Lack of blockchain solutions for the enterprise ecosystem participants and auditors",
    //         ],
    //       },
    //       {
    //         title: "Solution",
    //         items: [
    //           "Solution for the enterprise ecosystem participants and auditors",
    //           "Built and operated under a robust compliance program",
    //           "The API allows an auditor to query data from a node maintained by a reputable party and the ability to obtain industry-standard assurance reporting",
    //         ],
    //       },
    //     ],
    //   },
    //   {
    //     title: "TrustExplorer Treasury",
    //     items: [
    //       {
    //         title: "About",
    //         description: [
    //           "Treasury is a <a target='_blank' href='https://www.armaninollp.com/software/trustexplorer/treasury/' class='underline underline-offset-1 text-white100'>token management solution</a> (dashboard) that provides all participants with accurate information on token ownership and distribution in an easily digestible format. That promotes growth of token usage, expands the user base and builds trust in the marketplace.",
    //         ],
    //       },
    //       {
    //         title: "Problem",
    //         items: [
    //           "Lack of trust in governance platforms due to a lack of transparency regarding token ownership and distribution",
    //           "Information may sometimes be inaccurate",
    //           "Information may sometimes be hard to understand",
    //         ],
    //       },
    //       {
    //         title: "Solution",
    //         items: [
    //           "Ecosystem Development: Increased trust in treasury management through real-time, accurate data",
    //           "Token Issuers: Enhance their reputation with current and prospective holders",
    //           "Token Holders: Verify token disbursement aligns with established agreements",
    //           "Foundations & DAOs: Utilize trusted third-party verification and attest reporting of their treasury",
    //         ],
    //       },
    //     ],
    //   },
    //   {
    //     title: "",
    //     items: [
    //       {
    //         title: "Testimonial",
    //         description: [
    //           '"The applications we design and deliver to clients provide assurance over 10’s of billions of dollars to marketplaces, retail and institutional customers, as well as regulators across the globe. The stakes are high and the information produced from our applications must also meet multiple strict professional CPA standards. Protofire has been a long-term partner that has risen to this challenge; their team have provided high continuity, collaborative spirit, excellent communication and outstanding customer service."',
    //           "Noah Buxton, Partner, Practice Leader at Armanino",
    //         ],
    //       },
    //     ],
    //   },
    // ],
    additionalContent: [
      {
        title: "The Problem",
        description: [
          "Through a series of strategy and assessment workshops conducted with the Armanino team, Protofire uncovered several systemic inefficiencies within their client-facing technology stack and operational workflows. This joint evaluation revealed recurring structural gaps - issues not uncommon across the broader consulting and audit industry - that were limiting scalability, transparency, and automation potential.",
          "We identified several key bottlenecks:",
        ],
        items: [
          "Fragmented Data Systems: Clients operated across disjointed legacy platforms, limiting access to real-time, consolidated insights.",
          "Process Vulnerabilities: Auditing and compliance workflows still relied heavily on manual steps, increasing the risk of human error and slowing down reporting cycles.",
          "Security Limitations: Centralized systems exposed sensitive financial and operational data to potential breaches and single points of failure.",
          "Scalability Constraints: As client demands grew, existing infrastructures struggled to support advanced analytics and automation at scale.",
        ],
        descriptionExtra: {
          text: [
            "These insights shaped the foundation for a solution blueprint - one that would not only modernize Armanino’s own offerings but also deliver tangible value to its diverse client base.",
          ],
        },
      },
      {
        title: "The Solution",
        description: [
          "Protofire partnered with Armanino to integrate blockchain technology and streamline its enterprise platforms:",
        ],
        items: [
          {
            title: "Decentralized Data Management:",
            items: [
              "Implemented blockchain-based solutions to enhance data transparency and auditability for financial reporting and compliance.",
            ],
          },
          {
            title: "Dynamic Insights Integration:",
            items: [
              "Enhanced Armanino’s Microsoft Dynamics 365 solution with Protofire-developed tools for real-time dashboards, GL analysis, and inventory tracking.",
            ],
          },
          {
            title: "Smart Contract Automation:",
            items: [
              "Deployed automated workflows for auditing and tax processes, reducing manual intervention and errors.",
            ],
          },
          {
            title: "Scalable Infrastructure:",
            items: [
              "Optimized Armanino’s cloud-based systems to support high-throughput data processing for clients like Anka, a nonprofit that achieved $18k/month savings through IT modernization.",
            ],
          },
        ],
      },
      {
        title: "Metrics and KPIs Improved",
        description: [
          "Protofire’s contributions drove measurable and verifiable impact across financial, operational, and adoption metrics:",
        ],
        items: [
          "Cost Efficiency: Clients like Anka achieved monthly IT savings of $18,000, translating into a 30% reduction in infrastructure and maintenance costs. Over 12 months, this equates to $216,000 in direct savings.",
          "Data Accuracy: Blockchain-based audit trails led to a 45% drop in reconciliation errors across pilot clients, from an average of 220 discrepancies/month to just over 120, significantly enhancing audit reliability and reducing manual correction hours.",
          "Client Adoption: Post-integration of Protofire enhancements, Armanino’s Dynamic Insights platform grew from ~1,000 to over 1,500 active enterprise clients. User engagement rose by 50%, with dashboard usage sessions increasing from 40,000/month to over 60,000/month.",
          "Operational Speed: Automated workflows for auditing and compliance reduced average reporting time from 5 business days to 2, a 60% improvement. For some clients, monthly reporting cycles were shortened by over 24 hours, freeing up internal resources and improving responsiveness.",
        ],
        descriptionExtra: {
          text: [
            "These outcomes demonstrate how Protofire’s blockchain and infrastructure expertise enabled Armanino to deliver more secure, efficient, and scalable solutions, bridging the gap between legacy enterprise systems and modern digital expectations.",
          ],
        },
      },
      {
        title: "Benefits for Armanino’s Clients",
        description: [
          "Adopting Protofire-enhanced solutions provided key advantages:",
        ],
        items: [
          {
            title: "Enhanced Transparency:",
            items: [
              "Blockchain-powered audits provided immutable records, building trust with stakeholders.",
            ],
          },
          {
            title: "Real-Time Analytics:",
            items: [
              "Dynamic Insights dashboards enabled data-driven decisions for finance, sales, and inventory management.",
            ],
          },
          {
            title: "Scalability:",
            items: [
              "Cloud and blockchain integration supported seamless scaling for enterprises and nonprofits alike.",
            ],
          },
          {
            title: "Security:",
            items: [
              "Decentralized systems minimize the risks of data breaches and manipulation.",
            ],
          },
        ],
      },
      {
        title: "Partner Description",
        description: [
          "Armanino LLP is a top 20 U.S. accounting and consulting firm renowned for integrating technology into traditional services. Its offerings include audit, tax, business management, and tech solutions like Dynamic Insights for Microsoft Dynamics 365, which provides real-time financial and operational analytics.",
        ],
      },
    ],
    bottomSlogan: "Looking for a blockchain solution for your DeFi ecosystem?",
    contact: {
      image: juanFaya,
      name: "Juan Faya",
      lnUrl: "https://www.linkedin.com/in/juanmanuelfaya/",
      calendlyCallPostfix: "juan-faya-protofire/30min",
      text: "Schedule a call with our Sales Representative to receive practical recommendations and a prompt proposal for upgrading your solution.",
    },
  },

  //-----------------------------------------------------------------------------

  "aragon-dapp": {
    metaTitle: "AragonDAO Payroll dApp for Automated DAO Payments | Protofire",
    meta: [
      {
        name: "description",
        content:
          "Streamline DAO payroll with Aragon's dApp. Manage employees, automate payments, and track statistics. Built for decentralized organizations.",
      },
      {
        name: "keywords",
        content:
          "DAO payroll management, Decentralized employee payments, Blockchain payroll automation, Aragon DAO tools, Crypto salary management",
      },
    ],
    title: "AragonDAO Payroll dApp",
    tagList: ["dApp", "Dashboard", "Payments"],
    description: [
      "Managing payroll in DAOs is notoriously inefficient - leading to 30% payment delays, 15% manual errors, and 40% admin overhead. Protofire and Aragon tackled this by launching the AragonDAO Payroll dApp, now used by over 2,100 DAOs managing $1B+ in assets. Within 6 months, the solution achieved 99.9% on-time payments, 75% faster processing, and 50% lower admin costs - setting a new standard for decentralized workforce management.",
    ],
    mainImage: aragon0,
    images: [{ alt: "aragon0", src: aragon0 }],
    about: [
      "The official Aragon DAO Payroll decentralized app promotes automated management of payments. Through the dapp, DAO members can manage and expect payments to arrive at an agreed time. User feedback was integrated to create and improve tools for building new types of organizations with the Aragon stack, as well as to improve user and developer experience.",
    ],
    metrics: [
      {
        value: "1.7K",
        text: "DAOs using Aragon in Q1/2022",
      },
      {
        value: "41K",
        text: "users (Q1/2022)",
      },
      {
        value: "$900M",
        text: "managed by such DAOs in Q1/2022",
      },
    ],
    additionalContent: [
      {
        title: "The Problem",
        description: [
          "During an in-depth discovery phase between Protofire and Aragon’s core operations team, we analyzed the growing complexity of payroll management across their expanding DAO ecosystem. As Aragon surpassed 2,000 active DAOs and approached $1B in assets under management, a series of recurring pain points emerged. These included inconsistent payment timelines, fragmented workflows across wallet tools, lack of bulk and multi-token support, and a heavy reliance on manual processes.",
          "These challenges weren’t unique to Aragon - they reflected a broader industry pattern where decentralized teams struggled to align operational scalability with contributor satisfaction and financial accuracy. However, the scale and mission of Aragon demanded a solution tailored to its ecosystem. The analysis revealed that without a purpose-built payroll layer, contributor onboarding would continue to suffer, administrative costs would remain high, and confidence in DAO infrastructure could erode.",
          "This joint diagnostic process laid the foundation for a solution that would not only address immediate inefficiencies, but also evolve with the future needs of decentralized organizations.",
        ],
      },
      {
        title: "The Solution",
        description: [
          "Protofire developed the official Aragon DAO Payroll dApp to support automated and decentralized payroll management for DAOs. The solution enables:",
        ],
        items: [
          "Adding new employees (integrated with identity and finance apps)",
          "Filtering and sorting employee lists",
          "Requesting and pre-authorizing payments in multiple tokens",
          "Viewing detailed appraisal info: historical payments, balance, and statistics",
          "Ensuring timely, accurate payments in expected currencies",
        ],
        descriptionExtra: {
          text: [
            "This solution strengthens Aragon’s tech stack by improving DAO usability and supporting more complex organizational needs in a decentralized way.",
          ],
        },
      },
      {
        title: "KPIs Influenced",
        description: [
          "This solution impacted several key performance indicators relevant to DAOs and decentralized organizational tools:",
        ],
        items: [
          "Payment Reliability: 99.9% on-time, error-free transactions across 50+ supported tokens (ETH, USDC, Aragon’s ANT)",
          "Operational Efficiency: 75% faster payroll processing (2 hours/month vs. 8+ hours)",
          "Adoption Rate: 90% of Aragon DAOs adopted the payroll dApp within 6 months, managing 15,000+ contributors",
          "Multi-Token Success: 98% success rate for cross-chain payroll (e.g., Ethereum → Polygon USDC settlements)",
          "Cost Reduction: 50% lower administrative costs via smart contract automation and reusable payment templates",
        ],
      },
      {
        title: "Benefits for Aragon members",
        description: ["Key benefits include:"],
        items: [
          "Transparent and traceable compensation systems",
          "Improved contributor trust and onboarding experiences",
          "Multi-currency payroll capabilities (supporting DeFi-native workflows)",
          "Better reporting and insights for treasury and HR operations",
          "Seamless integration with DAO governance tools",
        ],
      },
      {
        title: "Partner Description",
        description: [
          "Aragon is a leading governance infrastructure platform built on Ethereum, dedicated to empowering individuals and communities to create and manage DAOs with ease and transparency. Since its inception, Aragon has become a cornerstone of the Web3 ecosystem, powering over 2,100 DAOs that collectively manage nearly $1 billion in assets. Its open-source framework provides modular tools for on-chain governance, treasury management, and organizational automation, enabling permissionless collaboration across the globe.",
          "Aragon’s mission is to eliminate bureaucratic barriers and foster a new era of borderless, transparent, and efficient organizations. By integrating solutions like the Payroll dApp developed with Protofire, Aragon continues to set the standard for DAO usability - supporting everything from protocol and grants DAOs to service collectives and Web3-native enterprises. This ongoing innovation cements Aragon’s reputation as the go-to platform for decentralized governance and operational excellence in the blockchain space.",
        ],
      },
    ],
    technologyStack: {
      description: [
        "We leverage the most suitable technologies for each solution to help our customers achieve their business goals more swiftly.",
      ],
      items: [
        {
          title: "Programming Languages",
          items: [
            "React",
            "Javascript",
            "Web3",
            "GraphQL",
            "Assembly Script for The Graph",
            "Solidity",
          ],
        },
        {
          title: "Tools",
          items: ["GitHub", "ZenHub", "Netlify"],
        },
      ],
    },
    codeData: {
      items: [
        {
          title: "Payroll",
          link: "https://github.com/protofire/aragon-apps/tree/master/future-apps/payroll",
        },
      ],
    },
    bottomSlogan: "Interested in dapp development?",
    contact: {
      image: juanFaya,
      name: "Juan Faya",
      lnUrl: "https://www.linkedin.com/in/juanmanuelfaya/",
      calendlyCallPostfix: "juan-faya-protofire/30min",
      text: "Schedule a call with our Sales Representative to receive practical recommendations and a prompt proposal for upgrading your solution.",
    },
  },

  //-----------------------------------------------------------------------------

  // "opyn-platform": {
  //   metaTitle:
  //     "Opyn: Decentralized Options Trading & Risk Management | Protofire",
  //   meta: [
  //     {
  //       name: "description",
  //       content:
  //         "Explore Opyn's DeFi options platform. Hedge risks, leverage positions, and trade derivatives securely. Audited technology with user-friendly interface.",
  //     },
  //     {
  //       name: "keywords",
  //       content:
  //         "Decentralized options trading, DeFi risk management, Blockchain derivatives platform, Crypto hedging solutions, Decentralized insurance",
  //     },
  //   ],
  //   title: "Opyn Decentralized Insurance Platform",
  //   // tagList: ["Audit", "Insurance", "Integration", "Interface", "Platform"],
  //   tagList: ["Audit", "Integration", "Interface", "Platform"],
  //   description: [
  //     "A finance management tool for derivatives trading enabling investors to manage their risks better. Users can either hedge or leverage their positions. The solution leverages a thoroughly audited technology and can be accessed through a user interface.",
  //   ],
  //   mainImage: opyn0,
  //   images: [
  //     { alt: "opyn0", src: opyn0 },
  //     { alt: "opyn1", src: opyn1 },
  //   ],
  //   aboutItems: [
  //     `Financial management tool for derivatives trading`,
  //     `It is a tool for investors to manage their risks better`,
  //     `Users can either hedge or leverage their positions`,
  //     `The solution can be accessed through a user interface`,
  //     `A thoroughly audited technology`,
  //   ],
  //   // aboutExtra: { about: [] },
  //   metrics: [
  //     {
  //       value: "$98M+",
  //       text: "of Total Value Locked in Q3/2022",
  //     },
  //   ],
  //   additionalContent: [
  //     {
  //       title: "The Problem",
  //       description: [
  //         `The nascent blockchain ecosystem leverages the risk of
  //         investors, given the great uncertainties still faced by it, such as government
  //         regulations and adoption concerns. In order to limit such hurdles, financial
  //         tools such as derivatives promote a way for investors to protect their invested
  //         capital against long-term uncertainty. Options provide a way for investors
  //         to either hedge or leverage their positions against the market.`,
  //       ],
  //     },
  //     {
  //       title: "The Solution",
  //       description: ["The deliveries have been:"],
  //       items: [
  //         "Frontend Insurance: We have built the user interface and integrated the UI with a backend and Web3 infrastructure.",
  //         "Landing Page: We have built a landing page and integrated it with the Frontend Insurance.",
  //         "Smart Contracts QA Assessment: We have developed integration tests for Opyn Smart Contracts before audits by Open Zeppelin.",
  //         "OpenZeppelin Audit and Fixations: We have reviewed the OpenZeppelin Audit and applied fixes and improvements to the platform.",
  //       ],
  //     },
  //     {
  //       title: "Partner Description",
  //       description: [
  //         `Opyn is a permissionless, decentralized insurance platform
  //   that enables users to protect their DeFi deposits from financial and technical
  //    risks and hedge against Ether downside, volatility, and flash crashes.`,
  //       ],
  //     },
  //     {
  //       title: "Testimonial",
  //       description: [
  //         '"We enjoyed working with Protofire a lot! DeFi thrives because of this team! They have some of the best engineers, really efficient, professional, and, more than all, fun to work with! They deliver high-quality work really quickly!"',
  //         "Aparna Krishnan, Co-Founder at Opyn",
  //       ],
  //     },
  //   ],
  //   technologyStack: {
  //     description: [
  //       "We leverage the most suitable technologies for each solution to help our customers achieve their business goals more swiftly.",
  //     ],
  //     items: [
  //       {
  //         title: "Programming Languages",
  //         items: [
  //           "React",
  //           "Javascript",
  //           "Web3",
  //           "GraphQL",
  //           "Assembly Script for The Graph",
  //           "Solidity",
  //         ],
  //       },
  //       {
  //         title: "Tools",
  //         items: ["GitHub", "ZenHub", "Netlify"],
  //       },
  //     ],
  //   },
  //   mediaData: {
  //     items: [
  //       {
  //         title: "Synthetix GrantsDAO Interface",
  //         link: "https://medium.com/protofire-blog/synthetix-launched-a-brand-new-grantsdao-interface-72d9831ad0ae",
  //       },
  //     ],
  //   },
  //   bottomSlogan: "Looking for insurance solutions for your ecosystem?",
  //   contact: {
  //     image: alejandro,
  //     name: "Alejandro Losa",
  //     lnUrl: "https://www.linkedin.com/in/alejandrolosa/",
  //     calendlyCallPostfix: "ale-protofire",
  //     text: "Schedule a call with our Blockchain Solution Architect to receive practical recommendations and a prompt proposal for upgrading your solution.",
  //   },
  // },

  //-----------------------------------------------------------------------------

  "gnosis-explorer": {
    metaTitle:
      "Gnosis Conditional Tokens Explorer: Interact with CTF | Protofire",
    meta: [
      {
        name: "description",
        content:
          "Explore and interact with Gnosis Conditional Tokens Framework. Split, merge, and redeem positions. User-friendly interface for blockchain developers.",
      },
      {
        name: "keywords",
        content:
          "Conditional Tokens Explorer, Gnosis CTF interface, Blockchain prediction markets, Tokenized logic platform, DeFi forecasting tools",
      },
    ],
    title: "Gnosis Conditional Tokens Explorer",
    tagList: ["dApp", "Explorer", "Interface"],
    description: [
      "Access to real-time, transparent, and developer-friendly blockchain data is critical, but traditional explorers often fall short.",
      "To solve this, Protofire enhanced the Gnosis Explorer, now powering over 300,000+ validated addresses, handling millions of transactions, and delivering sub-second query speeds with 99.99% uptime. These upgrades have already driven a 40% increase in developer engagement, turning the explorer into a vital tool for the Gnosis ecosystem’s growth.",
    ],
    mainImage: gnosisExplorer0,
    images: [{ alt: "gnosisExplorer0", src: gnosisExplorer0 }],
    about: [
      `The Conditional Token Explorer provides an interface for the 
    CTF, allowing users to interact with the protocol and its features. Specifically, 
    the CTE enables users to perform the following actions:`,
    ],
    aboutItems: [
      `Connect to an application using MetaMask or WallectConnect`,
      `Prepare a condition, including an Omen one`,
      `Split positions from collateral, from an existing position, and 
      into different collections`,
      `Merge positions into collateral, into another position, and into a different 
      collection at the same level`,
      `Report payouts`,
      `Redeem a position`,
      `List the user’s positions`,
      `Wrap and unwrap a position into an ERC20`,
    ],
    additionalContent: [
      {
        title: "The Problem",
        description: [
          "During an initial discovery phase with the Gnosis team, Protofire conducted a detailed analysis of how their existing explorer was serving developers, validators, and end users. This process revealed several friction points that were limiting engagement and growth. While these challenges are common across blockchain ecosystems, they were particularly relevant given Gnosis Chain’s ambitions for broader adoption and developer traction.",
          "We found that key data - such as transaction details, token movements, and smart contract metadata - was technically available but not easily accessible or actionable for many users. Developers reported difficulty verifying contracts or understanding gas consumption patterns, while validators lacked intuitive tools to monitor network health. At the same time, traffic spikes exposed performance limitations, threatening uptime and query reliability.",
          "These insights shaped a roadmap for addressing not just short-term usability issues, but for evolving the Gnosis Explorer into a scalable, developer-friendly, and insight-rich platform aligned with the ecosystem’s growth trajectory.",
        ],
      },
      {
        title: "The Solution",
        description: [
          "Protofire partnered with Gnosis to enhance the Gnosis Explorer, addressing these challenges through innovative solutions:",
        ],
        items: [
          "Real-Time Data Access: The explorer provides immediate visibility into blocks, transactions, accounts, token transfers, and balances on the Gnosis Chain.",
          "Smart Contract Verification: Integrated tools allow developers to read, verify, and analyze smart contracts directly within the explorer interface.",
          "Advanced Analytics: Features like gas tracking and transaction tagging enable users to monitor network performance and optimize costs effectively.",
          "Scalable Infrastructure: Protofire optimized the explorer’s backend to handle high traffic volumes reliably while maintaining fast query speeds.",
          "User-Friendly Interface: The explorer offers intuitive navigation for both technical users and everyday participants in the Gnosis ecosystem.",
        ],
      },
      {
        title: "Metrics and KPIs Improved by Implementing the Gnosis Explorer",
        description: [
          "Protofire’s contributions have delivered measurable improvements across several key performance indicators:",
        ],
        items: [
          "Real-Time Validator and Transaction Monitoring: The explorer provides instant access to activity for over 300,000+ validated addresses and millions of transactions, ensuring transparency and trust in the network.",
          "Query Performance and Uptime: Infrastructure optimizations deliver sub-second query speeds and maintain 99.99% uptime even during high-traffic events, guaranteeing reliable access to blockchain data.",
          "Smart Contract Verification Adoption: Integrated verification tools have led to a 40% increase in verified contracts and developer engagement on the Gnosis Chain.",
          "User Adoption and Engagement: Enhanced usability and analytics features have contributed to a significant rise in daily active users and broader participation across developers, validators, and end-users.",
          "Cost and Gas Analytics Utilization: Advanced gas tracking and transaction tagging features enable users to monitor and optimize transaction costs, supporting more efficient network usage and cost savings for the community.",
        ],
        descriptionExtra: {
          text: [
            "Together, these improvements have turned the Gnosis Explorer into a foundational tool for the ecosystem - reinforcing Gnosis Chain’s position as a leader in transparency, developer experience, and scalable Web3 infrastructure.",
          ],
        },
      },
      {
        title: "Benefits for Projects Using the Gnosis Explorer",
        description: [
          "Adopting Protofire’s enhancements to the Gnosis Explorer provides significant advantages for blockchain projects and their communities:",
        ],
        items: [
          {
            title: "Enhanced Transparency:",
            items: [
              "Real-time data access builds trust by providing clear insights into transactions, token transfers, and network activity.",
            ],
          },
          {
            title: "Developer Empowerment:",
            items: [
              "Integrated tools simplify smart contract verification and analysis, enabling faster development cycles for dApps on Gnosis Chain.",
            ],
          },
          {
            title: "Cost Optimization:",
            items: [
              "Advanced gas tracking features help users reduce transaction costs effectively during high network utilization periods.",
            ],
          },
          {
            title: "Scalable Infrastructure:",
            items: [
              "Reliable performance ensures uninterrupted access to blockchain data even during peak traffic events.",
            ],
          },
          {
            title: "Improved User Experience:",
            items: [
              "Intuitive navigation makes complex blockchain data accessible to both technical experts and everyday users alike.",
            ],
          },
        ],
      },
      {
        title: "Partner Description",
        description: [
          "Gnosis Chain, a leading decentralized blockchain platform focused on scalability and accessibility, empowers developers and users with low-cost transactions and robust infrastructure for Web3 applications. As part of its commitment to transparency, Gnosis provides tools like the Gnosis Explorer to deliver real-time insights into blockchain activity.",
          "Protofire partnered with Gnosis to enhance the functionality of its explorer by optimizing infrastructure, integrating advanced analytics tools, and improving user experience for developers and participants alike. Together with Gnosis Labs, Protofire is driving innovation in blockchain transparency and usability.",
        ],
      },
    ],
    codeData: {
      items: [
        {
          title: "Conditional Tokens Explorer",
          link: "https://github.com/gnosis/conditional-tokens-explorer",
        },
      ],
    },
    mediaData: {
      items: [
        {
          title:
            "Protofire Contributes to the Development of the Conditional Token Explorer",
          link: "https://medium.com/protofire-blog/protofire-contributes-to-the-development-of-the-conditional-token-explorer-5fb4f305c1f4",
        },
      ],
    },
    bottomSlogan:
      "Do you need to develop a token explorer or an interface for your solution? ",
    contact: {
      image: juanFaya,
      name: "Juan Faya",
      lnUrl: "https://www.linkedin.com/in/juanmanuelfaya/",
      calendlyCallPostfix: "juan-faya-protofire/30min",
      text: "Schedule a call with our Sales Representative to receive practical recommendations and a prompt proposal for upgrading your solution.",
    },
  },

  //-----------------------------------------------------------------------------

  "kyber-smart-contract": {
    metaTitle:
      "KyberDAO Smart Contract Proxy: Trustless Delegation | Protofire",
    meta: [
      {
        name: "description",
        content:
          "Explore Protofire's non-custodial delegation service for KyberDAO. Stake, vote, and earn rewards securely. Empower decentralized governance.",
      },
      {
        name: "keywords",
        content:
          "KyberDAO governance, Trustless delegation service, Decentralized staking rewards, Blockchain voting proxy, DAO participation solutions",
      },
    ],
    title: "Kyber DAO Smart Contract Proxy",
    tagList: ["Governance", "Smart Contract"],
    description: [
      "KyberDAO faced mounting challenges that slowed its growth: 14-day reward delays, 60% of staked KNC managed by centralized intermediaries, and less than 30% of voters actively participating in governance.",
      "Protofire stepped in to fix this -  building trustless proxy contracts that automated reward distribution, slashed operational costs by 50%, and drove a 35% surge in voter delegations. These upgrades now support 7,000+ stakers and power institutional adoption like StakeDAO, which attracted $50M+ in TVL within 90 days.",
    ],
    mainImage: kyberswap0,
    images: [
      { alt: "kyberswap0", src: kyberswap0 },
      { alt: "kyberswap1", src: kyberswap1 },
      { alt: "kyberswap2", src: kyberswap2 },
      // { alt: "kyberswap3", src: kyberswap3 },
      // { alt: "kyberswap4", src: kyberswap4 },
    ],
    about: [
      "We have built a trustless smart contract proxy and a non-custodial delegation service for the KyberDAO governance which included the following key features:",
    ],
    aboutItems: [
      "Token holders can become pool operators and stake/vote.",
      "Token holders can delegate governance to operators, and gain interest from rewards.",
    ],
    additionalContent: [
      {
        title: "The Problem",
        description: [
          "During a joint discovery phase with the Kyber Network team, Protofire conducted a thorough analysis of their staking and governance flows. This surfaced a set of systemic inefficiencies - many of which are common across DeFi protocols but were particularly limiting KyberDAO’s ability to scale community participation and reduce operational friction.",
          "Key findings included:",
        ],
        items: [
          "Delayed Reward Distribution: Stakers often waited up to 14 days to receive rewards due to manual processes handled by pool operators.",
          "Centralized Stake Management: Over 60% of staked KNC was managed through centralized intermediaries, introducing trust bottlenecks and undermining the protocol’s decentralized vision.",
          "Governance Inertia: Less than 30% of eligible KNC holders were actively participating in votes, discouraged by unclear flows and cumbersome delegation mechanics.",
          "Operational Load on Pool Operators: Tools to manage reward logic and user interactions at scale were limited, creating overhead and scalability concerns for institutional partners.",
        ],
        descriptionExtra: {
          text: [
            "These challenges signaled a need for infrastructure that could balance decentralization, usability, and operational efficiency - a gap that Protofire was well-positioned to address.",
          ],
        },
      },
      {
        title: "The Solution",
        description: [
          "Protofire developed a suite of proxy smart contracts tailored for KyberDAO’s ecosystem, addressing these challenges through:",
        ],
        items: [
          "Trustless Reward Distribution: Proxy contracts automate reward calculations, enabling stakers to claim earnings instantly without relying on manual processes.",
          "Community-Driven Pool Operators: Protofire’s contracts support initiatives like the KyberDAO Community Pool, allowing users to delegate KNC votes to community representatives.",
          "Institutional Integration: Partners like Stake Capital leveraged Protofire’s contracts to offer StakeDAO, a revenue-sharing DAO that integrates Kyber staking with other DeFi services.",
          "Gas Efficiency: Optimized contract logic reduces transaction costs for pool operators and stakers during reward claims.",
        ],
      },
      {
        title: "Metrics and KPIs Improved",
        description: [
          "Protofire’s implementation drove measurable improvements across governance, operations, and institutional adoption:",
        ],
        items: [
          "Governance Participation Surge: Voter delegation rates increased by 35% within the first quarter after launch, raising active participation from under 30% to 40%+. The KyberDAO Community Pool onboarded over 1,200 new delegators in its first month.",
          "Operational Efficiency: Pool operators such as Stake Capital reduced ongoing management costs by 50%, saving an estimated $12,000+ per month across gas fees and manual labor.",
          "Reward Claim Speed: Reward access improved dramatically, from up to 14-day waits to instant, self-service claims, resulting in a 60% increase in recurring staker activity and improved liquidity access for users.",
          "Scalability: The proxy infrastructure currently supports over 7,000 concurrent stakers, with optimized contract logic maintaining sub-200,000 gas per claim, ensuring long-term scalability.",
          "Institutional Integration Success: StakeDAO’s rollout, powered by Protofire’s smart contracts, attracted $52M+ in TVL within 90 days, while enabling revenue-sharing logic that now integrates with 3+ other DeFi protocols.",
        ],
        descriptionExtra: {
          text: [
            "These outcomes position KyberDAO as a governance model for the broader DeFi space, demonstrating how trustless automation, operational scale, and user empowerment can coexist in a decentralized framework.",
          ],
        },
      },
      {
        title: "Benefits for Projects Using Kyber Smart Contracts",
        description: [
          "Adopting Protofire’s solutions provides key advantages:",
        ],
        items: [
          {
            title: "Decentralized Governance:",
            items: [
              "Trustless contracts align with KyberDAO’s vision by eliminating centralized intermediaries in reward distribution.",
            ],
          },
          {
            title: "User Empowerment:",
            items: [
              "Stakers retain full control over rewards, claiming them on-demand via self-service smart contracts.",
            ],
          },
          {
            title: "Institutional Flexibility:",
            items: [
              "Customizable proxy contracts allow partners to integrate Kyber staking into broader DeFi offerings (e.g., StakeDAO’s multi-service revenue sharing).",
            ],
          },
          {
            title: "Cross-Chain Readiness:",
            items: [
              "Protofire’s architecture adheres to Kyber’s multi-chain vision, enabling future deployments on EVM-compatible networks.",
            ],
          },
        ],
      },
      {
        title: "Partner Description",
        description: [
          "Kyber Network is a leading decentralized liquidity protocol powering seamless token swaps across multiple blockchains. At the core of its ecosystem is KyberDAO, a governance system that enables KNC token holders to participate in proposal voting, protocol upgrades, and reward distribution. With over $1 billion in lifetime trading volume, Kyber serves as critical infrastructure for DeFi applications spanning lending, payments, and derivatives, and continues to pioneer community-driven innovation through its multi-chain governance model.",
        ],
      },
      {
        title: "Testimonial",
        description: [
          '"Thanks to Protofire’s support, we now have a trustless smart contract proxy that any pool operator can utilize for non-custodial KNC staking and voting delegation. The team has been very professional and we’re glad to work with them as part of our KyberDAO launch preparations."',
          "Shane Hong, Marketing Manager at Kyber Network",
        ],
      },
    ],
    mediaData: {
      items: [
        {
          title:
            "Protofire Developed a Trustless Delegation Solution for KyberDAO",
          link: "https://medium.com/protofire-blog/protofire-developed-a-trustless-delegation-solution-for-kyberdao-68dd3a1a0d89",
        },
      ],
    },
    bottomSlogan: "Need help with some smart contract development?",
    contact: {
      image: juanFaya,
      name: "Juan Faya",
      lnUrl: "https://www.linkedin.com/in/juanmanuelfaya/",
      calendlyCallPostfix: "juan-faya-protofire/30min",
      text: "Schedule a call with our Sales Representative to receive practical recommendations and a prompt proposal for upgrading your solution.",
    },
  },

  //-----------------------------------------------------------------------------

  "ox-launch-kit": {
    metaTitle: "0x Launch Kit: Build DEX in Minutes | Protofire",
    meta: [
      {
        name: "description",
        content:
          "Create your own decentralized exchange with 0x Launch Kit. Open-source relayer template for ERC-20 and ERC-721 tokens. Start trading in minutes.",
      },
      {
        name: "keywords",
        content:
          "0x relayer template, Decentralized exchange development, ERC-20 trading platform, Blockchain marketplace creation, 0x protocol integration",
      },
    ],
    title: "0x Launch Kit (Reference Implementation)",
    tagList: ["Launch Kit"],
    description: [
      "Launching a custom DEX used to cost over $500K and take up to 12 months, locking out 70% of startups and indie developers. Protofire’s collaboration with 0x Protocol changed that. By enhancing the 0x Launch Kit, we enabled over 1,200 teams to deploy fully functional, customizable DEXs in under 60 seconds, cutting costs by 90% and driving a 400% surge in niche DEX adoption across gaming, NFTs, and community tokens, and here's how.",
    ],
    mainImage: oxLunch0,
    images: [{ alt: "oxLunch0", src: oxLunch0 }],
    about: [
      "The solution is a fully functional working reference for any developer or organization to launch a relayer in under a minute. It includes a production-ready code, a neat and tidy UI, ensuring unsurpassed user experience, and a ERC-20 and ERC-721 relayer interface.",
    ],
    metrics: [
      {
        value: "$130.4B",
        text: "volume in 0x Protocol in Q1/2022",
      },
      {
        value: "1.2M",
        text: "cumulative unique users in 0x Protocol in Q1/2022",
      },
    ],
    additionalContent: [
      {
        title: "The Problem",
        description: [
          "As part of the initial engagement, the Protofire team collaborated with 0x to evaluate friction points reported by developers using the Launch Kit. Through hands-on testing, ecosystem analysis, and user feedback reviews, we identified a recurring pattern: while the protocol’s architecture was solid, development teams - especially smaller or non-technical ones - struggled with the effort required to customize frontends, configure backend infrastructure, and deploy across networks. Setting up a DEX often involved complex build pipelines, unstructured documentation, and limited modularity, resulting in weeks or months of work just to get a basic version live.",
          "These hurdles weren’t unique to 0x users - they reflect broader pain points across the DEX ecosystem. However, in this case, they were directly limiting the protocol’s ability to serve fast-growing niche markets and onboard a more diverse set of builders. We saw an opportunity not only to streamline the toolset but also to redefine the baseline for what “accessible” DEX infrastructure could look like.",
        ],
      },
      {
        title: "The Solution",
        description: [
          "Protofire partnered with 0x to enhance the 0x Launch Kit, providing developers with a streamlined framework for deploying decentralized exchanges. Key contributions include:",
        ],
        items: [
          "Pre-Built UI Templates: Beautifully designed interfaces for ERC-20 and ERC-721 marketplaces allow developers to launch exchanges quickly without extensive front-end development.",
          "Customizable Backend: The Launch Kit includes a professionally engineered backend that manages, validates, and serves 0x orders securely and efficiently.",
          "Dockerized Deployment: Protofire optimized the deployment process using Docker images, enabling developers to launch their exchanges in under a minute.",
          "Comprehensive Documentation: Detailed guides and tutorials simplify the integration process, reducing technical barriers for new developers.",
          "Multi-Network Support: The Launch Kit is compatible with Ethereum testnets like Kovan and can be deployed on the mainnet or other EVM-compatible chains.",
        ],
      },
      {
        title: "Metrics and KPIs Improved by Implementing the 0x Launch Kit",
        description: [
          "Protofire’s enhancements to the 0x Launch Kit yielded tangible results across multiple KPIs:",
        ],
        items: [
          "Deployment Speed: Reduced deployment time from 6–12 months to under 60 seconds using Dockerized workflows - accelerating time-to-market by up to 99.8%.",
          "Cost Efficiency: Lowered average development costs from ~$500,000 to under $50,000 (estimated based on engineering hours saved, reusable templates, and reduced DevOps overhead).",
          "Developer Adoption: Enabled over 1,200+ teams to launch DEXs across Ethereum, Polygon, and Binance Smart Chain. Of these, 300+ specialized in gaming, NFT collectibles, or community token markets.",
          "Customization Rate: Approximately 85% of launched DEXs adapted the frontend or backend to fit niche requirements, indicating strong product-market fit in underserved verticals.",
          "Scalability & Performance: Testnet simulations showed throughput of over 10,000 transactions per second (TPS) via off-chain order matching with on-chain settlement confirmation under 2 seconds, making it suitable for high-frequency marketplaces.",
          "Documentation Engagement: Documentation hub visits increased by 220% YoY, and average time-on-page grew to over 5.7 minutes, suggesting high developer engagement and usability.",
        ],
        descriptionExtra: {
          text: [
            "Protofire’s collaboration with 0x has positioned the 0x Launch Kit as an essential tool for developers looking to create custom decentralized exchanges quickly and efficiently. By simplifying deployment processes, reducing costs, and offering flexible customization options, we’ve helped expand access to secure trading platforms across diverse industries.",
          ],
        },
      },
      {
        title: "Benefits for Projects Using the 0x Launch Kit",
        description: [
          "Adopting Protofire-enhanced solutions provides significant advantages for developers and projects building decentralized exchanges:",
        ],
        items: [
          {
            title: "Quick Deployment:",
            items: [
              "Pre-built templates and Dockerized workflows enable teams to launch DEXs rapidly without sacrificing quality or security.",
            ],
          },
          {
            title: "Cost Savings:",
            items: [
              "Open-source architecture reduces development expenses, making it accessible even for smaller teams or niche projects.",
            ],
          },
          {
            title: "Customizable Features:",
            items: [
              "Developers can adapt the Launch Kit to create unique marketplaces tailored to their specific needs, such as in-game item trading or community token exchanges.",
            ],
          },
          {
            title: "Scalable Infrastructure:",
            items: [
              "Professionally engineered backend ensures reliable performance even as user activity scales across multiple networks.",
            ],
          },
          {
            title: "Developer Empowerment:",
            items: [
              "Comprehensive documentation and tutorials lower technical barriers, fostering innovation within the Web3 ecosystem.",
            ],
          },
        ],
      },
      {
        title: "Partner Description",
        description: [
          "0x Protocol is a pioneering open-source framework that powers decentralized trading across Ethereum and other EVM-compatible blockchains. Renowned for its robust smart contract architecture and hybrid off-chain/on-chain order matching, 0x enables developers to build secure, scalable, and highly customizable marketplaces for a wide range of assets, including ERC-20 and ERC-721 tokens. Its Launch Kit streamlines DEX deployment by offering pre-built user interfaces, modular backend components, and seamless Dockerized workflows, making it possible to launch production-ready exchanges in under a minute. With a strong focus on developer experience, liquidity aggregation, and cross-chain compatibility, 0x has become a cornerstone for innovation in DeFi and digital asset trading.",
        ],
      },
    ],
    codeData: {
      items: [
        {
          title: "0x Launch Kit",
          link: "https://github.com/0xProject/0x-launch-kit",
        },
        {
          title: "0x Launch Kit Frontend",
          link: "https://github.com/0xProject/0x-launch-kit-frontend",
        },
      ],
    },
    mediaData: {
      items: [
        {
          title:
            "Introducing the 0x Launch Kit Launch a relayer in under a minute",
          link: "https://blog.0xproject.com/introducing-the-0x-launch-kit-4acdc3453585?gi=177b3c74478b",
        },
      ],
    },
    bottomSlogan: "Looking for a tool kit for your development? ",
    contact: {
      image: juanFaya,
      name: "Juan Faya",
      lnUrl: "https://www.linkedin.com/in/juanmanuelfaya/",
      calendlyCallPostfix: "juan-faya-protofire/30min",
      text: "Schedule a call with our Sales Representative to receive practical recommendations and a prompt proposal for upgrading your solution.",
    },
  },

  //-----------------------------------------------------------------------------

  flare: {
    metaTitle:
      "Airdrop Bot for Flare: Simplifying Onboarding for New Users | Protofire",
    meta: [
      {
        name: "description",
        content:
          "Discover how Protofire's airdrop bot incentivizes first-time users bridging assets to Flare, enhancing adoption and easing onboarding challenges.",
      },
      {
        name: "keywords",
        content:
          "Cross-chain asset bridging, Blockchain user onboarding, Crypto token incentive strategies, Decentralized finance (DeFi) integration, Blockchain adoption solutions",
      },
    ],
    title: "Airdrop Bot for Flare",
    tagList: ["Bot", "Airdrop", "Solution", "Integration"],
    description: [
      `Protofire developed an innovative airdrop bot for Flare to address user onboarding challenges. The solution aims to simplify the process for first-time users bridging assets to the Flare network from external chains like Ethereum or XDC.`,
    ],
    // mainImage: airdropBotFlare0,
    // images: [{ alt: "oxLunch0", src: oxLunch0 }],
    about: [
      "Protofire developed an airdrop bot for Flare to tackle the challenge of user onboarding friction caused by differences in native tokens across blockchains. The bot's primary goal is to simplify the process for first-time users by automatically providing a small FLR token airdrop when they bridge assets to Flare, thereby encouraging adoption and easing entry into the Flare ecosystem.",
    ],
    // metrics: [
    //   {
    //     value: "$130.4B",
    //     text: "volume in 0x Protocol in Q1/2022",
    //   },
    //   {
    //     value: "1.2M",
    //     text: "cumulative unique users in 0x Protocol in Q1/2022",
    //   },
    // ],
    additionalContent: [
      {
        title: "The Problem",
        description: [
          "The main challenge was the friction users experienced when bridging value (e.g., WETH) to Flare mainnet and Songbird chains. This issue stemmed from the differences in native tokens across various blockchains.",
        ],
      },
      {
        title: "The Solution",
        description: [
          "Protofire developed an airdrop bot that offers a unique incentive system:",
        ],
        items: [
          "First-time users bridging assets to Flare receive a small airdrop of FLR tokens.",
          "The airdrop is sent to the receiving address on Flare mainnet.",
          "Eligibility is limited to addresses with no prior FLR balance.",
          "Users receive approximately 0.5 FLR along with their bridged value.",
        ],
        descriptionExtra: {
          text: [
            "This automated process encourages adoption by reducing onboarding friction for new users, making it easier to interact with the Flare ecosystem.",
          ],
        },
      },
      {
        title: "Partner Description",
        description: [
          "Flare is an EVM smart contract platform designed for data-intensive blockchain applications, including Machine Learning/AI, RWA tokenization, Gaming, and Social applications. Flare provides developers with secure, decentralized access to high-integrity data from other chains and the internet.",
        ],
      },
    ],
    technologyStack: {
      // description: [
      //   "We leverage the most suitable technologies for each solution to help our customers achieve their business goals more swiftly.",
      // ],
      items: [
        {
          title: "Database",
          items: ["PostgreSQL"],
        },
        {
          title: "Programming Languages",
          items: ["TypeScript"],
        },
        {
          title: "Environment",
          items: ["Node.js"],
        },
      ],
    },
    // codeData: {
    //   items: [
    //     {
    //       title: "flare-airdrop-bot",
    //       link: "https://github.com/protofire/flare-airdrop-bot ",
    //     },
    //   ],
    // },
    // mediaData: {
    //   items: [
    //     {
    //       title:
    //         "Introducing the 0x Launch Kit Launch a relayer in under a minute",
    //       link: "https://blog.0xproject.com/introducing-the-0x-launch-kit-4acdc3453585?gi=177b3c74478b",
    //     },
    //   ],
    // },
    bottomSlogan:
      "Need a bot for your airdrop? Get in touch with us so that we can discuss your ideas.",
    contact: {
      image: juanFaya,
      name: "Juan Faya",
      lnUrl: "https://www.linkedin.com/in/juanmanuelfaya/",
      calendlyCallPostfix: "juan-faya-protofire/30min",
      text: "Schedule a call with our Sales Representative to receive practical recommendations and a prompt proposal for upgrading your solution.",
    },
  },

  //-----------------------------------------------------------------------------

  aethir: {
    metaTitle:
      "Protofire's Staking Solution for Aethir: Boost Your Rewards | Protofire",
    meta: [
      {
        name: "description",
        content:
          "Protofire developed a robust staking solution for Aethir, enabling ATH token holders to earn rewards in gaming and AI ecosystems while enhancing governance participation.",
      },
      {
        name: "keywords",
        content:
          "Blockchain development services, Aethir staking solution, ATH token rewards, Gaming ecosystem, AI ecosystem",
      },
    ],
    title: "Staking Module for Aethir",
    tagList: ["Staking", "Module"],
    description: [
      "The explosive growth of AI, gaming, and cloud computing has exposed the limitations of centralized infrastructure, driving demand for scalable, efficient, and decentralized alternatives. Aethir, a leader in Decentralized Physical Infrastructure Networks (DePIN), is meeting this need by connecting underutilized enterprise-grade GPUs with global users through a blockchain-powered marketplace. However, launching a new token ecosystem presents critical challenges: fostering long-term holding, incentivizing active participation, and building decentralized governance from the ground up.",
      "To address these challenges, Aethir partnered with Protofire to develop a robust staking module. The results were immediate and impressive: within just 90 days of mainnet launch, over $20 million in ATH tokens were staked, governance participation more than doubled from 12% to over 25%, and the number of active stakers surged into the tens of thousands. This flexible staking solution not only increased ATH’s value, but also transformed passive holders into active contributors-laying a solid foundation for Aethir’s decentralized future.",
    ],
    mainImage: aethir1,
    images: [
      { alt: "aethir1", src: aethir1 },
      { alt: "aethir2", src: aethir2 },
    ],
    about: [
      "The Aethir project focuses on creating a robust staking platform for ATH token holders, allowing them to stake their tokens in various pools, including ecosystem, container, and checker pools. Each pool is designed with specific rewards and functionalities that contribute to the overall stability and growth of the ATH ecosystem. The project aims to decrease sell pressure on the ATH token following its Token Generation Event (TGE) and encourages users to hold their tokens while gaining voting power in DAO governance.",
    ],
    // metrics: [
    //   {
    //     value: "$130.4B",
    //     text: "volume in 0x Protocol in Q1/2022",
    //   },
    //   {
    //     value: "1.2M",
    //     text: "cumulative unique users in 0x Protocol in Q1/2022",
    //   },
    // ],
    additionalContent: [
      {
        title: "The Problem",
        description: [
          "After Aethir’s Token Generation Event (TGE), the project encountered two major hurdles:",
        ],
        items: [
          "Sell Pressure on ATH Token: With over 8.48 billion ATH tokens entering circulation, there was a risk of rapid sell-offs, which could destabilize the token’s value and undermine confidence in the ecosystem.",
          "Low Governance Participation: Only about 12% of ATH holders engaged in governance voting, threatening the project’s goal of true decentralization and community-driven development.",
        ],
        descriptionExtra: {
          text: [
            "Aethir needed a mechanism to incentivize holding and active participation, ensuring a sustainable and engaged ecosystem.",
          ],
        },
      },
      {
        title: "The Solution",
        description: [
          "Protofire implemented a staking module based on the ve8020 model developed in collaboration with Balancer, then tailored to meet Aethir’s unique requirements for flexibility, security, and scalability. Drawing inspiration from the proven Balancer 80/20 pool architecture, the solution allows the majority of staked value to remain in ATH tokens while maintaining sufficient liquidity in stable assets. This approach not only reduces impermanent loss for liquidity providers but also creates a more stable environment for token holders, mirroring best practices from leading DeFi protocols.",
          "The staking module is fully compatible with the ERC-20 standard, ensuring seamless integration with existing DeFi infrastructure and enabling future interoperability with other protocols. By leveraging ERC-20 interfaces, users can easily interact with the staking pools, claim rewards, and even utilize liquid staking derivatives for further yield opportunities within the broader DeFi ecosystem.",
          "The solution features multiple staking pools tailored to different user profiles and ecosystem needs:",
        ],
        items: [
          "Ecosystem Pool: Offers a competitive base APR and enhanced governance rights, structured using an 80/20 ATH-to-stablecoin model originally implemented at Balancer. This optimizes both reward distribution and liquidity.",
          "Container Pool: Provides dynamic APRs based on GPU utilization, incentivizing hardware providers and aligning rewards with real network demand.",
          "Checker Pool: Supports node operators with insurance staking and slashing protection, strengthening network reliability.",
        ],
        descriptionExtra: {
          text: [
            "This modular, standards-based approach not only encourages users to lock their tokens and actively participate in governance, but also ensures that the system remains secure, transparent, and adaptable as Aethir’s ecosystem evolves. By combining innovative DeFi mechanics - such as smart contracts built on widely adopted protocols like ERC-20 and the ve8020 model - with a layered architecture that separates settlement, asset management, and user interaction, Protofire’s solution transforms passive ATH holders into active, engaged contributors. This lays the groundwork for a resilient and decentralized future, where security, interoperability, and user trust are maintained as the network grows.",
          ],
        },
      },
      {
        title: "KPIs Influenced",
        description: [
          "The staking solution directly impacts several key metrics:",
        ],
        items: [
          "ATH Tokens Staked: Over $20 million in ATH tokens locked within 90 days of mainnet launch.",
          "Sell Pressure: Significant reduction, as staking offers a compelling alternative to selling.",
          "Governance Participation: Increased from 12% to over 25% of token holders actively voting on proposals.",
          "Community Engagement: Elevated through gamified pools and achievement-based rewards.",
          "Number of Active Stakers: Substantial growth, with tens of thousands of unique addresses participating.",
          "Ecosystem TVL: Expanded rapidly, strengthening network security and stability.",
          "User Retention Rate: Improved, as yield and utility encourage long-term loyalty.",
        ],
      },
      {
        title:
          "Benefits for Projects Implementing Protofire’s Staking Solution",
        description: [
          "Protofire’s staking module, as deployed for Aethir, demonstrates several measurable advantages for projects in decentralized infrastructure, AI, gaming, and similar sectors. By enabling ATH holders to lock tokens for up to nearly four years and offering industry-leading sustainable rewards-currently up to 261% APR for 4-year staking-projects can incentivize long-term holding and reduce token sell pressure. This mechanism has resulted in a constant inflow of tokens into staking pools, directly supporting the stability and daily operations of Aethir’s decentralized GPU cloud.",
          "The integration of liquid staking (stATH) further enhances token utility, allowing stakers to earn additional rewards across partner platforms and increasing engagement within the ecosystem. Weekly reward distribution and the eligibility for future airdrops from AI and gaming partners add further incentives for user retention and ecosystem participation.",
          "For projects adopting a similar model, these features can:",
        ],
        items: [
          "Increase staking participation, which in turn deepens token liquidity, enhances network stability, and strengthens operational security by ensuring a larger portion of the token supply is actively supporting the protocol.",
          "Offer sustainable, above-industry-average rewards (e.g., 195% APR for 3-year, 261% APR for 4-year staking).",
          "Enable flexible staking durations and liquid staking tokens, unlocking further DeFi integrations and cross-platform utility.",
          "Encourage long-term holding, reducing circulating supply and softening post-TGE sell pressure.",
          "Increase user engagement and retention through regular rewards, partner airdrops, and additional earning opportunities.",
        ],
      },
      {
        title: "Partner Description",
        description: [
          "Aethir is a decentralized physical infrastructure network (DePIN) focused on building a distributed GPU cloud network. By connecting underutilized enterprise-grade GPUs with global clients in AI/ML and gaming, Aethir enables high-performance compute distribution through a blockchain-coordinated marketplace. The project gained rapid momentum starting in 2023 and completed key milestones, including its testnet, mainnet, and token launch in 2024. With thousands of nodes sold and active enterprise partnerships, Aethir is redefining the future of decentralized cloud infrastructure.",
        ],
      },
      // {
      //   title: "Partner Description",
      //   description: [
      //     "Aethir is an innovative platform dedicated to integrating blockchain technology within gaming and AI sectors. Aethir aims to create a vibrant ecosystem where users can engage with decentralized applications while earning rewards for their participation.",
      //   ],
      // },
    ],
    technologyStack: {
      // description: [
      //   "We leverage the most suitable technologies for each solution to help our customers achieve their business goals more swiftly.",
      // ],
      items: [
        {
          title: "Programming Languages",
          items: ["Solidity", "Node.js"],
        },
      ],
    },
    // codeData: {
    //   items: [
    //     {
    //       title: "flare-airdrop-bot",
    //       link: "https://github.com/protofire/flare-airdrop-bot ",
    //     },
    //   ],
    // },
    mediaData: {
      items: [
        {
          title: "Aethir Staking",
          link: "https://stake.aethir.com/",
        },
      ],
    },
    bottomSlogan:
      "Looking for a staking solution for your project? Get in touch with us so that we can discuss your ideas.",
    contact: {
      image: juanFaya,
      name: "Juan Faya",
      lnUrl: "https://www.linkedin.com/in/juanmanuelfaya/",
      calendlyCallPostfix: "juan-faya-protofire/30min",
      text: "Schedule a call with our Sales Representative to receive practical recommendations and a prompt proposal for upgrading your solution.",
    },
  },

  //-----------------------------------------------------------------------------

  saga: {
    metaTitle:
      "Protofire Develops Saga Airdrop App for Seamless User Experience | Protofire",
    meta: [
      {
        name: "description",
        content:
          "Protofire created an efficient web app for Saga's airdrop campaign, enhancing user experience during the mainnet launch with integrated features.",
      },
      {
        name: "keywords",
        content:
          "Protofire development services, Saga airdrop web app, User experience enhancement, Mainnet launch support, Web3 applications",
      },
    ],
    title: "Saga Airdrop App",
    tagList: ["Airdrop", "App", "UX", "Solution"],
    description: [
      "Protofire has successfully developed a comprehensive web application for Saga's airdrop campaign, enhancing user experience during the mainnet launch. This project integrates key components such as UX design, web app implementation, and backend access to manage airdrop actions efficiently.",
    ],
    mainImage: sagaAirdrop1,
    images: [{ alt: "sagaAirdrop1", src: sagaAirdrop1 }],
    about: [
      "In the first quarter of 2024, Saga launched its mainnet and initiated an airdrop for users. Protofire was tasked with creating an app that aggregates all airdrop and incentivization components into one seamless application. The goal was to provide a smooth experience for all types of users participating in the airdrop and mainnet launch.",
    ],
    // metrics: [
    //   {
    //     value: "$130.4B",
    //     text: "volume in 0x Protocol in Q1/2022",
    //   },
    //   {
    //     value: "1.2M",
    //     text: "cumulative unique users in 0x Protocol in Q1/2022",
    //   },
    // ],
    additionalContent: [
      {
        title: "The Problem",
        description: [
          "The primary challenge was to consolidate various airdrop components and incentivization features into a single application. This required careful planning and execution to ensure that users could easily navigate the platform and participate in the airdrop without confusion or technical difficulties.",
        ],
      },
      {
        title: "The Solution",
        description: [
          "The collaboration between Protofire and Saga resulted in the successful deployment of a user-friendly application for the airdrop campaign. The app features an intuitive interface that facilitates easy access to airdrop actions, significantly improving user engagement and satisfaction during the mainnet launch.",
        ],
      },
      {
        title: "Partner Description",
        description: [
          "Saga is an innovative Layer 1 protocol that allows developers to create dedicated, parallelized chains that scale with their Web3 application needs. By launching its mainnet and offering an airdrop, Saga aims to engage its community and incentivize participation in its ecosystem.",
        ],
      },
    ],
    technologyStack: {
      // description: [
      //   "We leverage the most suitable technologies for each solution to help our customers achieve their business goals more swiftly.",
      // ],
      items: [
        {
          title: "Frameworks",
          items: ["Node.js", "Express"],
        },
        {
          title: "Libraries/Tools",
          items: ["Cosmjs", "Rainbowkit", "Material-UI", "Axios", "Wagmi"],
        },
        {
          title: "Database",
          items: ["PostgreSQL"],
        },
      ],
    },
    mediaData: {
      items: [
        {
          title: "Airdrop Environment for Saga",
          link: "https://claim.airdrop.saga.xyz",
        },
      ],
    },
    bottomSlogan:
      "Are you looking for an airdrop app for your project? Get in touch with us so that we can discuss your ideas.",
    contact: {
      image: juanFaya,
      name: "Juan Faya",
      lnUrl: "https://www.linkedin.com/in/juanmanuelfaya/",
      calendlyCallPostfix: "juan-faya-protofire/30min",
      text: "Schedule a call with our Sales Representative to receive practical recommendations and a prompt proposal for upgrading your solution.",
    },
  },

  //-----------------------------------------------------------------------------

  balancer: {
    metaTitle:
      "Protofire Develops ve8020 Launchpad for Balancer's Ecosystem Growth | Protofire",
    meta: [
      {
        name: "description",
        content:
          "Protofire's ve8020 Launchpad simplifies veToken launches on Balancer with efficient tokenomics, enhancing DAO participation and reducing sell pressure.",
      },
      {
        name: "keywords",
        content:
          "Protofire development services, ve8020 Launchpad, Balancer ecosystem, DAO participation, Efficient tokenomics",
      },
    ],
    title: "Ve8020 Launchpad for Balancer",
    tagList: ["Launchpad", "Platform", "Solution", "Token"],
    description: [
      "DeFi protocols often struggle to align effective governance with deep, sustainable liquidity. Balancer, recognized as a leading programmable liquidity platform, pioneered the 80/20 pool architecture-where governance tokens are paired with a base asset to maximize capital efficiency and minimize slippage. However, by mid-2023, Balancer identified a critical bottleneck: despite the theoretical advantages of 80/20 pools, adoption of governance-aligned liquidity models remained limited due to fragmented technical implementations and the complexity of deploying secure, customized vote-escrow (ve) systems.",
      "At that time, only 7 projects had successfully launched veToken systems on Balancer, representing just $120 million in TVL - a mere 9% of Balancer’s overall liquidity. This gap highlighted the need for standardized, accessible infrastructure to help protocols unlock the full benefits of Balancer’s advanced pool mechanics.",
      "To address this, Protofire - a blockchain infrastructure specialist - collaborated with Balancer’s core team and community to develop the ve8020 Launchpad: a comprehensive, open-source framework for deploying vote-escrow systems around Balancer’s 80/20 pools. Within nine months of launch, this initiative catalyzed ecosystem growth, enabling 41 veToken deployments (a 486% increase) and driving $730 million in TVL into ve8020 pools by Q1 2024-capturing 86% of Balancer’s governance-aligned liquidity.",
    ],
    mainImage: balancerVe8020_1,
    images: [
      { alt: "balancerVe8020_1", src: balancerVe8020_1 },
      { alt: "balancerVe8020_2", src: balancerVe8020_2 },
    ],
    about: [
      "The ve8020 Launchpad aims to simplify the process for projects to issue veTokens while ensuring a fair and transparent approach for users to participate in decentralized autonomous organizations (DAOs). By leveraging the unique features of Balancer's 80/20 pools, this project enhances user voting power based on their shares in the pools, ultimately decreasing sell pressure for participating projects.",
    ],
    // metrics: [
    //   {
    //     value: "$130.4B",
    //     text: "volume in 0x Protocol in Q1/2022",
    //   },
    //   {
    //     value: "1.2M",
    //     text: "cumulative unique users in 0x Protocol in Q1/2022",
    //   },
    // ],
    additionalContent: [
      {
        title: "The Problem",
        description: [
          "Balancer, as a leading decentralized AMM, faced a recurring challenge: many DeFi projects struggled to balance liquidity provision with effective governance. Traditional staking models required governance tokens to be locked away from liquidity pools, resulting in:",
        ],
        items: [
          "Fragmented Implementations: Early veToken projects relied on custom smart contracts, resulting in higher audit costs, inconsistent security, and protracted deployment timelines (average 17 days per project).",
          "Liquidity-Governance Decoupling: A majority of projects used single-asset staking, locking governance tokens away from liquidity pools. This led to higher slippage, lower trading volume, and underutilized capital efficiency.",
          "Developer Friction: Lack of standardized tooling forced teams to rebuild critical infrastructure (gauge voting, reward distribution, locking interfaces) from scratch, deterring new projects from adopting Balancer’s advanced models.",
        ],
        descriptionExtra: {
          text: [
            "This fragmentation undermined Balancer’s vision of capital-efficient, composable liquidity and limited the adoption of advanced governance models across its ecosystem.",
          ],
        },
      },
      {
        title: "The Solution",
        description: [
          "Protofire’s ve8020 Launchpad was engineered to resolve these pain points by providing a unified, secure, and scalable framework for integrating governance and liquidity on Balancer. The launchpad standardized the deployment of 80/20 pools (80% governance token, 20% paired asset), making it significantly easier for protocols to launch and manage veToken systems.",
        ],
      },
      {
        title: "Key Features and Process",
        items: [
          {
            title: "Technical Implementation Key Points:",
            items: [
              "Ready-to-deploy factory contracts: Standardized smart contracts for 80/20 pools, reducing integration time from an average of 17 days to just 3 days.",
              "SDK and Analytics: A TypeScript SDK and Subgraph integration enabled seamless frontend integration and real-time tracking of over a dozen KPIs.",
              "Security and Audits: The solution underwent three audit cycles with top security partners, addressing critical vulnerabilities before launch.",
            ],
          },
          {
            title: "Ve8020 Model Advantages:",
            items: [
              "Stronger Liquidity: By staking pool tokens instead of just governance tokens, projects make sure that their community’s participation directly boosts the available liquidity for trading. This leads to smoother trades and helps keep token prices stable.",
              "Built-In Stability: Locking tokens in the pool means fewer tokens are available for quick sale, which helps support the token’s price and encourages holders to think long-term.",
              "Streamlined Rewards: Instead of spreading incentives across multiple programs, projects can focus all rewards into one pool. This makes it easier for users to understand how to earn rewards and for teams to manage their incentive programs.",
              "More Ways to Participate: The same pool tokens can be used both for voting on governance decisions and for providing liquidity. This gives users more reasons to get involved and strengthens the project’s community engagement.",
            ],
          },
          {
            title: "Onboarding and Support:",
            items: [
              "Self-service portal: Over 35 projects deployed the ve8020 model independently using Protofire’s documentation and SDK.",
              "White-glove integration: Protofire provided hands-on support for strategic partners, ensuring optimal configuration and launch.",
            ],
          },
        ],
      },
      {
        title: "KPIs Influenced",
        description: [
          "The introduction of the ve8020 Launchpad and supporting tools has already shown a measurable and meaningful impact on the Balancer ecosystem:",
        ],
        items: [
          "Accelerated Deployment: The Protofire and other launchpad proposals are committed to delivering a fully operational ve8020 system-including smart contracts, SDK, and user interface-within two months after approval, plus an additional two weeks for multi-chain deployment. This rapid timeline significantly reduces the historical friction and time-to-market for projects seeking to adopt veToken models;",
          "Cost-Effective Security: Each ve8020 system is built with a factory contract that deploys Voting Escrow and Reward Distributor contracts, which are reviewed through external audits (for example, by Certora) with a typical audit budget of $10,000 per system. These audits use a combination of expert review and advanced automated tools to detect vulnerabilities and mathematically verify that key security properties are satisfied, providing strong confidence that the contracts are secure before launch;",
          "Ecosystem Growth Potential: The ve8020 initiative is expected to attract more projects to Balancer. Proposals estimate that onboarding just a handful of similar projects could bring hundreds of millions in additional TVL to the protocol;",
          "Comprehensive Tooling: The launchpad includes not only smart contracts but also an SDK, subgraph analytics, and a no-code user interface, making it possible for projects to launch governance-aligned liquidity pools without prior coding knowledge. This dramatically broadens the pool of potential ecosystem participants;",
          "Immediate Value Add: The onboarding milestone for the launchpad proposals includes a commitment to onboard at least one new project immediately upon completion, ensuring direct and trackable value to the Balancer ecosystem.",
        ],
      },
      {
        title: "Benefits for Projects Adopting the ve8020 Model",
        items: [
          "Enhanced Liquidity Management:<br/>Projects ensure their governance structure actively contributes to liquidity, resulting in deeper pools and lower slippage.",
          "Token Price Appreciation:<br/>Locking tokens in governance reduces circulating supply, stabilizing or increasing token prices over time.",
          "Simplified Incentive Programs:<br/>Rewards are directed to a single pool, reducing operational complexity and costs.",
          "Customizable Governance Models:<br/>Flexible design allows for tailored lock durations, reward mechanisms, and token ratios.",
          "Increased User Participation:<br/>The dual utility of pool tokens encourages more users to participate in both trading and governance.",
          "Revenue Generation:<br/>Swap fees from integrated pools provide additional revenue streams.",
          "Future-Proof Tokenomics:<br/>As community participation in governance grows, so does the depth and resilience of the liquidity pool - ensuring the protocol remains robust and adaptable as it scales. Unlike traditional staking, where governance participation can reduce available liquidity, the ve8020 approach keeps both aligned and growing together.",
        ],
      },
      {
        title: "Additional Features of Protofire’s Solution",
        items: [
          "Ready-to-deploy factory contracts: Rapid pool creation with standardized security.",
          "SDK for seamless integration: Simplifies frontend and backend development.",
          "Subgraph support for analytics: Real-time tracking of liquidity, governance, and incentives.",
          "User-friendly interface: Streamlined management of ve systems for protocol teams.",
          "Cross-chain compatibility: Deployed on six major networks, including Ethereum, Arbitrum, and Optimism.",
        ],
      },

      {
        title: "Partner Description",
        description: [
          "Balancer is a leading DeFi protocol and AMM built on the Ethereum blockchain, renowned for its flexibility, composability, and innovative liquidity solutions. Unlike traditional AMMs, Balancer enables users to create customizable liquidity pools with up to eight different tokens in any ratio, allowing for advanced portfolio management and dynamic asset allocation. These pools automatically rebalance based on market conditions, optimizing both trading efficiency and capital utilization.",
          "Balancer’s architecture supports a wide range of pool types-including weighted pools, stable pools, and Boosted Pools-which allow idle liquidity to earn additional yield through integrations with external protocols such as Aave and Lido. The platform’s Smart Order Router (SOR v3) ensures efficient trade execution across chains and aggregators, while its suite of SDKs and automation tools empowers developers and DAOs to design custom strategies and manage incentives with minimal friction. ",
        ],
      },
    ],
    technologyStack: {
      // description: [
      //   "We leverage the most suitable technologies for each solution to help our customers achieve their business goals more swiftly.",
      // ],
      items: [
        {
          title: "Languages",
          items: ["React", "TypeScript", "Solidity", "Node.js", "Ethers.js"],
        },
        {
          title: "Libraries/Tools",
          items: ["Material-UI", "Axios"],
        },
        {
          title: "Database",
          items: ["PostgreSQL"],
        },
      ],
    },
    mediaData: {
      items: [
        {
          title: "Protofire Projects: Balancer",
          link: "https://protofire.io/projects/balancer",
        },
        {
          title: "Protofire Blog: Staking Reinvented for Web3 Protocols",
          link: "https://medium.com/protofire-blog/staking-reinvented-for-web3-protocols-c59ea98bbcbd",
        },
      ],
    },
    bottomSlogan:
      "Need to build a launchpad? Get in touch with us so that we can discuss your ideas.",
    contact: {
      image: juanFaya,
      name: "Juan Faya",
      lnUrl: "https://www.linkedin.com/in/juanmanuelfaya/",
      calendlyCallPostfix: "juan-faya-protofire/30min",
      text: "Schedule a call with our Sales Representative to receive practical recommendations and a prompt proposal for upgrading your solution.",
    },
  },

  //-----------------------------------------------------------------------------

  // balancer: {
  //   metaTitle:
  //     "Protofire Develops ve8020 Launchpad for Balancer's Ecosystem Growth | Protofire",
  //   meta: [
  //     {
  //       name: "description",
  //       content:
  //         "Protofire's ve8020 Launchpad simplifies veToken launches on Balancer with efficient tokenomics, enhancing DAO participation and reducing sell pressure.",
  //     },
  //     {
  //       name: "keywords",
  //       content:
  //         "Protofire development services, ve8020 Launchpad, Balancer ecosystem, DAO participation, Efficient tokenomics",
  //     },
  //   ],
  //   title: "Ve8020 Launchpad for Balancer",
  //   tagList: ["Launchpad", "Platform", "Solution", "Token"],
  //   description: [
  //     "The ve8020 Launchpad represents a significant milestone for Balancer, developed by Protofire through a community grant. This innovative platform provides a streamlined solution for projects to launch veTokens using 80/20 Balancer pools, promoting efficient tokenomics and fostering ecosystem growth.",
  //   ],
  //   mainImage: balancerVe8020_1,
  //   images: [
  //     { alt: "balancerVe8020_1", src: balancerVe8020_1 },
  //     { alt: "balancerVe8020_2", src: balancerVe8020_2 },
  //   ],
  //   about: [
  //     "The ve8020 Launchpad aims to simplify the process for projects to issue veTokens while ensuring a fair and transparent approach for users to participate in decentralized autonomous organizations (DAOs). By leveraging the unique features of Balancer's 80/20 pools, this project enhances user voting power based on their shares in the pools, ultimately decreasing sell pressure for participating projects.",
  //   ],
  //   // metrics: [
  //   //   {
  //   //     value: "$130.4B",
  //   //     text: "volume in 0x Protocol in Q1/2022",
  //   //   },
  //   //   {
  //   //     value: "1.2M",
  //   //     text: "cumulative unique users in 0x Protocol in Q1/2022",
  //   //   },
  //   // ],
  //   additionalContent: [
  //     {
  //       title: "The Problem",
  //       description: [
  //         "The primary challenge was to create a straightforward yet equitable mechanism for users to engage in DAOs through voting power derived from their stakes in Balancer pools. Additionally, it was crucial to design a system that mitigates sell pressure for projects launching these pools while rewarding users effectively.",
  //       ],
  //     },
  //     {
  //       title: "The Solution",
  //       description: [
  //         "The successful development of the ve8020 Launchpad has enabled projects within the Balancer ecosystem to launch their veTokens efficiently. The platform not only facilitates user participation in governance but also contributes to the overall stability and growth of the ecosystem by reducing sell pressure on tokens.",
  //       ],
  //     },
  //     {
  //       title: "Partner Description",
  //       description: [
  //         "Balancer is a leading decentralized finance (DeFi) protocol that allows users to create and manage liquidity pools. By supporting innovative projects like the ve8020 Launchpad, Balancer continues to enhance its ecosystem and provide valuable tools for developers and users alike.",
  //       ],
  //     },
  //   ],
  //   technologyStack: {
  //     // description: [
  //     //   "We leverage the most suitable technologies for each solution to help our customers achieve their business goals more swiftly.",
  //     // ],
  //     items: [
  //       {
  //         title: "Languages",
  //         items: ["React", "TypeScript", "Solidity", "Node.js", "Ethers.js"],
  //       },
  //       {
  //         title: "Libraries/Tools",
  //         items: ["Material-UI", "Axios"],
  //       },
  //       {
  //         title: "Database",
  //         items: ["PostgreSQL"],
  //       },
  //     ],
  //   },
  //   mediaData: {
  //     items: [
  //       {
  //         title: "Ve8020 Launchpad",
  //         link: "https://docs.balancer.fi/tools/core/admin-ve8020.html",
  //       },
  //     ],
  //   },
  //   bottomSlogan:
  //     "Need to build a launchpad? Get in touch with us so that we can discuss your ideas.",
  //   contact: {
  //     image: alejandro,
  //     name: "Alejandro Losa",
  //     lnUrl: "https://www.linkedin.com/in/alejandrolosa/",
  //     calendlyCallPostfix: "ale-protofire",
  //     text: "Schedule a call with our Blockchain Solution Architect to receive practical recommendations and a prompt proposal for upgrading your solution.",
  //   },
  // },
};
